(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.PictDocuserve = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],2:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":1}],3:[function(require,module,exports){
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.9"
/*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function () {
    return this
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.empty

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(factory)
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();

},{}],4:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],5:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":4,"fable-serviceproviderbase":2}],6:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],7:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":6,"fable-serviceproviderbase":2}],8:[function(require,module,exports){
/**
 * Simple syntax highlighter for use with CodeJar.
 *
 * Provides basic keyword/string/number/comment highlighting for common languages.
 * Can be replaced with Prism.js or highlight.js for more sophisticated highlighting
 * by passing a custom highlight function to the view options.
 *
 * @module Pict-Code-Highlighter
 */

// Language definition map
const _LanguageDefinitions = (
{
	'javascript':
	{
		// Combined regex to tokenize: comments, strings, template literals, regex, then everything else
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2|(`(?:[^`\\]|\\.)*?`)|(\/(?![/*])(?:\\.|\[(?:\\.|[^\]])*\]|[^/\\\n])+\/[gimsuvy]*)/g,
		keywords: /\b(async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|export|extends|finally|for|from|function|get|if|import|in|instanceof|let|new|of|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/g,
		builtins: /\b(true|false|null|undefined|NaN|Infinity|console|window|document|Math|JSON|Array|Object|String|Number|Boolean|Date|RegExp|Map|Set|Promise|Error|Symbol|parseInt|parseFloat|require|module|exports)\b/g,
		numbers: /\b(\d+\.?\d*(?:e[+-]?\d+)?|0x[0-9a-fA-F]+|0b[01]+|0o[0-7]+)\b/g
	},
	'json':
	{
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:[^"\\]|\\.)*")/g,
		keywords: /\b(true|false|null)\b/g,
		numbers: /-?\b\d+\.?\d*(?:e[+-]?\d+)?\b/g
	},
	'html':
	{
		// Tokenizer captures: (1) comments, (2) strings, (3) tags with attributes
		tokenizer: /(<!--[\s\S]*?-->)|(["'])(?:(?!\2|\\).|\\.)*?\2|(<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>)/g,
		// tagToken group index for identifying tag matches
		tagGroupIndex: 3
	},
	'css':
	{
		tokenizer: /(\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		selectors: /([.#]?[a-zA-Z_][\w-]*(?:\s*[>+~]\s*[.#]?[a-zA-Z_][\w-]*)*)\s*\{/g,
		properties: /\b([a-zA-Z-]+)\s*:/g,
		numbers: /\b(\d+\.?\d*)(px|em|rem|%|vh|vw|s|ms|deg|fr)?\b/g,
		keywords: /\b(important|inherit|initial|unset|none|auto|block|inline|flex|grid)\b/g
	},
	'sql':
	{
		tokenizer: /(--[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		keywords: /\b(SELECT|FROM|WHERE|AND|OR|INSERT|INTO|VALUES|UPDATE|SET|DELETE|CREATE|TABLE|DROP|ALTER|ADD|COLUMN|INDEX|JOIN|LEFT|RIGHT|INNER|OUTER|ON|AS|ORDER|BY|GROUP|HAVING|LIMIT|OFFSET|UNION|ALL|DISTINCT|COUNT|SUM|AVG|MIN|MAX|NOT|NULL|IS|IN|BETWEEN|LIKE|EXISTS|CASE|WHEN|THEN|ELSE|END|PRIMARY|KEY|FOREIGN|REFERENCES|CONSTRAINT|DEFAULT|CHECK|UNIQUE|CASCADE|GRANT|REVOKE|COMMIT|ROLLBACK|BEGIN|TRANSACTION|INT|VARCHAR|DATETIME|AUTO_INCREMENT|CURRENT_TIMESTAMP)\b/gi,
		numbers: /\b\d+\.?\d*\b/g
	}
});

// Alias some common language names
_LanguageDefinitions['js'] = _LanguageDefinitions['javascript'];
_LanguageDefinitions['htm'] = _LanguageDefinitions['html'];

/**
 * Escape HTML special characters to prevent XSS when inserting into innerHTML.
 *
 * @param {string} pString - The string to escape
 * @returns {string} The escaped string
 */
function escapeHTML(pString)
{
	return pString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Highlight a segment of code that is NOT inside a string or comment.
 * This applies keyword, number, and structural highlighting.
 *
 * @param {string} pCode - The code segment to highlight (already HTML-escaped)
 * @param {object} pLanguageDef - The language definition
 * @returns {string} The highlighted HTML
 */
function highlightCodeSegment(pCode, pLanguageDef)
{
	let tmpResult = pCode;

	// CSS selectors
	if (pLanguageDef.selectors)
	{
		pLanguageDef.selectors.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.selectors, '<span class="function-name">$1</span>{');
	}

	// CSS properties
	if (pLanguageDef.properties)
	{
		pLanguageDef.properties.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.properties, '<span class="property">$1</span>:');
	}

	// Keywords
	if (pLanguageDef.keywords)
	{
		pLanguageDef.keywords.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.keywords, '<span class="keyword">$1</span>');
	}

	// Builtins
	if (pLanguageDef.builtins)
	{
		pLanguageDef.builtins.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.builtins, '<span class="keyword">$1</span>');
	}

	// Numbers (CSS numbers may have units as a capture group, others do not)
	if (pLanguageDef.numbers)
	{
		pLanguageDef.numbers.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.numbers, (pMatch) =>
		{
			return `<span class="number">${pMatch}</span>`;
		});
	}

	return tmpResult;
}

/**
 * Highlight an HTML tag token, applying tag name, attribute name, and attribute value colors.
 *
 * The approach: parse the raw tag into structured pieces first, then build the
 * highlighted output from those pieces. This avoids mixing raw text with HTML span
 * tags, which would cause regex replacements to match span attributes on subsequent passes.
 *
 * @param {string} pTag - The raw (unescaped) tag string
 * @returns {string} The highlighted HTML
 */
function highlightHTMLTag(pTag)
{
	let tmpResult = '';
	let tmpRest = pTag;

	// 1. Extract the opening bracket and tag name: < or </  followed by tagname
	let tmpTagNameMatch = tmpRest.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9-]*)/);
	if (!tmpTagNameMatch)
	{
		// Not a recognizable tag, just escape the whole thing
		return escapeHTML(pTag);
	}

	tmpResult += escapeHTML(tmpTagNameMatch[1]);
	tmpResult += '<span class="tag">' + escapeHTML(tmpTagNameMatch[2]) + '</span>';
	tmpRest = tmpRest.substring(tmpTagNameMatch[0].length);

	// 2. Parse attributes from the remaining text (before the closing > or />)
	// Repeatedly match: whitespace + attr-name + optional =value
	let tmpAttrRegex = /^(\s+)([a-zA-Z-]+)(?:(\s*=\s*)(["'])([^"']*?)\4)?/;
	let tmpAttrMatch;

	while ((tmpAttrMatch = tmpRest.match(tmpAttrRegex)) !== null)
	{
		// Whitespace before the attribute
		tmpResult += tmpAttrMatch[1];
		// Attribute name
		tmpResult += '<span class="attr-name">' + escapeHTML(tmpAttrMatch[2]) + '</span>';

		// If there's an = value part
		if (tmpAttrMatch[3])
		{
			tmpResult += escapeHTML(tmpAttrMatch[3]);
			tmpResult += '<span class="attr-value">' + escapeHTML(tmpAttrMatch[4]) + escapeHTML(tmpAttrMatch[5]) + escapeHTML(tmpAttrMatch[4]) + '</span>';
		}

		tmpRest = tmpRest.substring(tmpAttrMatch[0].length);
	}

	// 3. Whatever remains (whitespace, />, >) — escape it all
	tmpResult += escapeHTML(tmpRest);

	return tmpResult;
}

/**
 * Create a highlight function for a given language.
 *
 * The approach: use a single tokenizer regex to split the code into protected tokens
 * (comments, strings) and code segments. Process each segment independently.
 * This avoids placeholder/sentinel issues entirely.
 *
 * @param {string} pLanguage - The language identifier (e.g. "javascript", "json", "html")
 * @returns {function} A function that takes an element and highlights its textContent
 */
function createHighlighter(pLanguage)
{
	return function highlightElement(pElement)
	{
		let tmpCode = pElement.textContent;
		let tmpLanguageName = (typeof (pLanguage) === 'string') ? pLanguage.toLowerCase() : 'javascript';
		let tmpLanguageDef = _LanguageDefinitions[tmpLanguageName];

		if (!tmpLanguageDef)
		{
			// No highlighting rules for this language; just escape and return
			pElement.innerHTML = escapeHTML(tmpCode);
			return;
		}

		if (!tmpLanguageDef.tokenizer)
		{
			// No tokenizer; just escape and apply keyword highlighting
			pElement.innerHTML = highlightCodeSegment(escapeHTML(tmpCode), tmpLanguageDef);
			return;
		}

		// Split the code into tokens using the tokenizer regex.
		// The tokenizer captures comments and strings as groups.
		// We process everything between matches as code.
		let tmpResult = '';
		let tmpLastIndex = 0;
		let tmpTagGroupIndex = tmpLanguageDef.tagGroupIndex || 0;

		tmpLanguageDef.tokenizer.lastIndex = 0;
		let tmpMatch;

		while ((tmpMatch = tmpLanguageDef.tokenizer.exec(tmpCode)) !== null)
		{
			// Add the code segment before this match
			if (tmpMatch.index > tmpLastIndex)
			{
				let tmpSegment = tmpCode.substring(tmpLastIndex, tmpMatch.index);
				tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
			}

			let tmpFullMatch = tmpMatch[0];

			// Determine token type from capture groups
			// Group 1 is always comments, Group 2+ are strings/template literals/regex
			if (tmpMatch[1])
			{
				// Comment
				tmpResult += `<span class="comment">${escapeHTML(tmpFullMatch)}</span>`;
			}
			else if (tmpTagGroupIndex > 0 && tmpMatch[tmpTagGroupIndex])
			{
				// HTML tag — highlight tag name, attributes, and values
				tmpResult += highlightHTMLTag(tmpFullMatch);
			}
			else
			{
				// String, template literal, or regex
				tmpResult += `<span class="string">${escapeHTML(tmpFullMatch)}</span>`;
			}

			tmpLastIndex = tmpLanguageDef.tokenizer.lastIndex;
		}

		// Add any remaining code after the last match
		if (tmpLastIndex < tmpCode.length)
		{
			let tmpSegment = tmpCode.substring(tmpLastIndex);
			tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
		}

		pElement.innerHTML = tmpResult;
	};
}

module.exports = createHighlighter;
module.exports.LanguageDefinitions = _LanguageDefinitions;

},{}],9:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "CodeEditor-Wrap",
	"DefaultDestinationAddress": "#CodeEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "CodeEditor-Container",
			"Template": "<!-- CodeEditor-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "CodeEditor-Wrap",
			"TemplateHash": "CodeEditor-Container",
			"DestinationAddress": "#CodeEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#CodeEditor-Container-Div",

	// Address in AppData or other Pict address space to read/write code content
	"CodeDataAddress": false,

	// The language for syntax highlighting (e.g. "javascript", "html", "css", "json")
	"Language": "javascript",

	// Whether the editor is read-only
	"ReadOnly": false,

	// Tab character: use tab or spaces
	"Tab": "\t",

	// Whether to indent with the same whitespace as the previous line
	"IndentOn": /[({[]$/,

	// Whether to add a closing bracket/paren/brace
	"MoveToNewLine": /^[)}\]]/,

	// Whether to handle the closing character
	"AddClosing": true,

	// Whether to preserve indentation on new lines
	"CatchTab": true,

	// Whether to show line numbers
	"LineNumbers": true,

	// Default code content if no address is provided
	"DefaultCode": "// Enter your code here\n",

	// CSS for the code editor.
	//
	// Every color/font is wired through pict-provider-theme tokens so apps
	// using pict-provider-theme get themed code editor automatically.  Each
	// var() carries its original ATOM-One-Light hex as the fallback so apps
	// without pict-provider-theme installed look exactly as before.
	"CSS": `.pict-code-editor-wrap
{
	display: flex;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.5;
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
}
.pict-code-editor-wrap .pict-code-line-numbers
{
	width: 40px;
	min-width: 40px;
	padding: 10px 0;
	text-align: right;
	background: var(--theme-color-background-secondary, #F5F5F5);
	border-right: 1px solid var(--theme-color-border-default, #D0D0D0);
	color: var(--theme-color-text-muted, #999);
	font-size: 13px;
	line-height: 1.5;
	user-select: none;
	pointer-events: none;
	box-sizing: border-box;
}
.pict-code-editor-wrap .pict-code-line-numbers span
{
	display: block;
	padding: 0 8px 0 0;
}
.pict-code-editor-wrap .pict-code-editor
{
	margin: 0;
	padding: 10px 10px 10px 8px;
	min-height: 100px;
	flex: 1;
	min-width: 0;
	outline: none;
	tab-size: 4;
	white-space: pre;
	overflow-wrap: normal;
	color: var(--theme-color-text-primary, #383A42);
	background: var(--theme-color-background-panel, #FAFAFA);
	caret-color: var(--theme-color-brand-primary, #526FFF);
	border-radius: 0 4px 4px 0;
}
.pict-code-editor-wrap .pict-code-editor.pict-code-no-line-numbers
{
	padding-left: 10px;
	border-radius: 4px;
}
/* Syntax token colors — each class binds to a Color.Syntax.* token from
   pict-provider-theme. Fallback hexes match the One Light palette so apps
   that don't install the theme provider look the same as before. */
.pict-code-editor-wrap .pict-code-editor .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
.pict-code-editor-wrap .pict-code-editor .string        { color: var(--theme-color-syntax-string,      #50A14F); }
.pict-code-editor-wrap .pict-code-editor .number        { color: var(--theme-color-syntax-number,      #986801); }
.pict-code-editor-wrap .pict-code-editor .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
.pict-code-editor-wrap .pict-code-editor .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
.pict-code-editor-wrap .pict-code-editor .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
.pict-code-editor-wrap .pict-code-editor .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
.pict-code-editor-wrap .pict-code-editor .property      { color: var(--theme-color-syntax-property,    #E45649); }
.pict-code-editor-wrap .pict-code-editor .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
.pict-code-editor-wrap .pict-code-editor .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
.pict-code-editor-wrap .pict-code-editor .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
.pict-code-editor-wrap .pict-code-editor .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
.pict-code-editor-wrap .pict-code-editor .type          { color: var(--theme-color-syntax-type,        #C18401); }
.pict-code-editor-wrap .pict-code-editor .variable      { color: var(--theme-color-syntax-variable,    #383A42); }

/* highlight.js class aliases — when host apps render code blocks with
   highlight.js (e.g. markdown previews via CodeJar's hljs integration),
   the output uses .hljs / .hljs-* classes rather than the bare token
   classes pict-section-code emits. Mapping them here lets one stylesheet
   theme both editor surfaces (bare classes) and hljs-rendered surfaces
   without the host needing a separate per-app github.css. Rules are
   intentionally unscoped (no .pict-code-editor-wrap parent) so they
   apply globally wherever hljs paints. */
.hljs                  { color: var(--theme-color-text-primary,         #383A42); background: transparent; }
.hljs-keyword,
.hljs-keyword.hljs-typeof,
.hljs-selector-tag,
.hljs-literal          { color: var(--theme-color-syntax-keyword,       #A626A4); }
.hljs-string,
.hljs-regexp,
.hljs-template-tag,
.hljs-template-variable { color: var(--theme-color-syntax-string,       #50A14F); }
.hljs-number,
.hljs-meta             { color: var(--theme-color-syntax-number,        #986801); }
.hljs-comment,
.hljs-quote            { color: var(--theme-color-syntax-comment,       #A0A1A7); font-style: italic; }
.hljs-operator,
.hljs-link             { color: var(--theme-color-syntax-operator,      #0184BC); }
.hljs-punctuation      { color: var(--theme-color-syntax-punctuation,   #383A42); }
.hljs-function .hljs-title,
.hljs-title.function_,
.hljs-title.class_     { color: var(--theme-color-syntax-function,      #4078F2); }
.hljs-variable,
.hljs-variable.language_,
.hljs-params           { color: var(--theme-color-syntax-variable,      #383A42); }
.hljs-type,
.hljs-class .hljs-title { color: var(--theme-color-syntax-type,         #C18401); }
.hljs-built_in,
.hljs-builtin-name     { color: var(--theme-color-syntax-builtin,       #986801); }
.hljs-attr,
.hljs-property         { color: var(--theme-color-syntax-property,      #E45649); }
.hljs-tag,
.hljs-name             { color: var(--theme-color-syntax-tag,           #E45649); }
.hljs-attribute        { color: var(--theme-color-syntax-attrname,      #986801); }
.hljs-symbol           { color: var(--theme-color-syntax-attrvalue,     #50A14F); }
.hljs-emphasis         { font-style: italic; }
.hljs-strong           { font-weight: bold; }
.hljs-deletion         { color: var(--theme-color-status-error,         #B62828); background: rgba(220, 50, 47, 0.08); }
.hljs-addition         { color: var(--theme-color-status-success,       #2E7A3A); background: rgba(80, 161, 79, 0.10); }
`
});

},{}],10:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libCreateHighlighter = require('./Pict-Code-Highlighter.js');
const _DefaultConfiguration = require('./Pict-Section-Code-DefaultConfiguration.js');

class PictSectionCode extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// The CodeJar instance
		this.codeJar = null;

		// The highlight function (can be overridden)
		this._highlightFunction = null;

		// The current language
		this._language = this.options.Language || 'javascript';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._codeJarPrototype = null;
		this.targetElement = false;

		// Build the default highlight function for the configured language
		this._highlightFunction = libCreateHighlighter(this._language);

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeJar prototype.  If not passed explicitly, try to find it
	 * as a global (window.CodeJar) or require it from the npm package.
	 *
	 * @param {function} [pCodeJarPrototype] - The CodeJar constructor function
	 * @returns {boolean|void}
	 */
	connectCodeJarPrototype(pCodeJarPrototype)
	{
		if (typeof (pCodeJarPrototype) === 'function')
		{
			this._codeJarPrototype = pCodeJarPrototype;
			return;
		}

		// Try to find CodeJar in global scope
		if (typeof (window) !== 'undefined')
		{
			if (typeof (window.CodeJar) === 'function')
			{
				this.log.trace(`PICT-Code Found CodeJar in window.CodeJar.`);
				this._codeJarPrototype = window.CodeJar;
				return;
			}
		}

		this.log.error(`PICT-Code No CodeJar prototype found. Include codejar via script tag or call connectCodeJarPrototype(CodeJar) explicitly.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve the CodeJar prototype if not already set
		if (!this._codeJarPrototype)
		{
			this.connectCodeJarPrototype();
		}

		if (!this._codeJarPrototype)
		{
			this.log.error(`PICT-Code Cannot initialize editor; no CodeJar prototype available.`);
			return false;
		}

		if (this.codeJar)
		{
			this.log.error(`PICT-Code editor is already initialized!`);
			return false;
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-Code Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Build the editor DOM structure
		this._buildEditorDOM();

		// Get initial code content
		let tmpCode = this._resolveCodeContent();

		// Create the CodeJar options
		let tmpCodeJarOptions = {};
		if (this.options.Tab)
		{
			tmpCodeJarOptions.tab = this.options.Tab;
		}
		if (this.options.IndentOn)
		{
			tmpCodeJarOptions.indentOn = this.options.IndentOn;
		}
		if (this.options.MoveToNewLine)
		{
			tmpCodeJarOptions.moveToNewLine = this.options.MoveToNewLine;
		}
		if (typeof (this.options.AddClosing) !== 'undefined')
		{
			tmpCodeJarOptions.addClosing = this.options.AddClosing;
		}
		if (typeof (this.options.CatchTab) !== 'undefined')
		{
			tmpCodeJarOptions.catchTab = this.options.CatchTab;
		}

		this.customConfigureEditorOptions(tmpCodeJarOptions);

		// Instantiate CodeJar on the editor element
		let tmpEditorElement = this._editorElement;
		this.codeJar = this._codeJarPrototype(tmpEditorElement, this._highlightFunction, tmpCodeJarOptions);

		// CodeJar forces white-space:pre-wrap and overflow-wrap:break-word
		// via inline styles, which causes line wrapping that breaks the
		// line-number alignment.  Override back to non-wrapping so the
		// wrap container scrolls horizontally instead.
		this._resetEditorWrapStyles();

		// Set the initial code
		if (tmpCode)
		{
			this.codeJar.updateCode(tmpCode);
		}

		// Wire up the change handler
		this.codeJar.onUpdate((pCode) =>
		{
			this._updateLineNumbers();
			this.onCodeChange(pCode);
		});

		// Initial line number render
		this._updateLineNumbers();

		// Handle read-only
		if (this.options.ReadOnly)
		{
			tmpEditorElement.setAttribute('contenteditable', 'false');
		}
	}

	/**
	 * Build the editor DOM elements inside the target container.
	 */
	_buildEditorDOM()
	{
		// Clear the target
		this.targetElement.innerHTML = '';

		// Create wrapper
		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-code-editor-wrap';

		// Create line numbers container
		if (this.options.LineNumbers)
		{
			let tmpLineNumbers = document.createElement('div');
			tmpLineNumbers.className = 'pict-code-line-numbers';
			tmpWrap.appendChild(tmpLineNumbers);
			this._lineNumbersElement = tmpLineNumbers;
		}

		// Create the editor element (CodeJar needs a pre or div)
		let tmpEditor = document.createElement('div');
		tmpEditor.className = 'pict-code-editor language-' + this._language;
		if (!this.options.LineNumbers)
		{
			tmpEditor.className += ' pict-code-no-line-numbers';
		}
		tmpWrap.appendChild(tmpEditor);

		this.targetElement.appendChild(tmpWrap);
		this._editorElement = tmpEditor;
		this._wrapElement = tmpWrap;
	}

	/**
	 * Update the line numbers display based on current code content.
	 */
	_updateLineNumbers()
	{
		if (!this.options.LineNumbers || !this._lineNumbersElement || !this._editorElement)
		{
			return;
		}

		let tmpCode = this._editorElement.textContent || '';
		let tmpLineCount = tmpCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += `<span>${i}</span>`;
		}

		this._lineNumbersElement.innerHTML = tmpHTML;
	}

	/**
	 * Reset inline styles that CodeJar sets on the editor element.
	 *
	 * CodeJar forces white-space:pre-wrap and overflow-wrap:break-word so
	 * long lines wrap visually.  That breaks line-number alignment because
	 * each wrapped visual row is not a logical line.  Resetting to pre /
	 * normal makes the outer .pict-code-editor-wrap scroll horizontally.
	 */
	_resetEditorWrapStyles()
	{
		if (!this._editorElement)
		{
			return;
		}
		this._editorElement.style.whiteSpace = 'pre';
		this._editorElement.style.overflowWrap = 'normal';
	}

	/**
	 * Resolve the initial code content from address or default.
	 *
	 * @returns {string} The code content
	 */
	_resolveCodeContent()
	{
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.CodeDataAddress);
			if (typeof (tmpAddressedData) === 'string')
			{
				return tmpAddressedData;
			}
			else
			{
				this.log.warn(`PICT-Code Address [${this.options.CodeDataAddress}] did not return a string; it was ${typeof (tmpAddressedData)}.`);
			}
		}

		return this.options.DefaultCode || '';
	}

	/**
	 * Hook for subclasses to customize CodeJar options before instantiation.
	 *
	 * @param {object} pOptions - The CodeJar options object to modify
	 */
	customConfigureEditorOptions(pOptions)
	{
		// Override in subclass to tweak options
	}

	/**
	 * Called when the code content changes.  Override in subclasses to handle changes.
	 *
	 * @param {string} pCode - The new code content
	 */
	onCodeChange(pCode)
	{
		// Write back to data address if configured
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.CodeDataAddress, pCode);
		}
	}

	// -- Public API Methods --

	/**
	 * Get the current code content.
	 *
	 * @returns {string} The current code
	 */
	getCode()
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code getCode called before editor initialized.');
			return '';
		}
		return this.codeJar.toString();
	}

	/**
	 * Set the code content.
	 *
	 * @param {string} pCode - The code to set
	 */
	setCode(pCode)
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code setCode called before editor initialized.');
			return;
		}
		this.codeJar.updateCode(pCode);
		this._updateLineNumbers();
	}

	/**
	 * Change the editor language and re-highlight.
	 *
	 * @param {string} pLanguage - The language identifier
	 */
	setLanguage(pLanguage)
	{
		this._language = pLanguage;
		this._highlightFunction = libCreateHighlighter(pLanguage);

		if (this._editorElement)
		{
			// Update the class
			this._editorElement.className = 'pict-code-editor language-' + pLanguage;
			if (!this.options.LineNumbers)
			{
				this._editorElement.className += ' pict-code-no-line-numbers';
			}
		}

		if (this.codeJar)
		{
			// Re-create the editor with the new highlight function
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set a custom highlight function to replace the built-in highlighter.
	 * Useful for integrating Prism.js, highlight.js, or any other library.
	 *
	 * @param {function} pHighlightFunction - A function that takes a DOM element and highlights its textContent
	 */
	setHighlightFunction(pHighlightFunction)
	{
		if (typeof (pHighlightFunction) !== 'function')
		{
			this.log.error('PICT-Code setHighlightFunction requires a function.');
			return;
		}
		this._highlightFunction = pHighlightFunction;

		if (this.codeJar)
		{
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set the read-only state of the editor.
	 *
	 * @param {boolean} pReadOnly - Whether the editor should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this._editorElement)
		{
			this._editorElement.setAttribute('contenteditable', pReadOnly ? 'false' : 'true');
		}
	}

	/**
	 * Destroy the editor and clean up.
	 */
	destroy()
	{
		if (this.codeJar)
		{
			this.codeJar.destroy();
			this.codeJar = null;
		}
	}

	/**
	 * Marshal code content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			let tmpCode = this._resolveCodeContent();
			if (typeof (tmpCode) === 'string')
			{
				this.codeJar.updateCode(tmpCode);
				this._updateLineNumbers();
			}
		}
	}

	/**
	 * Marshal the current code content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			this.onCodeChange(this.codeJar.toString());
		}
	}
}

module.exports = PictSectionCode;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.createHighlighter = libCreateHighlighter;

},{"./Pict-Code-Highlighter.js":8,"./Pict-Section-Code-DefaultConfiguration.js":9,"pict-view":68}],11:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

},{"./providers/Pict-Provider-Content.js":12,"./views/Pict-View-Content.js":13}],12:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. Passed through to parseInline() for vocabulary term auto-linking.
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver, pVocabularyResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. When provided, known vocabulary terms in the rendered text are wrapped in <span class="pict-vocab-term"> with data attributes carrying the popover content.
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		tmpResult = tmpResult.replace(/__([^_]+)__/g, '<strong>$1</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		tmpResult = tmpResult.replace(/_([^_]+)_/g, '<em>$1</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		// Vocabulary term auto-linking: scan the rendered text for
		// known vocabulary terms and wrap each first occurrence in a
		// span with data attributes for the popover system. Skips
		// content inside <code>, <a>, <pre>, and <strong> tags to
		// avoid mangling links, code, or already-emphasized text.
		if (typeof pVocabularyResolver === 'function')
		{
			tmpResult = this._applyVocabularyLinks(tmpResult, pVocabularyResolver);
		}

		return tmpResult;
	}

	/**
	 * Scan HTML for vocabulary terms and wrap the first occurrence
	 * of each in a <span class="pict-vocab-term"> element. The
	 * resolver callback is called for each candidate word/phrase
	 * and returns { slug, title, short } if it's a known term.
	 *
	 * Skips content inside HTML tags to avoid breaking links,
	 * code spans, and other markup.
	 *
	 * @param {string} pHTML
	 * @param {Function} pResolver - (word) => {slug, title, short} | null
	 * @returns {string}
	 */
	_applyVocabularyLinks(pHTML, pResolver)
	{
		if (!pHTML || typeof pResolver !== 'function')
		{
			return pHTML;
		}

		// Track which terms we've already linked to avoid duplicate
		// links for the same term appearing multiple times.
		let tmpLinked = {};

		// Split the HTML into segments: tags vs text nodes. We only
		// scan text nodes for vocabulary terms; tags pass through.
		// This regex captures HTML tags as separators.
		let tmpParts = pHTML.split(/(<[^>]+>)/g);

		// Track whether we're inside a tag that should be skipped
		let tmpSkipDepth = 0;
		let tmpSkipTags = ['code', 'a', 'pre', 'span'];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];

			// Check if this is an HTML tag
			if (tmpPart.charAt(0) === '<')
			{
				// Opening tag?
				let tmpOpenMatch = tmpPart.match(/^<(\w+)/);
				if (tmpOpenMatch && tmpSkipTags.indexOf(tmpOpenMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth++;
				}
				// Closing tag?
				let tmpCloseMatch = tmpPart.match(/^<\/(\w+)/);
				if (tmpCloseMatch && tmpSkipTags.indexOf(tmpCloseMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth = Math.max(0, tmpSkipDepth - 1);
				}
				continue; // Don't modify tags
			}

			// Skip text inside protected elements
			if (tmpSkipDepth > 0) continue;

			// Scan this text node for vocabulary terms. Use word
			// boundary regex to match whole words only.
			tmpParts[i] = tmpPart.replace(/\b([A-Za-z][A-Za-z0-9_-]{1,30})\b/g, (pMatch, pWord) =>
			{
				// Skip very short words and common English words
				if (pWord.length < 3) return pMatch;

				let tmpLower = pWord.toLowerCase();
				if (tmpLinked[tmpLower]) return pMatch; // already linked

				let tmpResult = pResolver(tmpLower);
				if (!tmpResult) return pMatch;

				tmpLinked[tmpLower] = true;
				let tmpShortEsc = (tmpResult.short || '').replace(/"/g, '&quot;');
				return '<span class="pict-vocab-term" data-vocab-slug="' + tmpResult.slug +
					'" data-vocab-title="' + (tmpResult.title || '').replace(/"/g, '&quot;') +
					'" data-vocab-short="' + tmpShortEsc + '">' + pMatch + '</span>';
			});
		}

		return tmpParts.join('');
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"pict-provider":7,"pict-section-code":10}],13:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		.pict-content pre {
			background: var(--theme-color-text-primary, #3D3229);
			color: var(--theme-color-text-on-brand, #E8E0D4);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
		}
		.pict-content code {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: var(--theme-color-brand-accent, #9E6B47);
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
			font-size: 14px;
			line-height: 1.5;
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background: var(--theme-color-background-tertiary, #342A22);
			border-right: 1px solid var(--theme-color-border-default, #4A3F35);
			color: var(--theme-color-text-muted, #8A7F72);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--theme-color-text-primary, #3D3229);
			color: var(--theme-color-text-on-brand, #E8E0D4);
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		.pict-content-code-wrap .keyword       { color: var(--theme-color-brand-primary,  #C678DD); }
		.pict-content-code-wrap .string        { color: var(--theme-color-status-success, #98C379); }
		.pict-content-code-wrap .number        { color: var(--theme-color-brand-accent,   #D19A66); }
		.pict-content-code-wrap .comment       { color: var(--theme-color-text-muted,     #7F848E); font-style: italic; }
		.pict-content-code-wrap .operator      { color: var(--theme-color-status-info,    #56B6C2); }
		.pict-content-code-wrap .punctuation   { color: var(--theme-color-text-on-brand,  #E8E0D4); }
		.pict-content-code-wrap .function-name { color: var(--theme-color-brand-primary,  #61AFEF); }
		.pict-content-code-wrap .property      { color: var(--theme-color-status-error,   #E06C75); }
		.pict-content-code-wrap .tag           { color: var(--theme-color-status-error,   #E06C75); }
		.pict-content-code-wrap .attr-name     { color: var(--theme-color-brand-accent,   #D19A66); }
		.pict-content-code-wrap .attr-value    { color: var(--theme-color-status-success, #98C379); }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.8em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
		}
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-muted, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: var(--theme-color-status-error, #B23A3A);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-status-error, #B23A3A);
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--theme-color-text-primary, #2A241E);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-primary, #1A1612);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--theme-color-text-muted, #5E5549);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--theme-color-border-light, #EAE3D8);
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 16px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`,

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Tag images and code blocks immediately so they're clickable.
		// Mermaid blocks are tagged after mermaid.run() resolves (see below).
		this.enableFullscreenViewers(tmpContainerID, { skipMermaid: true });

		// Post-render: initialize Mermaid diagrams if mermaid is available.
		// Once mermaid finishes, retag so the rendered SVGs are also clickable.
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Initialize Mermaid with theme variables read from the active
	 * pict-provider-theme palette. Mermaid's `base` theme honors
	 * `themeVariables`, so the diagram colors (node fills, cluster
	 * backgrounds, edges, labels) follow whatever theme is applied.
	 *
	 * Idempotent and cheap. Called lazily before the first
	 * `mermaid.run()` and again from the onApply subscription when
	 * the user switches themes.
	 */
	_initializeMermaidTheme()
	{
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return; }
		let tmpCs = getComputedStyle(document.documentElement);
		let tmpVar = (pName, pFallback) =>
		{
			let tmpVal = (tmpCs.getPropertyValue(pName) || '').trim();
			return tmpVal || pFallback;
		};
		// Read every token Mermaid 'base' actually consumes. Falling
		// back to the retold-content-system warm-beige hexes keeps the
		// diagram readable even if the theme provider isn't installed.
		try
		{
			mermaid.initialize(
			{
				startOnLoad: false,
				theme: 'base',
				securityLevel: 'loose',
				themeVariables:
				{
					// Primary surfaces (node fills + cluster background)
					primaryColor:        tmpVar('--theme-color-background-panel',    '#FAF8F4'),
					primaryTextColor:    tmpVar('--theme-color-text-primary',       '#3D3229'),
					primaryBorderColor:  tmpVar('--theme-color-brand-primary',      '#2E7D74'),
					// Secondary (alt rows, alternate nodes, sequence actor bg)
					secondaryColor:      tmpVar('--theme-color-background-secondary', '#F0EDE8'),
					secondaryTextColor:  tmpVar('--theme-color-text-secondary',     '#5E5549'),
					secondaryBorderColor:tmpVar('--theme-color-border-default',     '#DDD6CA'),
					// Tertiary (clusters, accent groups)
					tertiaryColor:       tmpVar('--theme-color-background-tertiary',  '#EDE9E3'),
					tertiaryTextColor:   tmpVar('--theme-color-text-secondary',     '#5E5549'),
					tertiaryBorderColor: tmpVar('--theme-color-border-light',       '#E8E2D7'),
					// Page-level + line + note
					background:          tmpVar('--theme-color-background-panel',    '#FAF8F4'),
					mainBkg:             tmpVar('--theme-color-background-panel',    '#FAF8F4'),
					secondBkg:           tmpVar('--theme-color-background-secondary', '#F0EDE8'),
					lineColor:           tmpVar('--theme-color-text-secondary',     '#5E5549'),
					textColor:           tmpVar('--theme-color-text-primary',       '#3D3229'),
					noteBkgColor:        tmpVar('--theme-color-background-tertiary',  '#EDE9E3'),
					noteTextColor:       tmpVar('--theme-color-text-primary',       '#3D3229'),
					noteBorderColor:     tmpVar('--theme-color-border-default',     '#DDD6CA'),
					// Status (Mermaid uses these for error/warning highlights)
					errorBkgColor:       tmpVar('--theme-color-status-error',       '#D9534F'),
					errorTextColor:      tmpVar('--theme-color-text-on-brand',     '#FFFFFF'),
					// Typography
					fontFamily:          tmpVar('--theme-typography-family-sans', 'inherit')
				}
			});
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid theme init failed: ' + pError.message); }
		}
	}

	/**
	 * Subscribe to pict-provider-theme apply events so Mermaid diagrams
	 * re-render with the new palette on theme change. Idempotent — safe
	 * to call multiple times. Falls through silently when the provider
	 * isn't installed (apps using pict-section-content without
	 * pict-provider-theme still get the static base theme).
	 */
	_subscribeToThemeChanges()
	{
		if (this._mermaidThemeSubscribed) { return; }
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') { return; }
		let tmpSelf = this;
		tmpProvider.onApply(function ()
		{
			tmpSelf._initializeMermaidTheme();
			tmpSelf._refreshMermaidDiagrams();
		});
		this._mermaidThemeSubscribed = true;
	}

	/**
	 * Re-render every Mermaid diagram on the page using its cached
	 * source. Called after a theme change so the new themeVariables
	 * take effect on already-displayed diagrams.
	 *
	 * Mermaid replaces `pre.mermaid`'s textContent with the rendered
	 * SVG during `mermaid.run()`. To re-render we need the original
	 * source, which `renderMermaidDiagrams` stashes on each element
	 * as `data-mermaid-source` BEFORE running. This method restores
	 * that source, drops the `data-processed` flag, and re-runs.
	 */
	_refreshMermaidDiagrams()
	{
		if (typeof mermaid === 'undefined' || typeof document === 'undefined') { return; }
		let tmpRendered = document.querySelectorAll('pre.mermaid[data-mermaid-source]');
		if (tmpRendered.length < 1) { return; }
		for (let i = 0; i < tmpRendered.length; i++)
		{
			let tmpEl = tmpRendered[i];
			tmpEl.textContent = tmpEl.getAttribute('data-mermaid-source');
			tmpEl.removeAttribute('data-processed');
			tmpEl.classList.remove('mermaid-rendered');
		}
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpRendered });
			if (tmpResult && typeof tmpResult.catch === 'function')
			{
				tmpResult.catch((pError) =>
				{
					if (this.log && this.log.warn) { this.log.warn('Mermaid re-render failed: ' + (pError && pError.message ? pError.message : pError)); }
				});
			}
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid re-render failed: ' + pError.message); }
		}
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: apply theme variables and subscribe to
		// theme apply events so diagrams re-render on theme change.
		this._initializeMermaidTheme();
		this._subscribeToThemeChanges();

		// Cache each diagram's source on the element so theme-change
		// re-renders can restore it. Mermaid replaces textContent with
		// the rendered SVG during run(), so we lose the source unless
		// we stash it here first.
		for (let i = 0; i < tmpMermaidElements.length; i++)
		{
			let tmpEl = tmpMermaidElements[i];
			if (!tmpEl.hasAttribute('data-mermaid-source'))
			{
				tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
			}
		}

		// mermaid.run() will process all pre.mermaid elements in the container.
		// It returns a promise; once it resolves the inner SVG exists and we
		// can tag the diagrams as fullscreen-clickable.
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(() =>
				{
					this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
				}).catch((pError) =>
				{
					this.log.error('Mermaid rendering error: ' + (pError && pError.message ? pError.message : pError));
				});
			}
			else
			{
				// Synchronous fallback (older mermaid)
				this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
			}
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Walk the freshly-rendered content and tag images, mermaid diagrams,
	 * and fenced code blocks so they're click-to-fullscreen.  Also installs
	 * a single delegated click listener on the container the first time it
	 * is called for that container.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 * @param {Object} [pOptions] - { skipMermaid: bool, onlyMermaid: bool }
	 */
	enableFullscreenViewers(pContainerID, pOptions)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}
		let tmpOptions = pOptions || {};

		if (!tmpOptions.onlyMermaid)
		{
			// Images
			let tmpImages = tmpContentBody.querySelectorAll('img:not([data-fullscreen-source])');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpImg = tmpImages[i];
				tmpImg.setAttribute('data-fullscreen-source', 'image');
				let tmpAlt = tmpImg.getAttribute('alt');
				if (!tmpAlt)
				{
					let tmpSrc = tmpImg.getAttribute('src') || '';
					tmpAlt = tmpSrc.split('/').pop().split('?')[0] || 'Image';
				}
				tmpImg.setAttribute('data-fullscreen-title', tmpAlt);
			}

			// Code wraps (fenced blocks): do NOT tag for click-to-fullscreen —
			// that would conflict with text selection for copy/paste.
			// Instead wrap each in a container with hover-revealed action
			// buttons (fullscreen + copy) floating to the right.
			let tmpCodeWraps = tmpContentBody.querySelectorAll('.pict-content-code-wrap:not([data-code-actions-wired])');
			for (let i = 0; i < tmpCodeWraps.length; i++)
			{
				this._wireCodeActions(tmpCodeWraps[i]);
			}
		}

		if (!tmpOptions.skipMermaid)
		{
			// Mermaid diagrams (after mermaid.run() has replaced the inner pre)
			let tmpMermaid = tmpContentBody.querySelectorAll('pre.mermaid:not([data-fullscreen-source])');
			for (let i = 0; i < tmpMermaid.length; i++)
			{
				let tmpPre = tmpMermaid[i];
				// Only tag once mermaid has actually rendered an svg into it
				if (tmpPre.querySelector('svg'))
				{
					tmpPre.setAttribute('data-fullscreen-source', 'mermaid');
					tmpPre.setAttribute('data-fullscreen-title', 'Mermaid Diagram');
				}
			}
		}

		// Install delegated click listener once per container.
		if (!tmpContentBody.__pictFullscreenWired)
		{
			tmpContentBody.__pictFullscreenWired = true;
			tmpContentBody.addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				while (tmpTarget && tmpTarget !== tmpContentBody && !tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					tmpTarget = tmpTarget.parentElement;
				}
				if (tmpTarget && tmpTarget !== tmpContentBody && tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					pEvent.preventDefault();
					this._openFullscreen(tmpTarget);
				}
			});
		}
	}

	/**
	 * Wrap a fenced code block in a container that holds the existing
	 * .pict-content-code-wrap plus a hover-revealed action column with
	 * fullscreen + copy buttons.  The action column is sticky-positioned
	 * so it follows the page scroll while the user is alongside a long
	 * code block.
	 *
	 * @param {HTMLElement} pCodeWrap - The .pict-content-code-wrap element
	 */
	_wireCodeActions(pCodeWrap)
	{
		if (!pCodeWrap || pCodeWrap.hasAttribute('data-code-actions-wired'))
		{
			return;
		}
		pCodeWrap.setAttribute('data-code-actions-wired', 'true');

		// Determine the fullscreen title from the language tag, if any.
		let tmpCodeEl = pCodeWrap.querySelector('code[class*="language-"]');
		let tmpLang = 'Code';
		if (tmpCodeEl)
		{
			let tmpMatch = (tmpCodeEl.getAttribute('class') || '').match(/language-(\S+)/);
			if (tmpMatch)
			{
				tmpLang = tmpMatch[1] + ' code';
			}
		}
		pCodeWrap.setAttribute('data-code-language', tmpLang);

		// Build the wrapping container.
		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-content-code-container';

		let tmpActions = document.createElement('div');
		tmpActions.className = 'pict-content-code-actions';
		tmpActions.setAttribute('aria-hidden', 'false');

		let tmpFullscreenBtn = document.createElement('button');
		tmpFullscreenBtn.type = 'button';
		tmpFullscreenBtn.className = 'pict-content-code-action-btn';
		tmpFullscreenBtn.setAttribute('aria-label', 'Open code in fullscreen');
		tmpFullscreenBtn.setAttribute('title', 'Open in fullscreen');
		tmpFullscreenBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><polyline points="3 6 3 3 6 3"></polyline><polyline points="13 6 13 3 10 3"></polyline><polyline points="3 10 3 13 6 13"></polyline><polyline points="13 10 13 13 10 13"></polyline></svg>';

		let tmpCopyBtn = document.createElement('button');
		tmpCopyBtn.type = 'button';
		tmpCopyBtn.className = 'pict-content-code-action-btn';
		tmpCopyBtn.setAttribute('aria-label', 'Copy code to clipboard');
		tmpCopyBtn.setAttribute('title', 'Copy code');
		tmpCopyBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1.25"></rect><path d="M11 5V3.25A1.25 1.25 0 0 0 9.75 2H3.25A1.25 1.25 0 0 0 2 3.25v6.5A1.25 1.25 0 0 0 3.25 11H5"></path></svg>';

		tmpActions.appendChild(tmpFullscreenBtn);
		tmpActions.appendChild(tmpCopyBtn);

		// Insert the container in the place of the code wrap, then move the
		// code wrap inside it followed by the actions column.
		let tmpParent = pCodeWrap.parentNode;
		tmpParent.insertBefore(tmpContainer, pCodeWrap);
		tmpContainer.appendChild(pCodeWrap);
		tmpContainer.appendChild(tmpActions);

		// Click handlers
		tmpFullscreenBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._openCodeFullscreen(pCodeWrap);
		});
		tmpCopyBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._copyCodeToClipboard(pCodeWrap, tmpCopyBtn);
		});
	}

	/**
	 * Open the fullscreen overlay for a fenced code block.  Reuses the
	 * same overlay singleton as image / mermaid.
	 */
	_openCodeFullscreen(pCodeWrap)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		// Stamp the source attributes the overlay's open() expects.
		pCodeWrap.setAttribute('data-fullscreen-source', 'code');
		pCodeWrap.setAttribute('data-fullscreen-title', pCodeWrap.getAttribute('data-code-language') || 'Code');
		tmpOverlay.open(pCodeWrap);
	}

	/**
	 * Copy the raw text of a code block to the clipboard and briefly flash
	 * a "Copied!" state on the trigger button.
	 */
	_copyCodeToClipboard(pCodeWrap, pButton)
	{
		let tmpCodeEl = pCodeWrap.querySelector('code');
		let tmpText = tmpCodeEl ? tmpCodeEl.textContent : pCodeWrap.textContent;

		let fFlashOk = () =>
		{
			pButton.classList.add('is-copied');
			pButton.setAttribute('title', 'Copied!');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copied');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};
		let fFlashFail = () =>
		{
			pButton.classList.add('is-copy-failed');
			pButton.setAttribute('title', 'Copy failed');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copy-failed');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};

		try
		{
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
			{
				navigator.clipboard.writeText(tmpText).then(fFlashOk).catch(fFlashFail);
				return;
			}
		}
		catch (e)
		{
			// fall through to legacy fallback
		}

		// Legacy fallback for non-secure contexts.
		try
		{
			let tmpTextarea = document.createElement('textarea');
			tmpTextarea.value = tmpText;
			tmpTextarea.style.position = 'fixed';
			tmpTextarea.style.opacity = '0';
			document.body.appendChild(tmpTextarea);
			tmpTextarea.select();
			let tmpOk = document.execCommand('copy');
			document.body.removeChild(tmpTextarea);
			if (tmpOk) { fFlashOk(); } else { fFlashFail(); }
		}
		catch (e)
		{
			fFlashFail();
		}
	}

	/**
	 * Lazily build the singleton fullscreen overlay element and attach it
	 * to <body>.  Returns the existing instance if already built.
	 */
	_buildFullscreenOverlay()
	{
		if (PictContentView._FullscreenOverlay)
		{
			return PictContentView._FullscreenOverlay;
		}

		let tmpOverlay = document.createElement('div');
		tmpOverlay.className = 'pict-fullscreen-overlay';
		tmpOverlay.setAttribute('role', 'dialog');
		tmpOverlay.setAttribute('aria-modal', 'true');
		tmpOverlay.setAttribute('aria-labelledby', 'pict-fullscreen-title');
		tmpOverlay.setAttribute('hidden', '');
		tmpOverlay.innerHTML = ''
			+ '<div class="pict-fullscreen-titlebar">'
			+   '<span class="pict-fullscreen-title" id="pict-fullscreen-title"></span>'
			+   '<div class="pict-fullscreen-controls">'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-out" aria-label="Zoom out" title="Zoom out"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-reset" aria-label="Reset zoom" title="Reset zoom"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="5"></circle><line x1="8" y1="5" x2="8" y2="11"></line><line x1="5" y1="8" x2="11" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-in" aria-label="Zoom in" title="Zoom in"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line><line x1="8" y1="3" x2="8" y2="13"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn pict-fullscreen-close" data-action="close" aria-label="Close" title="Close (Esc)"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg></button>'
			+   '</div>'
			+ '</div>'
			+ '<div class="pict-fullscreen-stage">'
			+   '<div class="pict-fullscreen-content"></div>'
			+ '</div>';
		document.body.appendChild(tmpOverlay);

		let tmpState = {
			scale: 1,
			translateX: 0,
			translateY: 0,
			isPanning: false,
			didPan: false,
			currentKind: '',
			panStartX: 0,
			panStartY: 0,
			panOrigX: 0,
			panOrigY: 0,
			pinchInitialDistance: 0,
			pinchInitialScale: 1
		};

		let tmpStage = tmpOverlay.querySelector('.pict-fullscreen-stage');
		let tmpContent = tmpOverlay.querySelector('.pict-fullscreen-content');
		let tmpTitleEl = tmpOverlay.querySelector('.pict-fullscreen-title');

		let fApplyTransform = () =>
		{
			tmpContent.style.transform = 'translate(' + tmpState.translateX + 'px, ' + tmpState.translateY + 'px) scale(' + tmpState.scale + ')';
			tmpStage.classList.toggle('is-zoomed', tmpState.scale > 1.001);
		};

		let fClampScale = (pValue) =>
		{
			if (pValue < 0.5) return 0.5;
			if (pValue > 8) return 8;
			return pValue;
		};

		let fZoomAt = (pNewScale, pAnchorClientX, pAnchorClientY) =>
		{
			let tmpClamped = fClampScale(pNewScale);
			let tmpStageRect = tmpStage.getBoundingClientRect();
			let tmpAnchorX = (pAnchorClientX !== undefined) ? pAnchorClientX : (tmpStageRect.left + tmpStageRect.width / 2);
			let tmpAnchorY = (pAnchorClientY !== undefined) ? pAnchorClientY : (tmpStageRect.top + tmpStageRect.height / 2);
			// Convert anchor into the local coordinate of the content (which is centered)
			let tmpCenterX = tmpStageRect.left + tmpStageRect.width / 2;
			let tmpCenterY = tmpStageRect.top + tmpStageRect.height / 2;
			let tmpDX = tmpAnchorX - tmpCenterX;
			let tmpDY = tmpAnchorY - tmpCenterY;
			let tmpRatio = tmpClamped / tmpState.scale;
			tmpState.translateX = tmpDX - tmpRatio * (tmpDX - tmpState.translateX);
			tmpState.translateY = tmpDY - tmpRatio * (tmpDY - tmpState.translateY);
			tmpState.scale = tmpClamped;
			fApplyTransform();
		};

		let fResetTransform = () =>
		{
			tmpState.scale = 1;
			tmpState.translateX = 0;
			tmpState.translateY = 0;
			fApplyTransform();
		};

		let fClose = () =>
		{
			tmpOverlay.setAttribute('hidden', '');
			tmpContent.innerHTML = '';
			fResetTransform();
			document.documentElement.style.removeProperty('overflow');
			document.removeEventListener('keydown', fKeydown);
		};

		let fKeydown = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pEvent.preventDefault();
				fClose();
			}
			else if (pEvent.key === '+' || pEvent.key === '=')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale + 0.25);
			}
			else if (pEvent.key === '-' || pEvent.key === '_')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale - 0.25);
			}
			else if (pEvent.key === '0')
			{
				pEvent.preventDefault();
				fResetTransform();
			}
		};

		// Backdrop click closes (only when clicking the backdrop itself or
		// the stage area, not the inner content).  Suppress if a
		// drag-to-pan just finished — the pointerup that ended the pan
		// also fires a click event which we must ignore.
		tmpOverlay.addEventListener('click', (pEvent) =>
		{
			if (tmpState.didPan)
			{
				tmpState.didPan = false;
				return;
			}
			if (pEvent.target === tmpOverlay || pEvent.target === tmpStage)
			{
				fClose();
			}
		});

		// Toolbar buttons
		tmpOverlay.querySelectorAll('[data-action]').forEach((pBtn) =>
		{
			pBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpAction = pBtn.getAttribute('data-action');
				if (tmpAction === 'close')
				{
					fClose();
				}
				else if (tmpAction === 'zoom-in')
				{
					fZoomAt(tmpState.scale + 0.25);
				}
				else if (tmpAction === 'zoom-out')
				{
					fZoomAt(tmpState.scale - 0.25);
				}
				else if (tmpAction === 'zoom-reset')
				{
					fResetTransform();
				}
			});
		});

		// Wheel zoom — for images and mermaid diagrams.
		// For code blocks, let the browser handle native scrolling
		// so the user can scroll through long code.
		tmpStage.addEventListener('wheel', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			pEvent.preventDefault();
			let tmpDelta = -pEvent.deltaY;
			let tmpStep = (tmpDelta > 0 ? 1 : -1) * 0.15;
			fZoomAt(tmpState.scale + tmpStep, pEvent.clientX, pEvent.clientY);
		}, { passive: false });

		// Drag-to-pan when zoomed (not for code blocks — they scroll natively)
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			if (tmpState.scale <= 1.001)
			{
				return;
			}
			if (pEvent.target.closest('.pict-fullscreen-controls'))
			{
				return;
			}
			tmpState.isPanning = true;
			tmpState.panStartX = pEvent.clientX;
			tmpState.panStartY = pEvent.clientY;
			tmpState.panOrigX = tmpState.translateX;
			tmpState.panOrigY = tmpState.translateY;
			tmpStage.setPointerCapture(pEvent.pointerId);
			tmpStage.classList.add('is-panning');
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.translateX = tmpState.panOrigX + (pEvent.clientX - tmpState.panStartX);
			tmpState.translateY = tmpState.panOrigY + (pEvent.clientY - tmpState.panStartY);
			fApplyTransform();
		});
		let fEndPan = (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.isPanning = false;
			// Flag that a pan just ended so the subsequent click event
			// (which the browser fires after pointerup) does not close
			// the overlay via the backdrop-close handler.
			tmpState.didPan = true;
			tmpStage.classList.remove('is-panning');
			try { tmpStage.releasePointerCapture(pEvent.pointerId); } catch (e) {}
		};
		tmpStage.addEventListener('pointerup', fEndPan);
		tmpStage.addEventListener('pointercancel', fEndPan);

		// Touch pinch zoom
		let tmpActiveTouches = {};
		tmpStage.addEventListener('touchstart', (pEvent) =>
		{
			for (let i = 0; i < pEvent.touches.length; i++)
			{
				let tmpT = pEvent.touches[i];
				tmpActiveTouches[tmpT.identifier] = { x: tmpT.clientX, y: tmpT.clientY };
			}
			if (pEvent.touches.length === 2)
			{
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				tmpState.pinchInitialDistance = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				tmpState.pinchInitialScale = tmpState.scale;
			}
		}, { passive: true });
		tmpStage.addEventListener('touchmove', (pEvent) =>
		{
			if (pEvent.touches.length === 2 && tmpState.pinchInitialDistance > 0)
			{
				pEvent.preventDefault();
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				let tmpRatio = tmpDist / tmpState.pinchInitialDistance;
				let tmpMidX = (tmpA.clientX + tmpB.clientX) / 2;
				let tmpMidY = (tmpA.clientY + tmpB.clientY) / 2;
				fZoomAt(tmpState.pinchInitialScale * tmpRatio, tmpMidX, tmpMidY);
			}
		}, { passive: false });
		tmpStage.addEventListener('touchend', () =>
		{
			tmpActiveTouches = {};
			tmpState.pinchInitialDistance = 0;
		});

		PictContentView._FullscreenOverlay = {
			element: tmpOverlay,
			content: tmpContent,
			titleEl: tmpTitleEl,
			state: tmpState,
			open: (pSourceEl) =>
			{
				let tmpTitle = pSourceEl.getAttribute('data-fullscreen-title') || '';
				tmpTitleEl.textContent = tmpTitle;
				tmpContent.innerHTML = '';

				let tmpKind = pSourceEl.getAttribute('data-fullscreen-source');
				tmpState.currentKind = tmpKind || '';
				let tmpClone;
				if (tmpKind === 'mermaid')
				{
					let tmpSvg = pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-mermaid-svg');
						// Drop mermaid's inline max-width / width / height style so the
						// fullscreen CSS rule actually controls the size.
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'image')
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-img');
				}
				else
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-codewrap');
				}
				tmpContent.appendChild(tmpClone);

				// Hide zoom controls for code blocks (they scroll natively)
				let tmpZoomBtns = tmpOverlay.querySelectorAll('[data-action="zoom-in"], [data-action="zoom-out"], [data-action="zoom-reset"]');
				for (let i = 0; i < tmpZoomBtns.length; i++)
				{
					tmpZoomBtns[i].style.display = (tmpKind === 'code') ? 'none' : '';
				}

				fResetTransform();
				tmpOverlay.removeAttribute('hidden');
				document.documentElement.style.overflow = 'hidden';
				document.addEventListener('keydown', fKeydown);
			},
			close: fClose
		};
		return PictContentView._FullscreenOverlay;
	}

	/**
	 * Open the fullscreen overlay for a tagged source element.
	 */
	_openFullscreen(pSourceEl)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		tmpOverlay.open(pSourceEl);
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],14:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],15:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.align]   - 'left'|'right' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.setAttribute('role', 'menu');
		tmpMenu.style.maxHeight = pOptions.maxHeight;

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],16:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],17:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron SVG helper ──────────────────────────────
		let tmpChevronRight = '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,3 11,8 6,13"/></svg>';
		let tmpChevronLeft = '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="10,3 5,8 10,13"/></svg>';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],18:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			this._centerEl.innerHTML = '';
			this._centerEl.appendChild(tmpInner);
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		let tmpHost;
		if (pPanel.Position === 'overlay')
		{
			tmpHost = this._overlayLayer;
		}
		else if (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],19:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible)
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		let tmpContent = '<span class="pict-modal-toast-message">' + this._escapeHTML(pMessage) + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],20:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in
			void tmpTooltipElement.offsetHeight;
			tmpTooltipElement.classList.add('pict-modal-visible');

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					tmpHide();
				});
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			tmpHide();
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
		};

		return { destroy: tmpDestroy };
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],21:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],22:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	transition: opacity 160ms ease, width 160ms ease, height 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover    { box-shadow:  3px 0 6px -2px rgba(0, 0, 0, 0.18); }
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover   { box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.18); }
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover     { box-shadow:  0 3px 6px -2px rgba(0, 0, 0, 0.18); }
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover  { box-shadow:  0 -3px 6px -2px rgba(0, 0, 0, 0.18); }

/* Side panels: slim VERTICAL sliver pulled OUT of the panel's outer
   boundary like a drawer tab. The inner edge is anchored AT the panel
   boundary (with a 1px overlap so the tab visually merges with the
   panel's own background — no hairline gap). The tab grows OUTWARD
   only on hover; the inner edge stays put so the tab always looks
   like an extension of the panel rather than a floating button.
   Border-left is removed for left panels (and border-right for right
   panels) so the panel-facing edge is open. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	/* width 6, right: -5px → tab spans (panelRight - 1) to (panelRight + 5).
	   The 1px overlap into the panel is what makes it look attached. */
	right: -5px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -5px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
}
/* Hover: same inner anchor (panelRight - 1), tab grows outward to
   width 18 → right: -17px. Top + height grow downward only (top
   stays, height extends so the tab visually 'drops' the chevron
   into view). */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -17px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -17px;
}

/* Top / bottom panels: slim HORIZONTAL sliver pulled OUT of the
   horizontal boundary, anchored 14 px in from the right.  Same
   inner-edge-anchored / 1 px overlap pattern as the side panels. */
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -5px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -5px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -17px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -17px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],23:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items, align, position, minWidth, maxHeight,
	 *   className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss.
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":14,"./Pict-Modal-Dropdown.js":15,"./Pict-Modal-Overlay.js":16,"./Pict-Modal-Panel.js":17,"./Pict-Modal-Shell.js":18,"./Pict-Modal-Toast.js":19,"./Pict-Modal-Tooltip.js":20,"./Pict-Modal-Window.js":21,"./Pict-Section-Modal-DefaultConfiguration.js":22,"pict-view":68}],24:[function(require,module,exports){
/**
 * Pict Provider: Theme
 *
 * Runtime theme manager for Pict applications.  Registers theme bundles
 * (token maps + CSS + SVG + image assets) and applies them by injecting
 * CSS custom properties into a single <style id="pict-theme"> element.
 *
 * Themes can be:
 *   - Single-mode (Modes.Strategy = "single")
 *   - Paired light/dark (Modes.Strategy = "paired")
 *   - System-aware (Modes.Strategy = "system" — paired + auto-pick)
 *
 * Mode is reflected as `theme-light` / `theme-dark` class on <html>.
 *
 * Token resolution path examples:
 *   provider.token('Tokens.Color.Background.Primary') -> raw current value
 *   provider.cssVar('Color.Background.Primary')       -> 'var(--theme-color-background-primary)'
 *   provider.asset('SVG', 'Logo')                     -> SVG string
 *   provider.image('Hero')                            -> image URL / data URL
 *
 * Template expressions registered (when pict has addTemplate):
 *   {~Theme:Tokens.Color.Background.Primary~}    raw value
 *   {~ThemeVar:Color.Background.Primary~}        var(--theme-...) reference
 *   {~ThemeAsset:SVG.Logo~}                      asset content
 *   {~ThemeImage:Hero~}                          image URL
 *
 * Stateless: this provider does not persist anything.  Host applications
 * decide what to apply at boot (from localStorage, server config, etc.).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

const STYLE_ELEMENT_ID = 'pict-theme';
const HTML_CLASS_LIGHT = 'theme-light';
const HTML_CLASS_DARK = 'theme-dark';
const CSS_VAR_PREFIX = '--theme-';

class PictProviderTheme extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictProviderTheme';

		this._themes = {};
		this._themeOrder = [];
		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		this._systemMediaQuery = null;
		this._systemListener = null;
		this._registeredCSSHashes = [];
		this._applyListeners = [];

		// Auto-register the four theme template expressions if the host pict
		// supports addTemplate.  In bare-fable/test contexts this is skipped.
		if (this.pict && typeof this.pict.addTemplate === 'function')
		{
			try
			{
				this.pict.addTemplate(require('./templates/Pict-Template-Theme.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeVar.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeAsset.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeImage.js'));
			}
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: template registration skipped: ' + pError.message);
			}
		}
	}

	// ================================================================
	// Theme registration
	// ================================================================

	/**
	 * Register a theme bundle.  Bundle is the compiled JSON shape (see
	 * the manifest schema documented in the module README and example themes).
	 *
	 * @param {object} pBundle - parsed manifest object
	 * @returns {boolean} true on success
	 */
	registerTheme(pBundle)
	{
		if (!pBundle || typeof pBundle !== 'object')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle is not an object');
			return false;
		}
		if (!pBundle.Hash || typeof pBundle.Hash !== 'string')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle missing required string Hash');
			return false;
		}

		if (!this._themes[pBundle.Hash])
		{
			this._themeOrder.push(pBundle.Hash);
		}
		this._themes[pBundle.Hash] = pBundle;
		return true;
	}

	/**
	 * Get an array of registered theme metadata for building UIs.
	 * @returns {Array<{Hash, Name, Version, Strategy, DefaultMode, Comprehensive}>}
	 */
	listThemes()
	{
		let tmpList = [];
		for (let i = 0; i < this._themeOrder.length; i++)
		{
			let tmpHash = this._themeOrder[i];
			let tmpTheme = this._themes[tmpHash];
			let tmpModes = tmpTheme.Modes || {};
			tmpList.push(
			{
				Hash: tmpTheme.Hash,
				Name: tmpTheme.Name || tmpTheme.Hash,
				Version: tmpTheme.Version || null,
				Strategy: tmpModes.Strategy || 'single',
				DefaultMode: tmpModes.Default || 'light',
				Comprehensive: tmpTheme.Comprehensive !== false
			});
		}
		return tmpList;
	}

	/**
	 * Get the raw stored bundle for a hash.
	 */
	getTheme(pHash)
	{
		return this._themes[pHash] || null;
	}

	// ================================================================
	// Apply / unapply
	// ================================================================

	/**
	 * Apply a theme by hash.  Optionally specify mode ('light', 'dark', 'system').
	 * If pMode is omitted, the theme's Modes.Default is used.
	 *
	 * @param {string} pHash
	 * @param {string} [pMode]
	 * @returns {boolean}
	 */
	applyTheme(pHash, pMode)
	{
		let tmpTheme = this._themes[pHash];
		if (!tmpTheme)
		{
			if (this.log) this.log.warn(`PictProviderTheme.applyTheme: unknown theme hash [${pHash}]`);
			return false;
		}

		// Resolve the effective theme bundle (handle BasedOn inheritance).
		let tmpEffective = this._resolveBundle(tmpTheme);

		let tmpStrategy = (tmpEffective.Modes && tmpEffective.Modes.Strategy) || 'single';
		let tmpDefaultMode = (tmpEffective.Modes && tmpEffective.Modes.Default) || 'light';

		let tmpMode = pMode || tmpDefaultMode;

		// Single-mode themes cannot be put into dark/light/system; clamp.
		if (tmpStrategy === 'single')
		{
			tmpMode = tmpDefaultMode;
		}

		this._activeHash = pHash;
		this._activeMode = tmpMode;

		// Build CSS once, regardless of mode (paired themes emit both blocks
		// and rely on the html class to switch between them).
		let tmpCSS = this._buildThemeCSS(tmpEffective);
		this._injectStyleElement(tmpCSS);

		// Register any auxiliary CSS files declared in the bundle through the
		// Pict CSS cascade so they participate in injectCSS().
		this._registerAuxiliaryCSS(tmpEffective);

		// Set the html class to drive paired-theme variable resolution.
		this._applyMode(tmpMode, tmpStrategy);

		// Notify subscribers (e.g. apps that need to re-color SVG icon palettes
		// from a bundle.IconColors block, swap chart palettes, etc.).
		this._fireApplyListeners(tmpEffective);

		return true;
	}

	/**
	 * Change mode without reapplying the theme.  No-op if no theme is active
	 * or active theme is single-mode.
	 *
	 * @param {string} pMode - 'light' | 'dark' | 'system'
	 */
	setMode(pMode)
	{
		if (!this._activeHash) return false;

		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpStrategy = (tmpTheme.Modes && tmpTheme.Modes.Strategy) || 'single';

		if (tmpStrategy === 'single') return false;

		this._activeMode = pMode;
		this._applyMode(pMode, tmpStrategy);
		this._fireApplyListeners(tmpTheme);
		return true;
	}

	// ================================================================
	// Listener subscription
	// ================================================================

	/**
	 * Subscribe to theme apply / mode-change events.  The callback is
	 * invoked with the effective (BasedOn-resolved) bundle and a context
	 * object: { Hash, Mode, ResolvedMode }.
	 *
	 * Apps use this to re-color SVG icon palettes, swap chart colors,
	 * push tokens into non-CSS consumers (canvas, WebGL), etc.
	 *
	 * Returns a dispose function for symmetry with offApply().
	 */
	onApply(fCallback)
	{
		if (typeof fCallback !== 'function') return function () {};
		this._applyListeners.push(fCallback);
		let tmpSelf = this;
		return function () { tmpSelf.offApply(fCallback); };
	}

	offApply(fCallback)
	{
		let tmpIdx = this._applyListeners.indexOf(fCallback);
		if (tmpIdx >= 0) this._applyListeners.splice(tmpIdx, 1);
	}

	_fireApplyListeners(pBundle)
	{
		if (this._applyListeners.length === 0) return;
		let tmpContext =
		{
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
		for (let i = 0; i < this._applyListeners.length; i++)
		{
			try { this._applyListeners[i](pBundle, tmpContext); }
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: onApply listener threw: ' + pError.message);
			}
		}
	}

	/**
	 * Remove the injected style element, html class, and any auxiliary CSS.
	 */
	unapplyTheme()
	{
		this._detachSystemListener();

		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode)
			{
				tmpStyleEl.parentNode.removeChild(tmpStyleEl);
			}
			if (document.documentElement && document.documentElement.classList)
			{
				document.documentElement.classList.remove(HTML_CLASS_LIGHT);
				document.documentElement.classList.remove(HTML_CLASS_DARK);
			}
		}

		// Unregister any auxiliary CSS we added.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		return true;
	}

	getActiveTheme()
	{
		return {
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
	}

	// ================================================================
	// Token / asset accessors
	// ================================================================

	/**
	 * Resolve a token by dot path against the active theme bundle.  Walks
	 * the entire bundle root, so paths can address Tokens, Brand, etc.
	 *
	 * If the value is paired ({Light, Dark}), returns the value at the
	 * currently resolved mode.
	 *
	 * @param {string} pPath - e.g. 'Tokens.Color.Background.Primary'
	 * @returns {string|number|null}
	 */
	token(pPath)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpValue = this._walkPath(tmpTheme, pPath);
		return this._resolveModedValue(tmpValue);
	}

	/**
	 * Returns a CSS `var(--theme-...)` reference for a token under Tokens.
	 * Path is given without the Tokens prefix:
	 *   cssVar('Color.Background.Primary') -> 'var(--theme-color-background-primary)'
	 *
	 * @param {string} pTokenPath
	 * @returns {string}
	 */
	cssVar(pTokenPath)
	{
		return 'var(' + this._cssVarName(pTokenPath) + ')';
	}

	/**
	 * Look up a named asset under SVG, optionally nested (e.g. 'Icons.Foo').
	 * @param {string} pCategory - 'SVG' | 'Image'
	 * @param {string} pName
	 */
	asset(pCategory, pName)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpRoot = tmpTheme[pCategory];
		if (!tmpRoot) return null;
		return this._walkPath(tmpRoot, pName);
	}

	image(pName)
	{
		return this.asset('Image', pName);
	}

	svg(pName)
	{
		return this.asset('SVG', pName);
	}

	// ================================================================
	// Internals
	// ================================================================

	/**
	 * Resolve a bundle's BasedOn chain into a single effective bundle by
	 * deep-merging this bundle onto its base.  Cycle-safe.
	 */
	_resolveBundle(pBundle)
	{
		let tmpChain = [];
		let tmpCurrent = pBundle;
		let tmpSeen = {};
		while (tmpCurrent)
		{
			if (tmpSeen[tmpCurrent.Hash]) break;
			tmpSeen[tmpCurrent.Hash] = true;
			tmpChain.unshift(tmpCurrent);
			let tmpBaseHash = tmpCurrent.BasedOn;
			tmpCurrent = tmpBaseHash ? this._themes[tmpBaseHash] : null;
		}
		if (tmpChain.length === 1) return tmpChain[0];

		let tmpResult = {};
		for (let i = 0; i < tmpChain.length; i++)
		{
			tmpResult = this._deepMerge(tmpResult, tmpChain[i]);
		}
		return tmpResult;
	}

	_deepMerge(pTarget, pSource)
	{
		let tmpResult = Object.assign({}, pTarget);
		let tmpKeys = Object.keys(pSource);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpVal = pSource[tmpKey];
			if (tmpVal !== null
				&& typeof tmpVal === 'object'
				&& !Array.isArray(tmpVal)
				&& tmpResult[tmpKey] !== null
				&& typeof tmpResult[tmpKey] === 'object'
				&& !Array.isArray(tmpResult[tmpKey]))
			{
				tmpResult[tmpKey] = this._deepMerge(tmpResult[tmpKey], tmpVal);
			}
			else
			{
				tmpResult[tmpKey] = tmpVal;
			}
		}
		return tmpResult;
	}

	/**
	 * Walk a dot-path from a starting object.  Returns null if any segment
	 * is missing.  Path segments are matched case-sensitively as authored.
	 */
	_walkPath(pRoot, pPath)
	{
		if (!pRoot || !pPath) return null;
		let tmpSegments = pPath.split('.');
		let tmpNode = pRoot;
		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpNode === null || typeof tmpNode !== 'object') return null;
			tmpNode = tmpNode[tmpSegments[i]];
			if (typeof tmpNode === 'undefined') return null;
		}
		return tmpNode;
	}

	/**
	 * If pValue is a paired-mode object {Light, Dark}, pick the value matching
	 * the current resolved mode.  Otherwise return as-is.
	 */
	_resolveModedValue(pValue)
	{
		if (this._isPairedValue(pValue))
		{
			let tmpMode = this._resolvedMode || 'light';
			let tmpKey = (tmpMode === 'dark') ? 'Dark' : 'Light';
			return pValue[tmpKey];
		}
		return pValue;
	}

	_isPairedValue(pValue)
	{
		return pValue !== null
			&& typeof pValue === 'object'
			&& !Array.isArray(pValue)
			&& Object.keys(pValue).length > 0
			&& Object.keys(pValue).every((k) => k === 'Light' || k === 'Dark');
	}

	/**
	 * Build the CSS string for a theme.  For single-mode themes, emits a
	 * single :root block.  For paired themes, emits :root for the Light
	 * variant and a .theme-dark { ... } block for the Dark variant.
	 *
	 * Only values under bundle.Tokens become CSS custom properties.
	 */
	_buildThemeCSS(pTheme)
	{
		let tmpTokens = pTheme.Tokens || {};
		let tmpFlat = this._flattenTokens(tmpTokens, '');

		let tmpStrategy = (pTheme.Modes && pTheme.Modes.Strategy) || 'single';
		let tmpHasPaired = tmpFlat.some((tmpEntry) => this._isPairedValue(tmpEntry.Value));

		let tmpAliasLines = this._buildAliasLines(pTheme.Aliases);

		if (tmpStrategy === 'single' || !tmpHasPaired)
		{
			let tmpCSS = ':root {\n';
			for (let i = 0; i < tmpFlat.length; i++)
			{
				let tmpEntry = tmpFlat[i];
				let tmpVal = this._isPairedValue(tmpEntry.Value)
					? tmpEntry.Value.Light
					: tmpEntry.Value;
				tmpCSS += '\t' + this._cssVarName(tmpEntry.Path) + ': ' + this._formatCSSValue(tmpVal) + ';\n';
			}
			tmpCSS += tmpAliasLines;
			tmpCSS += '}\n';
			return tmpCSS;
		}

		let tmpRootCSS = ':root {\n';
		let tmpDarkCSS = '.' + HTML_CLASS_DARK + ' {\n';

		for (let i = 0; i < tmpFlat.length; i++)
		{
			let tmpEntry = tmpFlat[i];
			let tmpVarName = this._cssVarName(tmpEntry.Path);
			if (this._isPairedValue(tmpEntry.Value))
			{
				if (typeof tmpEntry.Value.Light !== 'undefined')
				{
					tmpRootCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Light) + ';\n';
				}
				if (typeof tmpEntry.Value.Dark !== 'undefined')
				{
					tmpDarkCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Dark) + ';\n';
				}
			}
			else
			{
				tmpRootCSS += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value) + ';\n';
			}
		}

		// Aliases live in :root only.  Their var() targets resolve to the
		// active mode's value automatically — no need to duplicate in dark.
		tmpRootCSS += tmpAliasLines;
		tmpRootCSS += '}\n';
		tmpDarkCSS += '}\n';
		return tmpRootCSS + tmpDarkCSS;
	}

	/**
	 * Emit alias lines for legacy CSS variable names that map to token paths
	 * under Tokens.  Each alias becomes:
	 *   --legacy-name: var(--theme-color-...);
	 * Indirection-via-var means paired-mode swap propagates without
	 * needing alias entries duplicated in the .theme-dark block.
	 *
	 * Authored as: { "--legacy-name": "Color.Background.Primary", ... }
	 */
	_buildAliasLines(pAliases)
	{
		if (!pAliases || typeof pAliases !== 'object') return '';
		let tmpKeys = Object.keys(pAliases);
		let tmpOut = '';
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpAlias = tmpKeys[i];
			let tmpTarget = pAliases[tmpAlias];
			if (typeof tmpTarget !== 'string' || tmpTarget.length === 0) continue;
			tmpOut += '\t' + tmpAlias + ': var(' + this._cssVarName(tmpTarget) + ');\n';
		}
		return tmpOut;
	}

	/**
	 * Walk an arbitrary nested token tree and produce a flat list of
	 * { Path: 'color.background.primary', Value: <leaf> } entries.
	 *
	 * Paired-mode objects ({Light, Dark}) and primitive values are leaves.
	 */
	_flattenTokens(pNode, pPathPrefix)
	{
		let tmpResults = [];
		if (pNode === null || typeof pNode !== 'object' || Array.isArray(pNode))
		{
			if (pPathPrefix)
			{
				tmpResults.push({ Path: pPathPrefix, Value: pNode });
			}
			return tmpResults;
		}
		if (this._isPairedValue(pNode))
		{
			tmpResults.push({ Path: pPathPrefix, Value: pNode });
			return tmpResults;
		}
		let tmpKeys = Object.keys(pNode);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pPathPrefix ? (pPathPrefix + '.' + tmpKey) : tmpKey;
			let tmpChild = pNode[tmpKey];
			tmpResults = tmpResults.concat(this._flattenTokens(tmpChild, tmpChildPath));
		}
		return tmpResults;
	}

	/**
	 * 'Color.Background.Primary' -> '--theme-color-background-primary'
	 */
	_cssVarName(pTokenPath)
	{
		return CSS_VAR_PREFIX + pTokenPath.toLowerCase().replace(/\./g, '-');
	}

	_formatCSSValue(pValue)
	{
		if (pValue === null || typeof pValue === 'undefined') return '';
		if (typeof pValue === 'number') return String(pValue);
		return String(pValue);
	}

	_injectStyleElement(pCSS)
	{
		if (typeof document === 'undefined') return;
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = STYLE_ELEMENT_ID;
			document.head.appendChild(tmpStyleEl);
		}
		tmpStyleEl.textContent = pCSS;
	}

	_registerAuxiliaryCSS(pTheme)
	{
		// Clear previously registered auxiliary CSS so stale entries don't pile
		// up when switching themes.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		if (!Array.isArray(pTheme.CSS)) return;
		if (!this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function') return;

		for (let i = 0; i < pTheme.CSS.length; i++)
		{
			let tmpEntry = pTheme.CSS[i];
			if (!tmpEntry || !tmpEntry.Hash || typeof tmpEntry.Content !== 'string') continue;
			let tmpPriority = (typeof tmpEntry.Priority === 'number') ? tmpEntry.Priority : 500;
			this.pict.CSSMap.addCSS(tmpEntry.Hash, tmpEntry.Content, tmpPriority);
			this._registeredCSSHashes.push(tmpEntry.Hash);
		}
	}

	/**
	 * Set or update the `theme-light` / `theme-dark` class on <html>.
	 * For 'system', subscribes to prefers-color-scheme.
	 */
	_applyMode(pMode, pStrategy)
	{
		this._detachSystemListener();

		let tmpResolved = pMode;
		if (pMode === 'system')
		{
			tmpResolved = this._readSystemPreference();
			this._attachSystemListener(pStrategy);
		}

		this._resolvedMode = (tmpResolved === 'dark') ? 'dark' : 'light';
		this._writeHTMLClass(this._resolvedMode);
	}

	_writeHTMLClass(pResolvedMode)
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		if (pResolvedMode === 'dark')
		{
			tmpList.remove(HTML_CLASS_LIGHT);
			tmpList.add(HTML_CLASS_DARK);
		}
		else
		{
			tmpList.remove(HTML_CLASS_DARK);
			tmpList.add(HTML_CLASS_LIGHT);
		}
	}

	_readSystemPreference()
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
		try
		{
			return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
		}
		catch (pError)
		{
			return 'light';
		}
	}

	_attachSystemListener(pStrategy)
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
		try
		{
			let tmpSelf = this;
			let tmpMQ = window.matchMedia('(prefers-color-scheme: dark)');
			let tmpHandler = function ()
			{
				let tmpResolved = tmpMQ.matches ? 'dark' : 'light';
				tmpSelf._resolvedMode = tmpResolved;
				tmpSelf._writeHTMLClass(tmpResolved);
			};
			if (typeof tmpMQ.addEventListener === 'function')
			{
				tmpMQ.addEventListener('change', tmpHandler);
			}
			else if (typeof tmpMQ.addListener === 'function')
			{
				tmpMQ.addListener(tmpHandler);
			}
			this._systemMediaQuery = tmpMQ;
			this._systemListener = tmpHandler;
		}
		catch (pError)
		{
			// Older browser; leave system listener unattached.
		}
	}

	_detachSystemListener()
	{
		if (!this._systemMediaQuery || !this._systemListener) return;
		try
		{
			if (typeof this._systemMediaQuery.removeEventListener === 'function')
			{
				this._systemMediaQuery.removeEventListener('change', this._systemListener);
			}
			else if (typeof this._systemMediaQuery.removeListener === 'function')
			{
				this._systemMediaQuery.removeListener(this._systemListener);
			}
		}
		catch (pError)
		{
			// noop
		}
		this._systemMediaQuery = null;
		this._systemListener = null;
	}
}

PictProviderTheme.default_configuration = _ProviderConfiguration;

module.exports = PictProviderTheme;
module.exports.STYLE_ELEMENT_ID = STYLE_ELEMENT_ID;
module.exports.HTML_CLASS_LIGHT = HTML_CLASS_LIGHT;
module.exports.HTML_CLASS_DARK = HTML_CLASS_DARK;
module.exports.CSS_VAR_PREFIX = CSS_VAR_PREFIX;

},{"./templates/Pict-Template-Theme.js":25,"./templates/Pict-Template-ThemeAsset.js":26,"./templates/Pict-Template-ThemeImage.js":27,"./templates/Pict-Template-ThemeVar.js":28,"pict-provider":7}],25:[function(require,module,exports){
/**
 * Pict template expression: {~Theme:Path~}
 *
 * Resolves a token path against the active theme bundle and returns the
 * raw value at the currently resolved mode.  Walks from the bundle root,
 * so paths like 'Tokens.Color.Background.Primary' or 'Brand.Name' work.
 *
 * Returns an empty string if no theme is active or the path is missing.
 */
const libPictTemplate = require('pict-template');

class PictTemplateTheme extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Theme:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.token(tmpPath);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateTheme;

},{"pict-template":66}],26:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeAsset:Category.Name~}
 *
 * Returns the contents of a named SVG (or other) asset from the active
 * theme bundle.  The first path segment is treated as the category
 * (e.g. SVG), the rest as the asset's path within that category.
 *
 *   {~ThemeAsset:SVG.Logo~}        -> bundle.SVG.Logo
 *   {~ThemeAsset:SVG.Icons.Foo~}   -> bundle.SVG.Icons.Foo
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeAsset extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeAsset:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpDot = tmpPath.indexOf('.');
		if (tmpDot < 0) return '';

		let tmpCategory = tmpPath.substring(0, tmpDot);
		let tmpName = tmpPath.substring(tmpDot + 1);

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.asset(tmpCategory, tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeAsset;

},{"pict-template":66}],27:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeImage:Name~}
 *
 * Returns the URL or data URL stored at bundle.Image[Name] in the active
 * theme bundle.  Convenience over {~ThemeAsset:Image.Name~}.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeImage extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeImage:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpName = (pTemplateHash || '').trim();
		if (!tmpName) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.image(tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeImage;

},{"pict-template":66}],28:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeVar:Path~}
 *
 * Returns a CSS `var(--theme-...)` reference for a token path under
 * Tokens.  E.g. {~ThemeVar:Color.Background.Primary~} ->
 * `var(--theme-color-background-primary)`.
 *
 * Useful inside style attributes and in CSS-in-JS contexts where you want
 * the live custom-property reference rather than the resolved value.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeVar extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeVar:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';
		return tmpProvider.cssVar(tmpPath);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeVar;

},{"pict-template":66}],29:[function(require,module,exports){
/**
 * pict-section-theme — entry point.
 *
 * Bundles every Retold-ecosystem theme and exposes five reusable views:
 *
 *   - Theme-Picker      : a custom dropdown listing every registered theme,
 *                         grouped by category, with inline SVG mode-glyphs.
 *                         Switches the active theme on change.
 *   - Theme-ModeToggle  : a 3-button toggle for Light / Dark / System mode.
 *                         Disables itself when the active theme is single-mode.
 *   - Theme-ScaleSelect : a dropdown of viewport scale presets (75% – 200%).
 *                         Independent of theme bundles — applied via CSS
 *                         `zoom` on <html> + a `--theme-scale` custom prop.
 *   - Theme-Button      : an embeddable SVG topbar button that, when clicked,
 *                         opens a pict-section-modal containing the picker,
 *                         the mode toggle, and the scale select. Designed to
 *                         drop into any application chrome.
 *   - Theme-BrandStrip  : the per-app brand signature (icon + name + two
 *                         color stripes). Driven by libThemeBrand which the
 *                         host configures via the `Brand` option.
 *
 * # Recommended consumption (Pict provider)
 *
 * Add the section as a Pict provider — it self-bootstraps on construction:
 *
 *     const libPictSectionTheme = require('pict-section-theme');
 *
 *     pict.addProvider('Theme-Section',
 *     {
 *         ApplyDefault: 'retold-default',
 *         DefaultMode:  'system',
 *         DefaultScale: 1.0,
 *         Brand:        libRetoldManagerBrand
 *     }, libPictSectionTheme);
 *
 * That single addProvider call:
 *   - Ensures `pict.providers.Theme` (the underlying pict-provider-theme
 *     runtime) exists.
 *   - Registers every theme in the runtime registry — bundled starter set
 *     plus anything the host registered via `Catalog.register()`.
 *   - Adds Theme-Picker / Theme-ModeToggle / Theme-ScaleSelect /
 *     Theme-Button / Theme-BrandStrip to `pict.views[...]`.
 *   - Hydrates persisted choices from localStorage; otherwise applies the
 *     supplied `ApplyDefault` / `DefaultMode` / `DefaultScale`.
 *   - Wires the `onApply` save handler so subsequent user picks persist.
 *   - Applies the supplied Brand block if one was provided.
 *
 * # Runtime theme registration
 *
 * The bundled starter set lives in `themes/_catalog.js`. To add custom
 * themes (e.g. a host app's own brand palette, or a remote bundle from
 * a "theme garden") use the registry:
 *
 *     const libCatalog = require('pict-section-theme').Catalog;
 *     libCatalog.register({ Hash: 'my-theme', Bundle: require('./mine.json'), Category: 'App' });
 *     // Or, async, from a URL:
 *     await libCatalog.registerFromURL('https://garden.example.com/themes/foo.json');
 *
 * Themes registered before `addProvider()` runs are picked up
 * automatically. Themes registered after must be manually pushed via
 * `pict.providers.Theme.registerTheme(bundle)`.
 *
 * # Persistence
 *
 * Persisting active theme + mode + scale to localStorage is on by
 * default. Storage key is scoped to `window.location.hostname` so apps
 * on different hosts keep independent state. Override with
 * `PersistenceKey: 'my-app'`. Pass `Persistence: false` to disable.
 *
 * A saved entry takes precedence over `ApplyDefault` — once a user has
 * picked a theme, reloads honour that pick instead of the host's
 * default. If the saved theme hash is no longer in the registry (theme
 * removed, app downgraded), the bootstrap falls back to `ApplyDefault`
 * cleanly.
 *
 * # Legacy API
 *
 * `install(pict, options)` and `registerCatalog(pict)` are still
 * exported as thin shims that delegate to the provider — existing apps
 * keep working without changes.
 */

'use strict';

const libPictProvider = require('pict-provider');
const libPictProviderTheme = require('pict-provider-theme');

const libPickerView = require('./views/PictView-Theme-Picker.js');
const libModeToggleView = require('./views/PictView-Theme-ModeToggle.js');
const libScaleSelectView = require('./views/PictView-Theme-ScaleSelect.js');
const libButtonView = require('./views/PictView-Theme-Button.js');
const libBrandStripView = require('./views/PictView-Theme-BrandStrip.js');
const libBrandMarkView = require('./views/PictView-Theme-Brand-Mark.js');
const libTopBarView = require('./views/PictView-Theme-TopBar.js');
const libBottomBarView = require('./views/PictView-Theme-BottomBar.js');

const libThemePersistence = require('./Theme-Persistence.js');
const libThemeScale = require('./Theme-Scale.js');
const libThemeBrand = require('./Theme-Brand.js');
// Theme-Logo (the deterministic name → SVG generator) is intentionally
// NOT required here. It's a build-time tool used by
// `pict-section-theme-brand` to precompute brand blocks into a host's
// package.json — there's no reason for it to ride along in the runtime
// bundle every host ships. Hosts that want runtime generation can
// `require('pict-section-theme/source/Theme-Logo.js')` directly; that
// keeps the import explicit and the cost opt-in.

const libCatalog = require('./themes/_catalog.js');

// View registry: short-name → { lib, hash } where hash is the
// ViewIdentifier the view registers under in pict.views[...].
const _Views =
{
	Picker:      { lib: libPickerView,      hash: 'Theme-Picker' },
	ModeToggle:  { lib: libModeToggleView,  hash: 'Theme-ModeToggle' },
	ScaleSelect: { lib: libScaleSelectView, hash: 'Theme-ScaleSelect' },
	Button:      { lib: libButtonView,      hash: 'Theme-Button' },
	BrandStrip:  { lib: libBrandStripView,  hash: 'Theme-BrandStrip' },
	BrandMark:   { lib: libBrandMarkView,   hash: 'Theme-Brand-Mark' },
	TopBar:      { lib: libTopBarView,      hash: 'Theme-TopBar' },
	BottomBar:   { lib: libBottomBarView,   hash: 'Theme-BottomBar' }
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme-Section',

	// Don't auto-fire the standard pict-provider initialize chain — we do
	// our setup work synchronously in the constructor so consumers can
	// use the views immediately after addProvider() returns.
	AutoInitialize: false,

	// Bootstrap config — same shape as the legacy install() options.
	ApplyDefault:    null,    // theme hash to apply at boot
	DefaultMode:     null,    // 'light' | 'dark' | 'system' | null (theme's default)
	DefaultScale:    null,    // 0.75 .. 2.0 — viewport scale
	Persistence:     true,
	PersistenceKey:  null,    // null → window.location.hostname
	RegisterCatalog: true,
	Views:           null,    // null → all views; or array of short-names
	ViewOptions:     null,    // { Picker: { ... }, ... } per-view overrides
	Brand:           null,    // { Name, Icon, Colors: { Primary, ... } }
	ProviderOptions: null     // pict-provider-theme overrides if a host wants them
};

// ── Helpers ──────────────────────────────────────────────────────────────

/**
 * Iterate the runtime registry and call provider.registerTheme() for each
 * entry. Safe to call before or after addProvider — the runtime's
 * registerTheme is idempotent on repeat hashes.
 *
 * @param {object} pPict - a Pict instance with the Theme runtime attached
 * @returns {number} count of themes registered
 */
function registerCatalog(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers.Theme)
	{
		if (pPict && pPict.log && pPict.log.warn)
		{
			pPict.log.warn('pict-section-theme.registerCatalog: pict.providers.Theme not found — register the runtime first');
		}
		return 0;
	}
	let tmpProvider = pPict.providers.Theme;
	let tmpEntries = libCatalog.list();
	let tmpCount = 0;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpProvider.registerTheme(tmpEntries[i].Bundle))
		{
			tmpCount++;
		}
	}
	return tmpCount;
}

/**
 * Return the registry as picker-friendly metadata (no Bundle payload).
 *
 * @returns {Array<{Hash, Name, Category, Strategy, DefaultMode, IsDefault}>}
 */
function listCatalog()
{
	let tmpEntries = libCatalog.list();
	let tmpList = [];
	for (let i = 0; i < tmpEntries.length; i++)
	{
		let tmpEntry = tmpEntries[i];
		let tmpBundle = tmpEntry.Bundle || {};
		let tmpModes = tmpBundle.Modes || {};
		tmpList.push(
		{
			Hash: tmpEntry.Hash,
			Name: tmpBundle.Name || tmpEntry.Hash,
			Category: tmpEntry.Category || 'Other',
			Strategy: tmpModes.Strategy || 'single',
			DefaultMode: tmpModes.Default || 'light',
			IsDefault: !!tmpEntry.IsDefault
		});
	}
	return tmpList;
}

// ── Bootstrap routine ────────────────────────────────────────────────────
// Shared between the provider class (new path) and the install() function
// (legacy path). Performs the actual wiring against a Pict instance.
function _bootstrap(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme: requires a Pict instance');
	}
	let tmpOptions = pOptions || {};

	// 1. Theme runtime — only add if not already attached (hosts with
	//    a custom runtime, e.g. retold-remote's V2 bridge, pre-register).
	if (!pPict.providers || !pPict.providers.Theme)
	{
		let tmpRuntimeOpts = Object.assign({},
			libPictProviderTheme.default_configuration, tmpOptions.ProviderOptions || {});
		pPict.addProvider('Theme', tmpRuntimeOpts, libPictProviderTheme);
	}

	// 2. Catalog — every entry from the runtime registry, unless the host
	//    asked to skip (RegisterCatalog: false).
	if (tmpOptions.RegisterCatalog !== false)
	{
		registerCatalog(pPict);
	}

	// 3. Views — default all five; pass an array to subset.
	let tmpViewNames = Array.isArray(tmpOptions.Views) ? tmpOptions.Views : Object.keys(_Views);
	for (let i = 0; i < tmpViewNames.length; i++)
	{
		let tmpEntry = _Views[tmpViewNames[i]];
		if (!tmpEntry)
		{
			if (pPict.log && pPict.log.warn)
			{
				pPict.log.warn('pict-section-theme: unknown view name "' + tmpViewNames[i] + '" — skipped');
			}
			continue;
		}
		if (pPict.views && pPict.views[tmpEntry.hash])
		{
			// Already registered — skip silently.
			continue;
		}
		let tmpViewOpts = Object.assign({},
			tmpEntry.lib.default_configuration,
			(tmpOptions.ViewOptions && tmpOptions.ViewOptions[tmpViewNames[i]]) || {});
		pPict.addView(tmpEntry.hash, tmpViewOpts, tmpEntry.lib);
	}

	// 4. Persistence + initial apply.
	let tmpProvider = pPict.providers.Theme;
	let tmpPersistenceEnabled = (tmpOptions.Persistence !== false);
	let tmpPersistenceKey = null;

	let tmpBootHash  = tmpOptions.ApplyDefault || null;
	let tmpBootMode  = tmpOptions.DefaultMode  || null;
	let tmpBootScale = (typeof tmpOptions.DefaultScale === 'number') ? tmpOptions.DefaultScale : null;

	if (tmpPersistenceEnabled && tmpProvider)
	{
		tmpPersistenceKey = libThemePersistence.resolveKey(tmpOptions.PersistenceKey);

		let tmpSaved = libThemePersistence.load(tmpPersistenceKey);
		if (tmpSaved
			&& tmpSaved.ThemeHash
			&& typeof tmpProvider.getTheme === 'function'
			&& tmpProvider.getTheme(tmpSaved.ThemeHash))
		{
			tmpBootHash = tmpSaved.ThemeHash;
			if (tmpSaved.Mode)  { tmpBootMode  = tmpSaved.Mode; }
			if (tmpSaved.Scale) { tmpBootScale = tmpSaved.Scale; }
		}
		else if (tmpSaved && tmpSaved.Scale)
		{
			tmpBootScale = tmpSaved.Scale;
		}

		// Single save snapshot — both the provider listener and the scale
		// listener call this so any change persists the full set.
		let tmpSaveCurrent = function ()
		{
			let tmpActive = (typeof tmpProvider.getActiveTheme === 'function')
				? tmpProvider.getActiveTheme() : { Hash: null, Mode: null };
			libThemePersistence.save(tmpPersistenceKey,
			{
				ThemeHash: tmpActive.Hash,
				Mode:      tmpActive.Mode,
				Scale:     libThemeScale.getActive()
			});
		};

		tmpProvider.onApply(tmpSaveCurrent);
		libThemeScale.onChange(tmpSaveCurrent);
	}

	if (tmpBootHash && tmpProvider)
	{
		tmpProvider.applyTheme(tmpBootHash, tmpBootMode);
	}
	if (tmpBootScale !== null)
	{
		libThemeScale.applyScale(tmpBootScale);
	}

	// 5. Brand — host-supplied app identity. Apply LAST so the BrandStrip
	//    view's first paint sees the CSS custom properties.
	if (tmpOptions.Brand)
	{
		libThemeBrand.applyBrand(tmpOptions.Brand);
	}

	// Stash the resolved key on the provider for debugging + so the host
	// can clear it via clearPersistence() for a "reset to defaults"
	// affordance.
	if (tmpProvider && tmpPersistenceKey)
	{
		tmpProvider._persistenceKey = tmpPersistenceKey;
	}

	return tmpProvider;
}

// ── PictProvider class ───────────────────────────────────────────────────
// The recommended entry point. `pict.addProvider('Theme-Section',
// options, PictSectionThemeProvider)` self-bootstraps the whole module
// (runtime + catalog + views + persistence + apply + brand) inside the
// constructor — no follow-up install() call required.
class PictSectionThemeProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictSectionTheme';

		// pict-provider sets `this.pict` for us via super() above. Run the
		// bootstrap synchronously so the views, theme runtime, and applied
		// theme are all in place before addProvider() returns.
		_bootstrap(this.pict, this.options);
	}

	/**
	 * Embed theme controls into a host-supplied container.
	 *
	 * The Theme-Button view ships a popover that hosts the picker + mode
	 * toggle + scale select — convenient for "drop a theme menu in the
	 * topbar" but not for apps that already have a settings surface and
	 * want the controls inline there. `mount()` writes the destination
	 * divs each theme view expects into the supplied container, then
	 * calls render() on each requested view.
	 *
	 * Important: each theme view has a SINGLE default destination id
	 * (e.g. `#Theme-Picker`). Mounting overrides where the view paints —
	 * once mount() is called, the picker / toggle / scale destinations
	 * live inside the supplied container. Combining a mount() with a
	 * Theme-Button popover that ALSO hosts these views causes duplicate
	 * destination ids and undefined behaviour; pick one host per view.
	 *
	 * @param {object} pOptions
	 * @param {string|HTMLElement} pOptions.Container - CSS selector or element
	 * @param {Array<string>} [pOptions.Views] - short names; default ['Picker','ModeToggle','ScaleSelect']
	 * @param {string} [pOptions.WrapperClass] - class added to the outer wrapper div
	 * @returns {object|null} { container, viewsRendered } on success, null if the container can't be resolved
	 */
	mount(pOptions)
	{
		let tmpOpts = pOptions || {};
		let tmpContainer = tmpOpts.Container;
		if (!tmpContainer) { return null; }
		let tmpEl = (typeof tmpContainer === 'string')
			? (this.pict && this.pict.ContentAssignment
				? this.pict.ContentAssignment.getElement(tmpContainer)
				: document.querySelector(tmpContainer))
			: tmpContainer;
		// ContentAssignment.getElement returns an array-like; normalise to one node.
		if (tmpEl && tmpEl.length && !tmpEl.tagName) { tmpEl = tmpEl[0]; }
		if (!tmpEl)
		{
			if (this.pict && this.pict.log && this.pict.log.warn)
			{
				this.pict.log.warn('pict-section-theme.mount: container not found for ' + tmpContainer);
			}
			return null;
		}

		let tmpRequested = Array.isArray(tmpOpts.Views) && tmpOpts.Views.length
			? tmpOpts.Views
			: ['Picker', 'ModeToggle', 'ScaleSelect'];

		// Build a wrapper that carries one row per requested view; each row
		// contains the destination div the view's render() will write into.
		let tmpRows = [];
		let tmpRendered = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			let tmpEntry = _Views[tmpRequested[i]];
			if (!tmpEntry) { continue; }
			let tmpDestSel = tmpEntry.lib.default_configuration.DefaultDestinationAddress || '';
			let tmpDestId = tmpDestSel.replace(/^#/, '');
			if (!tmpDestId) { continue; }
			tmpRows.push(
				'<div class="pict-theme-mount-row pict-theme-mount-row-' + tmpEntry.hash.toLowerCase() + '">'
					+ '<div id="' + tmpDestId + '"></div>'
				+ '</div>');
			tmpRendered.push(tmpEntry.hash);
		}

		let tmpWrapperClass = 'pict-theme-mount' + (tmpOpts.WrapperClass ? ' ' + tmpOpts.WrapperClass : '');
		tmpEl.innerHTML = '<div class="' + tmpWrapperClass + '">' + tmpRows.join('') + '</div>';

		// Render each requested view. Each render() targets the destination
		// id we just stamped into the wrapper.
		for (let i = 0; i < tmpRendered.length; i++)
		{
			let tmpView = this.pict.views[tmpRendered[i]];
			if (tmpView && typeof tmpView.render === 'function')
			{
				try { tmpView.render(); }
				catch (pErr) { /* a view render failure shouldn't break the host */ }
			}
		}

		return { container: tmpEl, viewsRendered: tmpRendered };
	}
}

// ── Legacy install() ─────────────────────────────────────────────────────
// Thin shim for apps that already call install(); delegates to the same
// bootstrap routine the provider runs.
function install(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme.install: first arg must be a Pict instance');
	}
	return _bootstrap(pPict, pOptions || {});
}

/**
 * Drop the saved theme state for this app's storage key. The next
 * install() (or page reload / addProvider) falls back to ApplyDefault.
 *
 * @param {object} pPict - the pict instance
 * @returns {boolean} true if anything was cleared
 */
function clearPersistence(pPict)
{
	let tmpKey = (pPict && pPict.providers && pPict.providers.Theme && pPict.providers.Theme._persistenceKey)
		|| libThemePersistence.resolveKey(null);
	return libThemePersistence.clear(tmpKey);
}

// ── Exports ──────────────────────────────────────────────────────────────
// Default export = the provider class so apps can do:
//   pict.addProvider('Theme-Section', { ... }, libPictSectionTheme);
//
// Named exports preserved so legacy callers keep working unchanged.
module.exports = PictSectionThemeProvider;
module.exports.default_configuration = _ProviderConfiguration;

module.exports.Provider = libPictProviderTheme;             // the runtime class
module.exports.PictSectionThemeProvider = PictSectionThemeProvider;
module.exports.PickerView = libPickerView;
module.exports.ModeToggleView = libModeToggleView;
module.exports.ButtonView = libButtonView;
module.exports.ScaleSelectView = libScaleSelectView;
module.exports.BrandStripView = libBrandStripView;
module.exports.BrandMarkView = libBrandMarkView;
module.exports.TopBarView = libTopBarView;
module.exports.BottomBarView = libBottomBarView;
module.exports.Catalog = libCatalog;                        // the registry singleton
module.exports.Brand = libThemeBrand;                       // the brand helper module
module.exports.Scale = libThemeScale;                       // the scale helper module
module.exports.Persistence = libThemePersistence;           // the persistence helper module
// Theme-Logo is exposed as a sub-module path, not a top-level field —
// see the comment near the imports above.
module.exports.registerCatalog = registerCatalog;
module.exports.listCatalog = listCatalog;
module.exports.install = install;
module.exports.clearPersistence = clearPersistence;

},{"./Theme-Brand.js":30,"./Theme-Persistence.js":32,"./Theme-Scale.js":33,"./themes/_catalog.js":37,"./views/PictView-Theme-BottomBar.js":57,"./views/PictView-Theme-Brand-Mark.js":58,"./views/PictView-Theme-BrandStrip.js":59,"./views/PictView-Theme-Button.js":60,"./views/PictView-Theme-ModeToggle.js":61,"./views/PictView-Theme-Picker.js":62,"./views/PictView-Theme-ScaleSelect.js":63,"./views/PictView-Theme-TopBar.js":64,"pict-provider":7,"pict-provider-theme":24}],30:[function(require,module,exports){
/**
 * Theme-Brand — app-level brand identity (icon + colors) that overlays
 * the active theme.
 *
 * # What this is for
 *
 * The active *theme* describes how UI surfaces look (panel colors,
 * borders, text, status). The active *brand* describes which APP the
 * user is in. retold-facto, retold-manager, and ultravisor can share
 * the same theme but each carries its own visual signature: a small
 * icon and two brand colors that show up in a stripe under the nav
 * (and optionally tinge link underlines, header accents, etc. when
 * the active theme opts to reference them).
 *
 * Brand is host-supplied (passed to pict-section-theme.install() as
 * `Brand: {...}` or applied later via this module's `applyBrand()`)
 * and NOT user-pickable — it's the app's wordmark. It's also not
 * persisted; the host config drives it on every boot.
 *
 * # Brand shape
 *
 * Two equivalent forms — pick whichever reads better in your app.
 *
 * ## Recommended: nested form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:   { Light: '#0044cc', Dark: '#6b8eff' },   // both required
 *       Secondary: { Light: '#c75033', Dark: '#ff8a6b' }    // both required
 *     },
 *     Tagline: 'Optional short tagline'
 *   }
 *
 * This mirrors how theme JSONs already structure their Tokens.Color.*
 * trees, makes the "explicit light + dark variants" contract obvious,
 * and means your brand and your theme look consistent in source.
 *
 * ## Legacy: flat form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:        '#0066ff',                // required
 *       Secondary:      '#ff6600',                // required
 *       PrimaryLight:   '#3388ff',                // optional, light-mode tint
 *       PrimaryDark:    '#0044cc',                // optional, dark-mode tint
 *       SecondaryLight: '#ff8833',
 *       SecondaryDark:  '#cc4400'
 *     }
 *   }
 *
 * The flat form's `Primary` / `Secondary` are mode-agnostic constants
 * (used for the `--brand-color-primary` / `-secondary` CSS variables);
 * the *Light / *Dark fields drive the mode-aware variants. When the
 * Light / Dark fields are omitted, the base Primary / Secondary
 * doubles for both modes. Both forms land on the same six output CSS
 * variables — see "CSS variables emitted" below.
 *
 * Icon shape: inline SVG markup, OR a data URL, OR a remote / app-served
 * URL. IconType is optional and auto-detected from the value.
 *
 * # CSS variables emitted
 *
 *   :root {
 *     --brand-color-primary:           <Primary>
 *     --brand-color-secondary:         <Secondary>
 *     --brand-color-primary-light:     <PrimaryLight or Primary>
 *     --brand-color-primary-dark:      <PrimaryDark or Primary>
 *     --brand-color-secondary-light:   <SecondaryLight or Secondary>
 *     --brand-color-secondary-dark:    <SecondaryDark or Secondary>
 *     --brand-color-primary-mode:      <Primary OR PrimaryLight in :root>
 *     --brand-color-secondary-mode:    <Secondary OR SecondaryLight in :root>
 *     --brand-name:                    "<Name>"
 *   }
 *   .theme-dark {
 *     --brand-color-primary-mode:      <PrimaryDark or Primary>
 *     --brand-color-secondary-mode:    <SecondaryDark or Secondary>
 *   }
 *
 * The `*-mode` variables are the ones theme/host CSS should reach for
 * when they want a brand color that automatically swaps for dark mode
 * (parallel to how --theme-color-* works). The plain Primary/Secondary
 * are constants that ignore the mode toggle — useful for the brand
 * stripe itself, where the brand should look the same in both modes.
 *
 * # Listener pattern
 *
 * Mirrors Theme-Scale: subscribe via `onBrandChange(cb)`, dispose by
 * calling the returned function. The BrandStrip view uses this to
 * re-render when the host changes brand at runtime (rare, but used by
 * test harnesses + multi-tenant hosts).
 */

const STYLE_ELEMENT_ID = 'pict-brand';
const FAVICON_LINK_ID = 'pict-brand-favicon';
const FAVICON_DARK_LINK_ID = 'pict-brand-favicon-dark';

let _activeBrand = null;
let _listeners = [];

function _isInlineSVG(pIcon)
{
	return (typeof pIcon === 'string') && /^\s*<svg[\s>]/i.test(pIcon);
}

function _isImageURL(pIcon)
{
	if (typeof pIcon !== 'string') return false;
	return /^(data:|https?:|\/|\.\.?\/)/.test(pIcon);
}

function _detectIconType(pBrand)
{
	if (pBrand && typeof pBrand.IconType === 'string') return pBrand.IconType;
	if (!pBrand || !pBrand.Icon) return null;
	if (_isInlineSVG(pBrand.Icon)) return 'svg';
	if (_isImageURL(pBrand.Icon)) return 'image';
	return null;
}

// Resolve a "color slot" to { Light, Dark, Base } regardless of input
// shape. Supported inputs:
//   - "string"                        → all three equal that string
//   - { Light, Dark }                 → Base = Light, others as given
//   - { Light, Dark, Base }           → Base explicit
//   - missing                         → null (caller decides how to fail)
function _resolveColorSlot(pSlot)
{
	if (typeof pSlot === 'string' && pSlot.length > 0)
	{
		return { Light: pSlot, Dark: pSlot, Base: pSlot };
	}
	if (pSlot && typeof pSlot === 'object')
	{
		let tmpLight = (typeof pSlot.Light === 'string' && pSlot.Light.length > 0) ? pSlot.Light : null;
		let tmpDark  = (typeof pSlot.Dark  === 'string' && pSlot.Dark.length  > 0) ? pSlot.Dark  : null;
		// Need at least one variant present.
		if (!tmpLight && !tmpDark) return null;
		// Fill missing variant from the other side. Base defaults to
		// the light variant (matches the legacy flat-form semantics).
		tmpLight = tmpLight || tmpDark;
		tmpDark  = tmpDark  || tmpLight;
		let tmpBase = (typeof pSlot.Base === 'string' && pSlot.Base.length > 0) ? pSlot.Base : tmpLight;
		return { Light: tmpLight, Dark: tmpDark, Base: tmpBase };
	}
	return null;
}

function _normalize(pBrand)
{
	if (!pBrand || typeof pBrand !== 'object') return null;
	let tmpColors = pBrand.Colors || {};

	// Brand colors accept TWO forms — flat or nested:
	//
	//   FLAT (legacy):
	//     Colors: {
	//       Primary:        '#e54b1e',     // required (the mode-agnostic value)
	//       Secondary:      '#1e9aa0',     // required
	//       PrimaryLight:   '#e54b1e',     // optional fallback to Primary
	//       PrimaryDark:    '#ff7a4a',     // optional fallback to Primary
	//       SecondaryLight: '#1e9aa0',     // optional fallback to Secondary
	//       SecondaryDark:  '#5fc5cb'      // optional fallback to Secondary
	//     }
	//
	//   NESTED (recommended):
	//     Colors: {
	//       Primary:   { Light: '#e54b1e', Dark: '#ff7a4a' },  // both required
	//       Secondary: { Light: '#1e9aa0', Dark: '#5fc5cb' }   // both required
	//     }
	//
	// The nested form mirrors how themes already structure their
	// Tokens.Color.* trees and makes the "this brand needs explicit
	// light + dark variants" contract obvious. Either form lands on
	// the same six --brand-color-* CSS variables.
	let tmpPriSlot = _resolveColorSlot(tmpColors.Primary);
	let tmpSecSlot = _resolveColorSlot(tmpColors.Secondary);
	if (!tmpPriSlot || !tmpSecSlot) return null;

	// Legacy flat-form fields override the resolved slot's Light/Dark
	// (so a host passing both forms gets the most explicit one).
	let tmpPriLight = tmpColors.PrimaryLight   || tmpPriSlot.Light;
	let tmpPriDark  = tmpColors.PrimaryDark    || tmpPriSlot.Dark;
	let tmpSecLight = tmpColors.SecondaryLight || tmpSecSlot.Light;
	let tmpSecDark  = tmpColors.SecondaryDark  || tmpSecSlot.Dark;

	return {
		Hash:    pBrand.Hash || 'brand',
		Name:    pBrand.Name || pBrand.Hash || 'Brand',
		Icon:    pBrand.Icon || null,
		IconType: _detectIconType(pBrand),
		Tagline: (typeof pBrand.Tagline === 'string') ? pBrand.Tagline : null,
		// Optional favicon assets. Each can be: inline `<svg>` markup, a
		// data URL, or a regular URL. When both Favicon and FaviconDark
		// are supplied, paired light/dark <link rel="icon"> tags are
		// emitted with prefers-color-scheme media queries; otherwise a
		// single <link> covers both modes.
		Favicon:     pBrand.Favicon     || null,
		FaviconDark: pBrand.FaviconDark || null,
		Colors:
		{
			Primary:        tmpPriSlot.Base,
			Secondary:      tmpSecSlot.Base,
			PrimaryLight:   tmpPriLight,
			PrimaryDark:    tmpPriDark,
			SecondaryLight: tmpSecLight,
			SecondaryDark:  tmpSecDark
		}
	};
}

// Encode an inline `<svg>` blob into a data URL safe for an <img src> /
// <link href> attribute. Falls through if the input already looks like
// a URL (data:, http:, /, ./, ../).
function _faviconHref(pIcon)
{
	if (!pIcon || typeof pIcon !== 'string') return null;
	if (_isInlineSVG(pIcon))
	{
		// percent-encode SVG markup. Don't encode '#' or '&' minimally;
		// the safe path is to encode aggressively then unescape spaces.
		let tmpEncoded = encodeURIComponent(pIcon).replace(/'/g, '%27').replace(/"/g, '%22');
		return 'data:image/svg+xml;charset=utf-8,' + tmpEncoded;
	}
	if (_isImageURL(pIcon)) return pIcon;
	return null;
}

function _removeFaviconLinks()
{
	if (typeof document === 'undefined') return;
	[FAVICON_LINK_ID, FAVICON_DARK_LINK_ID].forEach((pID) =>
	{
		let tmpEl = document.getElementById(pID);
		if (tmpEl && tmpEl.parentNode) tmpEl.parentNode.removeChild(tmpEl);
	});
}

function _injectFaviconLinks(pBrand)
{
	if (typeof document === 'undefined') return;
	_removeFaviconLinks();

	let tmpLight = _faviconHref(pBrand.Favicon);
	let tmpDark  = _faviconHref(pBrand.FaviconDark);
	if (!tmpLight && !tmpDark) return;

	let tmpHasPair = !!(tmpLight && tmpDark);

	if (tmpLight)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpLight;
		if (/^data:image\/svg\+xml/.test(tmpLight)) tmpLink.type = 'image/svg+xml';
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: light)';
		document.head.appendChild(tmpLink);
	}

	if (tmpDark)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_DARK_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpDark;
		if (/^data:image\/svg\+xml/.test(tmpDark)) tmpLink.type = 'image/svg+xml';
		// If we have a light variant, the dark link's media query handles
		// the swap; otherwise it serves both modes.
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: dark)';
		document.head.appendChild(tmpLink);
	}
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

// Escape so the brand name can ride along inside the CSS `content`-style
// `--brand-name` value as a quoted string.
function _cssQuote(pStr)
{
	return '"' + String(pStr || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
}

function _buildCSS(pBrand)
{
	let tmpC = pBrand.Colors;
	let tmpRoot = ':root {\n'
		+ '\t--brand-color-primary:         ' + tmpC.Primary + ';\n'
		+ '\t--brand-color-secondary:       ' + tmpC.Secondary + ';\n'
		+ '\t--brand-color-primary-light:   ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-primary-dark:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-light: ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-color-secondary-dark:  ' + tmpC.SecondaryDark + ';\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-name:                  ' + _cssQuote(pBrand.Name) + ';\n'
		+ '}\n';
	// Dark-mode overrides for the *-mode variables only.
	let tmpDark = '.theme-dark {\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryDark + ';\n'
		+ '}\n';
	return tmpRoot + tmpDark;
}

/**
 * Apply (or replace) the active brand. Pass `null` to clear.
 *
 * @param {object|null} pBrand
 * @returns {object|null} the normalized active brand (or null on clear)
 */
function applyBrand(pBrand)
{
	let tmpPrev = _activeBrand;

	if (pBrand === null)
	{
		_activeBrand = null;
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
		}
		_removeFaviconLinks();
		_fireChange(null, tmpPrev);
		return null;
	}

	let tmpNorm = _normalize(pBrand);
	if (!tmpNorm)
	{
		// Bad input — keep current brand, no-op.
		if (typeof console !== 'undefined' && console.warn)
		{
			console.warn('Theme-Brand.applyBrand: bad brand object — needs Colors.Primary + Colors.Secondary as strings.');
		}
		return _activeBrand;
	}

	_activeBrand = tmpNorm;
	_injectStyleElement(_buildCSS(tmpNorm));
	_injectFaviconLinks(tmpNorm);
	_fireChange(tmpNorm, tmpPrev);
	return tmpNorm;
}

function getActive()
{
	return _activeBrand;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNew, pOld)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNew, pOld); }
		catch (pErr) { /* swallow — listener failure must not break callers */ }
	}
}

/**
 * Reset to no-brand state and detach the injected style. Tests use this;
 * runtime hosts rarely need it.
 */
function reset()
{
	applyBrand(null);
	_listeners = [];
}

module.exports =
{
	applyBrand:      applyBrand,
	getActive:       getActive,
	onChange:        onChange,
	offChange:       offChange,
	reset:           reset,
	STYLE_ELEMENT_ID:      STYLE_ELEMENT_ID,
	FAVICON_LINK_ID:       FAVICON_LINK_ID,
	FAVICON_DARK_LINK_ID:  FAVICON_DARK_LINK_ID
};

},{}],31:[function(require,module,exports){
/**
 * Theme-Icons — single source of truth for the inline SVG glyphs the
 * theme section uses (sun, moon, system / monitor, plus a chevron for
 * dropdown triggers).
 *
 * Every icon:
 *   - Is a self-contained SVG string suitable for direct DOM insertion
 *     (innerHTML, template substitution, or pict-section-modal's
 *     `Icon: <html>` field on dropdown items).
 *   - Uses `currentColor` for stroke so it picks up the surrounding
 *     text colour from the active theme (light + dark both look right
 *     without per-mode swaps).
 *   - Has `aria-hidden="true"` so screen readers ignore the decorative
 *     glyph and rely on the surrounding label / aria-label instead.
 *
 * The shapes are intentionally line-art (stroke-based, fill="none") so
 * they read at very small sizes (12–16 px) without going muddy. The
 * "system" icon is a stylised display (rectangle + stand) rather than
 * the unicode 🖥 to keep visual weight consistent with sun + moon.
 *
 * Need a different size? Pass `pSizePx` to any of the iconXxx() helpers
 * and the wrapper SVG's width/height are emitted with that value. The
 * default is 14 px which matches the mode toggle's existing visual.
 */

const _DEFAULT_SIZE_PX = 14;

function _wrap(pSizePx, pInner)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	return '<svg class="pict-theme-icon"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 24 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ pInner
		+ '</svg>';
}

/**
 * Sun glyph — central disc + 8 radial rays. Communicates "light mode"
 * universally. Slightly chunkier disc than the typical Feather sun so
 * it still reads at 12 px.
 */
function iconSun(pSizePx)
{
	return _wrap(pSizePx,
		'<circle cx="12" cy="12" r="4"/>'
		+ '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>');
}

/**
 * Moon glyph — clean crescent (one continuous filled-look path drawn
 * as a stroke). Avoids the brittle thin-crescent unicode characters
 * that fall back to weird outline glyphs in some system fonts.
 */
function iconMoon(pSizePx)
{
	return _wrap(pSizePx,
		'<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>');
}

/**
 * System / display glyph — a small monitor with a stand. Communicates
 * "follow the OS preference" without ambiguity (a monitor is universal
 * UI for system settings, more than the gear icon would be).
 */
function iconSystem(pSizePx)
{
	return _wrap(pSizePx,
		'<rect x="2" y="4" width="20" height="14" rx="2"/>'
		+ '<path d="M8 21h8M12 18v3"/>');
}

/**
 * Composite: a sun + moon side-by-side, sized so the two icons fit in
 * the same horizontal footprint as a single icon. Used in the picker
 * to indicate a paired (Light + Dark) theme without needing two
 * separate visual columns.
 */
function iconPaired(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	// Each half uses currentColor; the sun is rendered slightly smaller
	// in the left half and the moon in the right half by abusing the
	// viewBox width.
	return '<svg class="pict-theme-icon pict-theme-icon-paired"'
		+ ' width="' + (tmpSize * 1.6) + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 38 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		// Sun on the left (centred at 8,12, radius 3)
		+ '<circle cx="8" cy="12" r="3"/>'
		+ '<path d="M8 4v1.5M8 18.5V20M2.5 12H4M12 12h1.5M4.1 7.1l1 1M11.1 7.1l-1 1M4.1 16.9l1-1M11.1 16.9l-1-1"/>'
		// Moon on the right (mirrored crescent, centred near x=28)
		+ '<path d="M33 13.5A6.5 6.5 0 1 1 26 6a5 5 0 0 0 7 7.5z"/>'
		+ '</svg>';
}

/**
 * Down-chevron used by dropdown triggers. Sized to sit alongside body
 * text (10 px default).
 */
function iconChevronDown(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : 10;
	return '<svg class="pict-theme-icon pict-theme-icon-chevron"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 12 12" fill="none"'
		+ ' stroke="currentColor" stroke-width="1.6"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ '<path d="M3 4.5l3 3 3-3"/>'
		+ '</svg>';
}

/**
 * Pick the right capability icon for a theme based on its mode strategy.
 * Returns the composite paired glyph for paired themes, sun for light-only,
 * moon for dark-only.
 *
 * @param {string} pStrategy - 'single' or 'system'/'paired'
 * @param {string} pDefaultMode - 'light' or 'dark' (only consulted for single)
 * @param {number} [pSizePx]
 */
function iconForTheme(pStrategy, pDefaultMode, pSizePx)
{
	if (pStrategy === 'single')
	{
		return (pDefaultMode === 'dark') ? iconMoon(pSizePx) : iconSun(pSizePx);
	}
	return iconPaired(pSizePx);
}

module.exports =
{
	iconSun:         iconSun,
	iconMoon:        iconMoon,
	iconSystem:      iconSystem,
	iconPaired:      iconPaired,
	iconChevronDown: iconChevronDown,
	iconForTheme:    iconForTheme,
	DEFAULT_SIZE_PX: _DEFAULT_SIZE_PX
};

},{}],32:[function(require,module,exports){
/**
 * Theme-Persistence — reads and writes the user's selected theme + mode
 * to the browser's localStorage so a reload restores the same look.
 *
 * pict-provider-theme is intentionally stateless — host applications
 * decide what to apply at boot. This module is the small, opt-out-able
 * layer that pict-section-theme.install() uses to make "remember my
 * theme" the default behaviour without forcing every consumer to wire
 * it themselves.
 *
 * # Storage shape
 *
 * Every entry is a single JSON object under one key:
 *
 *   localStorage["pict-section-theme:<scope>"] =
 *     {
 *       Version:   1,
 *       ThemeHash: "retold-manager",
 *       Mode:      "dark",
 *       Scale:     1.25,
 *       SavedAt:   "2026-05-09T21:00:00.000Z"
 *     }
 *
 * Version-tagged so future schema changes can be migrated cleanly;
 * mismatched versions are treated as "no saved entry" and the host
 * application's defaults take over. Older entries that pre-date the
 * Scale field are still valid — Scale is optional and load() returns
 * null for it when absent (caller defaults to 1.0).
 *
 * # Scope (the <scope> portion of the key)
 *
 * Determined in this priority order:
 *   1. The string the host passed in (`PersistenceKey: 'my-app'`) —
 *      use this when one host serves multiple logical apps from the
 *      same origin and they shouldn't share theme state.
 *   2. window.location.hostname when running in a browser.
 *   3. The literal 'default' as a last-ditch fallback (Node, sandbox,
 *      mid-SSR, etc.).
 *
 * # Failure modes
 *
 * - localStorage missing (SSR, Safari private mode, blocked) →
 *   load() returns null, save() returns false, no exception.
 * - Quota exceeded → save() returns false silently; the in-memory
 *   active theme is unaffected.
 * - JSON parse error or version mismatch → load() returns null so the
 *   caller falls back to ApplyDefault.
 *
 * Nothing here throws — persistence failures must NEVER crash the host
 * application's boot path.
 */

const STORAGE_PREFIX = 'pict-section-theme:';
const SCHEMA_VERSION = 1;

function _getStorage()
{
	try
	{
		if (typeof window !== 'undefined' && window.localStorage)
		{
			return window.localStorage;
		}
	}
	catch (pErr) { /* SecurityError in some contexts */ }
	return null;
}

function _autoScope()
{
	try
	{
		if (typeof window !== 'undefined' && window.location && window.location.hostname)
		{
			return window.location.hostname;
		}
	}
	catch (pErr) { /* fall through */ }
	return 'default';
}

/**
 * Resolve the full localStorage key for this app's theme state.
 *
 * @param {string|null} pUserKey - Host-supplied scope override; falsy
 *   values trigger the auto-scope fallback (hostname → 'default').
 * @returns {string} the fully-qualified localStorage key.
 */
function resolveKey(pUserKey)
{
	let tmpScope = (typeof pUserKey === 'string' && pUserKey.length > 0)
		? pUserKey
		: _autoScope();
	return STORAGE_PREFIX + tmpScope;
}

/**
 * Read the saved theme state for a key.  Returns null if nothing is
 * stored, the storage is unavailable, or the entry's schema version
 * doesn't match.
 *
 * @param {string} pKey - the resolved storage key
 * @returns {{ThemeHash: string, Mode: string|null, Scale: number|null}|null}
 */
function load(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return null;

	let tmpRaw;
	try { tmpRaw = tmpStore.getItem(pKey); }
	catch (pErr) { return null; }
	if (!tmpRaw) return null;

	let tmpParsed;
	try { tmpParsed = JSON.parse(tmpRaw); }
	catch (pErr) { return null; }

	if (!tmpParsed || typeof tmpParsed !== 'object') return null;
	if (tmpParsed.Version !== SCHEMA_VERSION) return null;
	if (typeof tmpParsed.ThemeHash !== 'string' || tmpParsed.ThemeHash.length === 0) return null;

	let tmpScale = null;
	if (typeof tmpParsed.Scale === 'number' && isFinite(tmpParsed.Scale) && tmpParsed.Scale > 0)
	{
		tmpScale = tmpParsed.Scale;
	}

	return {
		ThemeHash: tmpParsed.ThemeHash,
		Mode:      (typeof tmpParsed.Mode === 'string' && tmpParsed.Mode.length > 0)
			? tmpParsed.Mode
			: null,
		Scale:     tmpScale
	};
}

/**
 * Persist the active theme + mode for this key.  No-ops gracefully
 * when storage is unavailable or quota is exceeded.
 *
 * @param {string} pKey
 * @param {{ThemeHash: string, Mode?: string, Scale?: number}} pState
 * @returns {boolean} true on success, false otherwise
 */
function save(pKey, pState)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	if (!pState || typeof pState.ThemeHash !== 'string' || pState.ThemeHash.length === 0) return false;

	let tmpEntry =
	{
		Version:   SCHEMA_VERSION,
		ThemeHash: pState.ThemeHash,
		Mode:      (typeof pState.Mode === 'string' && pState.Mode.length > 0) ? pState.Mode : null,
		Scale:     (typeof pState.Scale === 'number' && isFinite(pState.Scale) && pState.Scale > 0)
			? pState.Scale
			: null,
		SavedAt:   new Date().toISOString()
	};

	try { tmpStore.setItem(pKey, JSON.stringify(tmpEntry)); return true; }
	catch (pErr) { return false; }
}

/**
 * Remove the saved theme state for a key.  Useful for "reset to
 * defaults" actions.
 */
function clear(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	try { tmpStore.removeItem(pKey); return true; }
	catch (pErr) { return false; }
}

module.exports =
{
	resolveKey: resolveKey,
	load:       load,
	save:       save,
	clear:      clear,
	STORAGE_PREFIX: STORAGE_PREFIX,
	SCHEMA_VERSION: SCHEMA_VERSION
};

},{}],33:[function(require,module,exports){
/**
 * Theme-Scale — viewport scale (zoom) selector independent of theme bundles.
 *
 * Scale is a *user preference*, not a property of any particular theme:
 * the user might want Cyberpunk-at-1.25x or Retold-Manager-at-0.85x.
 * Pict-provider-theme is intentionally bundle-shaped (Tokens / SVG /
 * Image), so scale lives here at the section layer alongside Mode.
 *
 * # Apply mechanism
 *
 * Two outputs feed cooperating CSS:
 *
 *   1. `html { zoom: <scale>; }` — works for legacy stylesheets that
 *      use `px` everywhere (most Retold apps including retold-manager).
 *      Browsers (Chromium-based + Firefox 126+ + Safari) all honour
 *      `zoom` on root.
 *
 *   2. `:root { --theme-scale: <scale>; }` — exposed for stylesheets
 *      that want to opt into explicit `calc(... * var(--theme-scale))`
 *      sizing. Keeps the value addressable from JS too via
 *      `getComputedStyle(document.documentElement).getPropertyValue(...)`.
 *
 * Both are written into a single `<style id="pict-theme-scale">` element
 * appended to `<head>` after the theme provider's own style element so
 * scale wins last. Re-applying just rewrites this one element's text.
 *
 * # Listener pattern
 *
 * Mirrors pict-provider-theme.onApply(): subscribers receive the new
 * scale value plus the previous value and a return-able `dispose`
 * function. The persistence wiring in pict-section-theme.install()
 * uses this to autosave whenever the scale changes.
 *
 * # Stateless across instances
 *
 * No singleton state — each browser window has one DOM, so the module
 * tracks active scale via a module-level variable, but exposes
 * `getActive()` for callers that want to query it. `applyScale()` is
 * idempotent: applying the same value re-injects the same CSS (cheap
 * no-op).
 */

const STYLE_ELEMENT_ID = 'pict-theme-scale';
const CSS_VAR_NAME = '--theme-scale';
const DEFAULT_SCALE = 1.0;
const MIN_SCALE = 0.5;
const MAX_SCALE = 3.0;

// Curated list of presets. Hosts that want a different range can pass
// a custom `Presets` array to the ScaleSelect view; this default covers
// the readability common cases without overwhelming the dropdown.
const PRESETS =
[
	{ Value: 0.75, Label: 'Tiny (75%)' },
	{ Value: 0.85, Label: 'Small (85%)' },
	{ Value: 1.00, Label: 'Default (100%)' },
	{ Value: 1.15, Label: 'Comfortable (115%)' },
	{ Value: 1.25, Label: 'Large (125%)' },
	{ Value: 1.50, Label: 'Huge (150%)' },
	{ Value: 1.75, Label: 'Extra Huge (175%)' },
	{ Value: 2.00, Label: 'Massive (200%)' }
];

let _activeScale = DEFAULT_SCALE;
let _listeners = [];

function _clamp(pValue)
{
	let tmpNum = Number(pValue);
	if (!isFinite(tmpNum) || tmpNum <= 0) return DEFAULT_SCALE;
	if (tmpNum < MIN_SCALE) return MIN_SCALE;
	if (tmpNum > MAX_SCALE) return MAX_SCALE;
	return tmpNum;
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

function _buildCSS(pScale)
{
	// `zoom` on <html> scales everything (px + rem + layout). The
	// `--theme-scale` custom property exposes the same value to any CSS
	// that wants to react explicitly via calc().
	return ':root {\n'
		+ '\t' + CSS_VAR_NAME + ': ' + pScale + ';\n'
		+ '}\n'
		+ 'html {\n'
		+ '\tzoom: ' + pScale + ';\n'
		+ '}\n';
}

/**
 * Apply a viewport scale.
 *
 * @param {number} pScale - desired multiplier (e.g. 1.0, 1.25). Values
 *   outside [MIN_SCALE, MAX_SCALE] are clamped; non-finite values
 *   reset to DEFAULT_SCALE.
 * @returns {number} the actually-applied scale (after clamping).
 */
function applyScale(pScale)
{
	let tmpPrev = _activeScale;
	let tmpNext = _clamp(pScale);
	_activeScale = tmpNext;
	_injectStyleElement(_buildCSS(tmpNext));
	if (tmpPrev !== tmpNext) { _fireChange(tmpNext, tmpPrev); }
	return tmpNext;
}

function getActive()
{
	return _activeScale;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNewScale, pOldScale)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNewScale, pOldScale); }
		catch (pErr) { /* listener failures must not break callers */ }
	}
}

/**
 * Reset to default scale and remove the injected style element. Useful
 * for tests + "reset to defaults" affordances.
 */
function reset()
{
	_activeScale = DEFAULT_SCALE;
	if (typeof document !== 'undefined')
	{
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
	}
	_listeners = [];
}

module.exports =
{
	applyScale: applyScale,
	getActive:  getActive,
	onChange:   onChange,
	offChange:  offChange,
	reset:      reset,

	PRESETS:        PRESETS,
	DEFAULT_SCALE:  DEFAULT_SCALE,
	MIN_SCALE:      MIN_SCALE,
	MAX_SCALE:      MAX_SCALE,
	STYLE_ELEMENT_ID: STYLE_ELEMENT_ID,
	CSS_VAR_NAME:     CSS_VAR_NAME
};

},{}],34:[function(require,module,exports){
module.exports={
	"Hash": "1970s-console",
	"Name": "1970s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Amber phosphor on brown-black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A1000",
				"Secondary": "#140C00",
				"Tertiary": "#1E1400",
				"Panel": "#1C1200",
				"Viewer": "#100A00",
				"Hover": "#2A1C00",
				"Selected": "#3A2800",
				"Thumb": "#140C00"
			},
			"Text": {
				"Primary": "#FFAA00",
				"Secondary": "#DD8800",
				"Muted": "#AA6600",
				"Dim": "#884400",
				"Placeholder": "#663300"
			},
			"Brand": {
				"Accent": "#FFCC00",
				"AccentHover": "#FFDD44"
			},
			"Border": {
				"Default": "#2A1800",
				"Light": "#3A2200"
			},
			"Status": {
				"Danger": "#FF4400",
				"DangerMuted": "#AA3300"
			},
			"Scrollbar": {
				"Track": "#2A1800",
				"Hover": "#3A2800"
			},
			"Selection": {
				"Background": "rgba(255, 204, 0, 0.2)"
			},
			"Focus": {
				"Outline": "#FFCC00"
			},
			"Syntax": {
				"Keyword":     "#FFB000",
				"String":      "#FFD080",
				"Number":      "#FFB000",
				"Comment":     "#806020",
				"Operator":    "#FFB000",
				"Punctuation": "#FFD080",
				"Function":    "#FFB000",
				"Variable":    "#FFE090",
				"Type":        "#FFB000",
				"Builtin":     "#FFB000",
				"Property":    "#FF6E40",
				"Tag":         "#FF6E40",
				"AttrName":    "#FFB000",
				"AttrValue":   "#FFD080"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', 'Lucida Console', monospace",
				"Mono": "'Courier New', 'Lucida Console', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#DD8800",
		"Accent": "#FFCC00",
		"Muted": "#884400",
		"Light": "#1E1400",
		"WarmBeige": "#201800",
		"TealTint": "#1A1000",
		"Lavender": "#1C1200",
		"AmberTint": "#221800",
		"PdfFill": "#201000",
		"PdfText": "#FF4400"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.405Z",
	"CompilerVersion": 1
}
},{}],35:[function(require,module,exports){
module.exports={
	"Hash": "1980s-console",
	"Name": "1980s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Green phosphor on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#001200",
				"Secondary": "#000E00",
				"Tertiary": "#001600",
				"Panel": "#001400",
				"Viewer": "#000A00",
				"Hover": "#002200",
				"Selected": "#003800",
				"Thumb": "#000E00"
			},
			"Text": {
				"Primary": "#00FF00",
				"Secondary": "#00CC00",
				"Muted": "#009900",
				"Dim": "#006600",
				"Placeholder": "#004400"
			},
			"Brand": {
				"Accent": "#00FF66",
				"AccentHover": "#44FF88"
			},
			"Border": {
				"Default": "#002A00",
				"Light": "#003A00"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#AA0000"
			},
			"Scrollbar": {
				"Track": "#002A00",
				"Hover": "#004400"
			},
			"Selection": {
				"Background": "rgba(0, 255, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF66"
			},
			"Syntax": {
				"Keyword":     "#00FF00",
				"String":      "#90FF90",
				"Number":      "#FFFF00",
				"Comment":     "#208020",
				"Operator":    "#00FF00",
				"Punctuation": "#90FF90",
				"Function":    "#00FF00",
				"Variable":    "#C0FFC0",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF4040",
				"Tag":         "#FF4040",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#90FF90"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#00CC00",
		"Accent": "#00FF66",
		"Muted": "#006600",
		"Light": "#001600",
		"WarmBeige": "#001A00",
		"TealTint": "#001200",
		"Lavender": "#001400",
		"AmberTint": "#001800",
		"PdfFill": "#140000",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],36:[function(require,module,exports){
module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Web Site",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Blue links on grey, beveled Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#C0C0C0",
				"Secondary": "#B0B0B0",
				"Tertiary": "#A8A8A8",
				"Panel": "#B8B8B8",
				"Viewer": "#D0D0D0",
				"Hover": "#B8B8D0",
				"Selected": "#000080",
				"Thumb": "#B0B0B0"
			},
			"Text": {
				"Primary": "#000000",
				"Secondary": "#000080",
				"Muted": "#404040",
				"Dim": "#606060",
				"Placeholder": "#808080"
			},
			"Brand": {
				"Accent": "#0000FF",
				"AccentHover": "#0000CC"
			},
			"Border": {
				"Default": "#808080",
				"Light": "#A0A0A0"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#990000"
			},
			"Scrollbar": {
				"Track": "#808080",
				"Hover": "#606060"
			},
			"Selection": {
				"Background": "rgba(0, 0, 128, 0.3)"
			},
			"Focus": {
				"Outline": "#0000FF"
			},
			"Syntax": {
				"Keyword":     "#0000FF",
				"String":      "#008000",
				"Number":      "#A52A2A",
				"Comment":     "#808080",
				"Operator":    "#000080",
				"Punctuation": "#000000",
				"Function":    "#0000A0",
				"Variable":    "#000000",
				"Type":        "#A52A2A",
				"Builtin":     "#A52A2A",
				"Property":    "#800080",
				"Tag":         "#800080",
				"AttrName":    "#A52A2A",
				"AttrValue":   "#008000"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Times New Roman', Times, serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#000080",
		"Accent": "#0000FF",
		"Muted": "#606060",
		"Light": "#A8A8A8",
		"WarmBeige": "#B0B0B0",
		"TealTint": "#A0A0A0",
		"Lavender": "#ABABD0",
		"AmberTint": "#B8B0A0",
		"PdfFill": "#C0A0A0",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],37:[function(require,module,exports){
/**
 * Theme Registry — runtime registry of every theme available to
 * pict-section-theme.
 *
 * Bundled "starter set" themes are pre-registered at module load time
 * via static `require()` so browserify can resolve and inline each JSON
 * at bundle time. Beyond the starter set, consumers can register
 * additional theme bundles at runtime — useful for:
 *
 *   - Loading themes the host app authored (e.g. an app's own brand
 *     palette that isn't shipped with this module).
 *   - Pulling themes from a remote "theme garden" via
 *     `registerFromURL()` (CDN-hosted curated bundles).
 *   - Tooling / playgrounds that mutate the registry as the user
 *     iterates.
 *
 * Module exports a singleton instance, so all consumers operate on the
 * same set. Use `register({Hash, Bundle, Category, IsDefault})` to add
 * themes, `list()` to enumerate them, `get(hash)` for direct lookup,
 * `unregister(hash)` to remove.
 *
 * Each entry shape:
 *
 *   {
 *     Hash:       <string>      // matches bundle.Hash; used by the picker
 *     Bundle:     <object>      // theme JSON, ready for provider.registerTheme()
 *     Category:   <string>      // grouping label for the picker UI
 *     IsDefault:  <bool?>       // true for the canonical ecosystem default
 *     Source:     <string?>     // 'starter' | URL | host-supplied tag
 *   }
 *
 * Backwards-compat:
 *   - The instance is iterable (Symbol.iterator), exposes `.length`,
 *     and supports numeric indexing `[i]` so legacy code that treated
 *     the catalog as an array continues to work without changes.
 */
'use strict';

class ThemeRegistry
{
	constructor()
	{
		this._themes = new Map();      // Hash → entry, insertion-ordered
		this._loadStarterSet();
	}

	// ── Bundled starter set ──────────────────────────────────────────────
	// Each `require()` is a literal string so browserify inlines the JSON
	// at build time. Adding a new bundled theme: drop the JSON in this
	// folder and append a row here. Runtime additions go via register()
	// from anywhere else in the codebase.
	_loadStarterSet()
	{
		const STARTER =
		[
			// Retold ecosystem defaults
			{ Hash: 'retold-default',     Category: 'Default',  IsDefault: true,  Bundle: require('./retold-default.json') },
			{ Hash: 'retold-mono',        Category: 'Default',  Bundle: require('./retold-mono.json') },

			// App-extracted themes (named after their host app)
			{ Hash: 'retold-manager',         Category: 'App',  Bundle: require('./retold-manager.json') },
			{ Hash: 'retold-content-system',  Category: 'App',  Bundle: require('./retold-content-system.json') },

			// Playground / starter paired themes (have light/dark)
			{ Hash: 'playground-corp',    Category: 'Paired',   Bundle: require('./playground-corp.json') },
			{ Hash: 'playground-starter', Category: 'Paired',   Bundle: require('./playground-starter.json') },

			// Greys (low-light single-mode themes)
			{ Hash: 'twilight',           Category: 'Grey',     Bundle: require('./twilight.json') },
			{ Hash: 'night',              Category: 'Grey',     Bundle: require('./night.json') },
			{ Hash: 'evening',            Category: 'Grey',     Bundle: require('./evening.json') },
			{ Hash: 'afternoon',          Category: 'Grey',     Bundle: require('./afternoon.json') },
			{ Hash: 'daylight',           Category: 'Grey',     Bundle: require('./daylight.json') },

			// Fun / period palettes
			{ Hash: 'cyberpunk',          Category: 'Fun',      Bundle: require('./cyberpunk.json') },
			{ Hash: 'synthwave',          Category: 'Fun',      Bundle: require('./synthwave.json') },
			{ Hash: 'neo-tokyo',          Category: 'Fun',      Bundle: require('./neo-tokyo.json') },
			{ Hash: 'solarized-dark',     Category: 'Fun',      Bundle: require('./solarized-dark.json') },
			{ Hash: 'forest',             Category: 'Fun',      Bundle: require('./forest.json') },
			{ Hash: 'hotdog',             Category: 'Fun',      Bundle: require('./hotdog.json') },
			{ Hash: '1970s-console',      Category: 'Fun',      Bundle: require('./1970s-console.json') },
			{ Hash: '1980s-console',      Category: 'Fun',      Bundle: require('./1980s-console.json') },
			{ Hash: '1990s-website',      Category: 'Fun',      Bundle: require('./1990s-website.json') },
			{ Hash: 'early-2000s',        Category: 'Fun',      Bundle: require('./early-2000s.json') },

			// Diagnostics / utility
			{ Hash: 'mobile-debug',       Category: 'Debug',    Bundle: require('./mobile-debug.json') }
		];

		for (let i = 0; i < STARTER.length; i++)
		{
			let tmpEntry = Object.assign({}, STARTER[i], { Source: STARTER[i].Source || 'starter' });
			this._themes.set(tmpEntry.Hash, tmpEntry);
		}
	}

	// ── Public API ───────────────────────────────────────────────────────

	/**
	 * Register a theme. Re-registering an existing hash overwrites cleanly.
	 *
	 * @param {{Hash, Bundle, Category?, IsDefault?, Source?}} pEntry
	 * @returns {object} the stored entry
	 */
	register(pEntry)
	{
		if (!pEntry || typeof pEntry !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry must be an object');
		}
		if (typeof pEntry.Hash !== 'string' || pEntry.Hash.length === 0)
		{
			throw new Error('ThemeRegistry.register: entry.Hash is required');
		}
		if (!pEntry.Bundle || typeof pEntry.Bundle !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry.Bundle is required');
		}
		let tmpStored = Object.assign({ Source: 'host' }, pEntry);
		this._themes.set(pEntry.Hash, tmpStored);
		return tmpStored;
	}

	/**
	 * Remove a theme by hash. Returns true if anything was removed.
	 * @param {string} pHash
	 * @returns {boolean}
	 */
	unregister(pHash)
	{
		return this._themes.delete(pHash);
	}

	/**
	 * Look up a single theme entry by hash.
	 * @param {string} pHash
	 * @returns {object|undefined}
	 */
	get(pHash)
	{
		return this._themes.get(pHash);
	}

	has(pHash)
	{
		return this._themes.has(pHash);
	}

	/**
	 * Snapshot of every registered entry, in registration order.
	 * @returns {Array<object>}
	 */
	list()
	{
		return Array.from(this._themes.values());
	}

	/**
	 * Drop every registered entry. Mostly useful in tests; production
	 * consumers should prefer `unregister()` per hash.
	 */
	clear()
	{
		this._themes.clear();
	}

	/**
	 * Re-load the bundled starter set. No-op if the starter set is
	 * already registered (re-registering replaces, so this is safe to
	 * call any time).
	 */
	loadStarterSet()
	{
		this._loadStarterSet();
	}

	/**
	 * Number of registered themes.
	 * @returns {number}
	 */
	get count()
	{
		return this._themes.size;
	}

	/**
	 * Async fetch + register from a URL. Used by the future "online theme
	 * garden" — the URL must serve a JSON bundle compatible with
	 * pict-provider-theme's `registerTheme()` shape.
	 *
	 * @param {string} pURL
	 * @param {{Category?, IsDefault?, Hash?}} [pMetadata] - override metadata
	 * @returns {Promise<object>} the registered entry
	 */
	async registerFromURL(pURL, pMetadata)
	{
		if (typeof fetch !== 'function')
		{
			throw new Error('ThemeRegistry.registerFromURL: fetch is not available in this environment');
		}
		let tmpResponse = await fetch(pURL);
		if (!tmpResponse.ok)
		{
			throw new Error('ThemeRegistry.registerFromURL: HTTP ' + tmpResponse.status + ' for ' + pURL);
		}
		let tmpBundle = await tmpResponse.json();
		if (!tmpBundle || typeof tmpBundle !== 'object' || typeof tmpBundle.Hash !== 'string')
		{
			throw new Error('ThemeRegistry.registerFromURL: payload missing Hash');
		}
		let tmpMeta = pMetadata || {};
		return this.register(
		{
			Hash: tmpMeta.Hash || tmpBundle.Hash,
			Bundle: tmpBundle,
			Category: tmpMeta.Category || 'Garden',
			IsDefault: !!tmpMeta.IsDefault,
			Source: pURL
		});
	}

	// ── Array-like compatibility ─────────────────────────────────────────
	// Older code iterated the catalog as an array (`for (let i = 0; i <
	// CATALOG.length; i++) ... CATALOG[i]`). Preserve those usages without
	// requiring a refactor: the iterator + length + numeric proxy give
	// `Array.isArray(registry)` returns false, but everything that reads
	// keeps working. New code should prefer `list()` / `get()`.

	get length()
	{
		return this._themes.size;
	}

	[Symbol.iterator]()
	{
		return this._themes.values();
	}
}

// Singleton — every consumer gets the same registry.
const _Registry = new ThemeRegistry();

// Numeric-index proxy: `registry[0]` returns the first entry, matching
// the legacy "catalog as array" shape. Wraps the singleton so existing
// `tmpEntry = _CATALOG[i]` loops keep working.
const _IndexedRegistry = new Proxy(_Registry,
{
	get(pTarget, pProp, pReceiver)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			let tmpIdx = parseInt(pProp, 10);
			let tmpList = pTarget.list();
			return tmpList[tmpIdx];
		}
		return Reflect.get(pTarget, pProp, pReceiver);
	},
	has(pTarget, pProp)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			return parseInt(pProp, 10) < pTarget.length;
		}
		return Reflect.has(pTarget, pProp);
	}
});

module.exports = _IndexedRegistry;
module.exports.ThemeRegistry = ThemeRegistry;

},{"./1970s-console.json":34,"./1980s-console.json":35,"./1990s-website.json":36,"./afternoon.json":38,"./cyberpunk.json":39,"./daylight.json":40,"./early-2000s.json":41,"./evening.json":42,"./forest.json":43,"./hotdog.json":44,"./mobile-debug.json":45,"./neo-tokyo.json":46,"./night.json":47,"./playground-corp.json":48,"./playground-starter.json":49,"./retold-content-system.json":50,"./retold-default.json":51,"./retold-manager.json":52,"./retold-mono.json":53,"./solarized-dark.json":54,"./synthwave.json":55,"./twilight.json":56}],38:[function(require,module,exports){
module.exports={
	"Hash": "afternoon",
	"Name": "Afternoon",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Warm light grey, softer contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8E4E0",
				"Secondary": "#DAD6D2",
				"Tertiary": "#D0CCC8",
				"Panel": "#DDD9D5",
				"Viewer": "#F0ECE8",
				"Hover": "#CCC8C4",
				"Selected": "#B8B4B0",
				"Thumb": "#DAD6D2"
			},
			"Text": {
				"Primary": "#2A2A2A",
				"Secondary": "#404040",
				"Muted": "#707070",
				"Dim": "#909090",
				"Placeholder": "#B0B0B0"
			},
			"Brand": {
				"Accent": "#555555",
				"AccentHover": "#333333"
			},
			"Border": {
				"Default": "#C0BCB8",
				"Light": "#D0CCC8"
			},
			"Status": {
				"Danger": "#AA3333",
				"DangerMuted": "#886655"
			},
			"Scrollbar": {
				"Track": "#B8B4B0",
				"Hover": "#A0A09C"
			},
			"Selection": {
				"Background": "rgba(85, 85, 85, 0.2)"
			},
			"Focus": {
				"Outline": "#555555"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#666666",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Georgia, 'Times New Roman', serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#404040",
		"Accent": "#555555",
		"Muted": "#909090",
		"Light": "#D0CCC8",
		"WarmBeige": "#DAD6D2",
		"TealTint": "#CCC8C4",
		"Lavender": "#D2D0CE",
		"AmberTint": "#D8D2C8",
		"PdfFill": "#D8C8C0",
		"PdfText": "#AA3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],39:[function(require,module,exports){
module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Electric green on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0E0A",
				"Secondary": "#060806",
				"Tertiary": "#0E120E",
				"Panel": "#0C100C",
				"Viewer": "#040604",
				"Hover": "#142014",
				"Selected": "#1A3A1A",
				"Thumb": "#060806"
			},
			"Text": {
				"Primary": "#C8FFC8",
				"Secondary": "#A0D8A0",
				"Muted": "#608860",
				"Dim": "#406040",
				"Placeholder": "#305030"
			},
			"Brand": {
				"Accent": "#00FF41",
				"AccentHover": "#44FF77"
			},
			"Border": {
				"Default": "#1A2A1A",
				"Light": "#224022"
			},
			"Status": {
				"Danger": "#FF3333",
				"DangerMuted": "#AA2222"
			},
			"Scrollbar": {
				"Track": "#1A2A1A",
				"Hover": "#2A4A2A"
			},
			"Selection": {
				"Background": "rgba(0, 255, 65, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF41"
			},
			"Syntax": {
				"Keyword":     "#FF00FF",
				"String":      "#00FF41",
				"Number":      "#FFFF00",
				"Comment":     "#406040",
				"Operator":    "#00FFFF",
				"Punctuation": "#A0D8A0",
				"Function":    "#FF00FF",
				"Variable":    "#C8FFC8",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF3333",
				"Tag":         "#FF3333",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#00FF41"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Lucida Console', 'Courier New', monospace",
				"Mono": "'Lucida Console', 'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#A0D8A0",
		"Accent": "#00FF41",
		"Muted": "#406040",
		"Light": "#0E120E",
		"WarmBeige": "#101610",
		"TealTint": "#0C140C",
		"Lavender": "#0E120E",
		"AmberTint": "#141810",
		"PdfFill": "#181010",
		"PdfText": "#FF3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],40:[function(require,module,exports){
module.exports={
	"Hash": "daylight",
	"Name": "Daylight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Bright white, dark text Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FFFFFF",
				"Secondary": "#F0F0F0",
				"Tertiary": "#E8E8E8",
				"Panel": "#F5F5F5",
				"Viewer": "#FAFAFA",
				"Hover": "#E0E0E0",
				"Selected": "#C8C8C8",
				"Thumb": "#F0F0F0"
			},
			"Text": {
				"Primary": "#1A1A1A",
				"Secondary": "#333333",
				"Muted": "#666666",
				"Dim": "#888888",
				"Placeholder": "#AAAAAA"
			},
			"Brand": {
				"Accent": "#444444",
				"AccentHover": "#222222"
			},
			"Border": {
				"Default": "#D0D0D0",
				"Light": "#E0E0E0"
			},
			"Status": {
				"Danger": "#CC0000",
				"DangerMuted": "#884444"
			},
			"Scrollbar": {
				"Track": "#C0C0C0",
				"Hover": "#A0A0A0"
			},
			"Selection": {
				"Background": "rgba(68, 68, 68, 0.2)"
			},
			"Focus": {
				"Outline": "#444444"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#444444",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Segoe UI', system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#333333",
		"Accent": "#444444",
		"Muted": "#888888",
		"Light": "#E8E8E8",
		"WarmBeige": "#F0F0F0",
		"TealTint": "#E0E0E0",
		"Lavender": "#EBEBEB",
		"AmberTint": "#F0EDE8",
		"PdfFill": "#F0E0E0",
		"PdfText": "#CC0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],41:[function(require,module,exports){
module.exports={
	"Hash": "early-2000s",
	"Name": "Early 2000s Web",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Teal and silver, Web 2.0 Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8F4F8",
				"Secondary": "#D0E8EE",
				"Tertiary": "#C0DDE6",
				"Panel": "#D8EEF2",
				"Viewer": "#F0F8FA",
				"Hover": "#B0D4E0",
				"Selected": "#88C4D8",
				"Thumb": "#D0E8EE"
			},
			"Text": {
				"Primary": "#1A3A4A",
				"Secondary": "#2A4A5A",
				"Muted": "#5A7A8A",
				"Dim": "#7A9AAA",
				"Placeholder": "#9ABACA"
			},
			"Brand": {
				"Accent": "#0099CC",
				"AccentHover": "#00AADD"
			},
			"Border": {
				"Default": "#A0C8D8",
				"Light": "#B8D8E4"
			},
			"Status": {
				"Danger": "#CC3300",
				"DangerMuted": "#994422"
			},
			"Scrollbar": {
				"Track": "#A0C8D8",
				"Hover": "#88B8CC"
			},
			"Selection": {
				"Background": "rgba(0, 153, 204, 0.2)"
			},
			"Focus": {
				"Outline": "#0099CC"
			},
			"Syntax": {
				"Keyword":     "#1A4080",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#333333",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Verdana, Geneva, Tahoma, sans-serif",
				"Mono": "'Lucida Console', Monaco, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#2A4A5A",
		"Accent": "#0099CC",
		"Muted": "#7A9AAA",
		"Light": "#C0DDE6",
		"WarmBeige": "#D0E8EE",
		"TealTint": "#B0D8E4",
		"Lavender": "#C8DCE6",
		"AmberTint": "#D8E0D0",
		"PdfFill": "#E0C8C0",
		"PdfText": "#CC3300"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],42:[function(require,module,exports){
module.exports={
	"Hash": "evening",
	"Name": "Evening",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Medium grey, transitional Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#484848",
				"Secondary": "#3C3C3C",
				"Tertiary": "#424242",
				"Panel": "#454545",
				"Viewer": "#363636",
				"Hover": "#525252",
				"Selected": "#606060",
				"Thumb": "#3C3C3C"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#D0D0D0",
				"Muted": "#A0A0A0",
				"Dim": "#888888",
				"Placeholder": "#707070"
			},
			"Brand": {
				"Accent": "#C0C0C0",
				"AccentHover": "#E0E0E0"
			},
			"Border": {
				"Default": "#585858",
				"Light": "#606060"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#585858",
				"Hover": "#686868"
			},
			"Selection": {
				"Background": "rgba(192, 192, 192, 0.25)"
			},
			"Focus": {
				"Outline": "#C0C0C0"
			},
			"Syntax": {
				"Keyword":     "#B894FF",
				"String":      "#A8D8B0",
				"Number":      "#FFB880",
				"Comment":     "#8A8A8A",
				"Operator":    "#7EC0FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFCC80",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB880",
				"Builtin":     "#FFB880",
				"Property":    "#FF9494",
				"Tag":         "#FF9494",
				"AttrName":    "#FFB880",
				"AttrValue":   "#A8D8B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0D0D0",
		"Accent": "#C0C0C0",
		"Muted": "#888888",
		"Light": "#424242",
		"WarmBeige": "#484848",
		"TealTint": "#3E3E3E",
		"Lavender": "#444444",
		"AmberTint": "#4A4640",
		"PdfFill": "#4A3C3C",
		"PdfText": "#FF6666"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],43:[function(require,module,exports){
module.exports={
	"Hash": "forest",
	"Name": "Forest",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Deep greens and earth browns Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A2018",
				"Secondary": "#141A12",
				"Tertiary": "#1E2620",
				"Panel": "#1C221A",
				"Viewer": "#101410",
				"Hover": "#283828",
				"Selected": "#344834",
				"Thumb": "#141A12"
			},
			"Text": {
				"Primary": "#D0DCC8",
				"Secondary": "#B0C4A8",
				"Muted": "#809878",
				"Dim": "#607858",
				"Placeholder": "#486040"
			},
			"Brand": {
				"Accent": "#6AAF5C",
				"AccentHover": "#88CC78"
			},
			"Border": {
				"Default": "#2A3A28",
				"Light": "#3A4A38"
			},
			"Status": {
				"Danger": "#CC4422",
				"DangerMuted": "#884422"
			},
			"Scrollbar": {
				"Track": "#2A3A28",
				"Hover": "#3A4A38"
			},
			"Selection": {
				"Background": "rgba(106, 175, 92, 0.25)"
			},
			"Focus": {
				"Outline": "#6AAF5C"
			},
			"Syntax": {
				"Keyword":     "#D4E157",
				"String":      "#A5D6A7",
				"Number":      "#FFB74D",
				"Comment":     "#5D6F58",
				"Operator":    "#80CBC4",
				"Punctuation": "#A8C8A0",
				"Function":    "#FFCC80",
				"Variable":    "#C8E6C9",
				"Type":        "#FFB74D",
				"Builtin":     "#FFB74D",
				"Property":    "#FF8A65",
				"Tag":         "#FF8A65",
				"AttrName":    "#FFB74D",
				"AttrValue":   "#A5D6A7"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#B0C4A8",
		"Accent": "#6AAF5C",
		"Muted": "#607858",
		"Light": "#1E2620",
		"WarmBeige": "#22281E",
		"TealTint": "#1A221A",
		"Lavender": "#1E2420",
		"AmberTint": "#262218",
		"PdfFill": "#261A18",
		"PdfText": "#CC4422"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],44:[function(require,module,exports){
module.exports={
	"Hash": "hotdog",
	"Name": "Hotdog",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Red and mustard yellow, garish Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#8B0000",
				"Secondary": "#6B0000",
				"Tertiary": "#7B0000",
				"Panel": "#750000",
				"Viewer": "#550000",
				"Hover": "#AA1111",
				"Selected": "#BB3300",
				"Thumb": "#6B0000"
			},
			"Text": {
				"Primary": "#FFD700",
				"Secondary": "#FFC000",
				"Muted": "#CC9900",
				"Dim": "#AA7700",
				"Placeholder": "#886600"
			},
			"Brand": {
				"Accent": "#FFD700",
				"AccentHover": "#FFEE44"
			},
			"Border": {
				"Default": "#AA2222",
				"Light": "#BB3333"
			},
			"Status": {
				"Danger": "#FFFF00",
				"DangerMuted": "#CCCC00"
			},
			"Scrollbar": {
				"Track": "#AA2222",
				"Hover": "#CC3333"
			},
			"Selection": {
				"Background": "rgba(255, 215, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFD700"
			},
			"Syntax": {
				"Keyword":     "#FFD800",
				"String":      "#FFFFFF",
				"Number":      "#FFD800",
				"Comment":     "#9C2828",
				"Operator":    "#FFD800",
				"Punctuation": "#FFFFFF",
				"Function":    "#FFD800",
				"Variable":    "#FFFFFF",
				"Type":        "#FFD800",
				"Builtin":     "#FFD800",
				"Property":    "#FFD800",
				"Tag":         "#FFD800",
				"AttrName":    "#FFD800",
				"AttrValue":   "#FFFFFF"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Impact, 'Arial Black', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFC000",
		"Accent": "#FFD700",
		"Muted": "#AA7700",
		"Light": "#7B0000",
		"WarmBeige": "#800000",
		"TealTint": "#6B0000",
		"Lavender": "#780000",
		"AmberTint": "#7A1000",
		"PdfFill": "#6B0000",
		"PdfText": "#FFFF00"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],45:[function(require,module,exports){
module.exports={
	"Hash": "mobile-debug",
	"Name": "Mobile Container Debug",
	"Category": "Debug",
	"Version": "0.0.1",
	"Description": "Unique color per container for layout debugging Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FF0000",
				"Secondary": "#00CCCC",
				"Tertiary": "#00AA00",
				"Panel": "#FFAA00",
				"Viewer": "#333333",
				"Hover": "rgba(255, 255, 255, 0.2)",
				"Selected": "rgba(255, 255, 255, 0.3)",
				"Thumb": "#AA00AA"
			},
			"Text": {
				"Primary": "#FFFFFF",
				"Secondary": "#EEEEEE",
				"Muted": "#CCCCCC",
				"Dim": "#AAAAAA",
				"Placeholder": "#888888"
			},
			"Brand": {
				"Accent": "#FFFF00",
				"AccentHover": "#FFFF88"
			},
			"Border": {
				"Default": "#FFFFFF",
				"Light": "#CCCCCC"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#CC4444"
			},
			"Scrollbar": {
				"Track": "#888888",
				"Hover": "#AAAAAA"
			},
			"Selection": {
				"Background": "rgba(255, 255, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFFF00"
			},
			"Syntax": {
				"Keyword":     "#A626A4",
				"String":      "#50A14F",
				"Number":      "#986801",
				"Comment":     "#A0A1A7",
				"Operator":    "#0184BC",
				"Punctuation": "#383A42",
				"Function":    "#4078F2",
				"Variable":    "#383A42",
				"Type":        "#C18401",
				"Builtin":     "#986801",
				"Property":    "#E45649",
				"Tag":         "#E45649",
				"AttrName":    "#986801",
				"AttrValue":   "#50A14F"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFFFFF",
		"Accent": "#FFFF00",
		"Muted": "#CCCCCC",
		"Light": "#333333",
		"WarmBeige": "#FFAA00",
		"TealTint": "#00CCCC",
		"Lavender": "#AA00AA",
		"AmberTint": "#FFAA00",
		"PdfFill": "#FF4444",
		"PdfText": "#FFFFFF"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],46:[function(require,module,exports){
module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Neon pink on dark navy Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0D0D2B",
				"Secondary": "#080820",
				"Tertiary": "#121235",
				"Panel": "#0F0F28",
				"Viewer": "#060615",
				"Hover": "#1A1A42",
				"Selected": "#2A1845",
				"Thumb": "#080820"
			},
			"Text": {
				"Primary": "#E8E0F0",
				"Secondary": "#D0C8E0",
				"Muted": "#9088A8",
				"Dim": "#6860A0",
				"Placeholder": "#504888"
			},
			"Brand": {
				"Accent": "#FF2D8A",
				"AccentHover": "#FF5AA0"
			},
			"Border": {
				"Default": "#2A2050",
				"Light": "#382868"
			},
			"Status": {
				"Danger": "#FF4466",
				"DangerMuted": "#AA3355"
			},
			"Scrollbar": {
				"Track": "#2A2050",
				"Hover": "#3A3068"
			},
			"Selection": {
				"Background": "rgba(255, 45, 138, 0.25)"
			},
			"Focus": {
				"Outline": "#FF2D8A"
			},
			"Syntax": {
				"Keyword":     "#FF4E9F",
				"String":      "#A1FFCE",
				"Number":      "#FFD93D",
				"Comment":     "#807A9E",
				"Operator":    "#7DF9FF",
				"Punctuation": "#C0BCEB",
				"Function":    "#FFCC80",
				"Variable":    "#E0D8FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF6E6E",
				"Tag":         "#FF6E6E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#A1FFCE"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0C8E0",
		"Accent": "#FF2D8A",
		"Muted": "#6860A0",
		"Light": "#121235",
		"WarmBeige": "#141438",
		"TealTint": "#100E30",
		"Lavender": "#141232",
		"AmberTint": "#1A1228",
		"PdfFill": "#1A1028",
		"PdfText": "#FF4466"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],47:[function(require,module,exports){
module.exports={
	"Hash": "night",
	"Name": "Night",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Near-black, minimal contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0A0A",
				"Secondary": "#060606",
				"Tertiary": "#0E0E0E",
				"Panel": "#0C0C0C",
				"Viewer": "#040404",
				"Hover": "#161616",
				"Selected": "#252525",
				"Thumb": "#060606"
			},
			"Text": {
				"Primary": "#888888",
				"Secondary": "#707070",
				"Muted": "#555555",
				"Dim": "#444444",
				"Placeholder": "#333333"
			},
			"Brand": {
				"Accent": "#666666",
				"AccentHover": "#808080"
			},
			"Border": {
				"Default": "#1A1A1A",
				"Light": "#222222"
			},
			"Status": {
				"Danger": "#AA4444",
				"DangerMuted": "#663333"
			},
			"Scrollbar": {
				"Track": "#1A1A1A",
				"Hover": "#2A2A2A"
			},
			"Selection": {
				"Background": "rgba(102, 102, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#666666"
			},
			"Syntax": {
				"Keyword":     "#C28FFF",
				"String":      "#B0E0B0",
				"Number":      "#FFA070",
				"Comment":     "#888888",
				"Operator":    "#80C8FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFD080",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF9090",
				"Tag":         "#FF9090",
				"AttrName":    "#FFB870",
				"AttrValue":   "#B0E0B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#707070",
		"Accent": "#666666",
		"Muted": "#444444",
		"Light": "#0E0E0E",
		"WarmBeige": "#121212",
		"TealTint": "#0C0C0C",
		"Lavender": "#101010",
		"AmberTint": "#141210",
		"PdfFill": "#141010",
		"PdfText": "#AA4444"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],48:[function(require,module,exports){
module.exports={
	"Hash": "playground-corp",
	"Name": "Playground Corp",
	"Version": "0.0.1",
	"Description": "A different paired starter — corporate teal palette, rounder corners.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#fbfbfd", "Dark": "#0e1416" },
				"Secondary": { "Light": "#eef3f6", "Dark": "#152024" },
				"Tertiary":  { "Light": "#dde7ec", "Dark": "#1e2c30" },
				"Panel":     { "Light": "#ffffff", "Dark": "#162126" },
				"Hover":     { "Light": "#e5edf1", "Dark": "#1d292e" }
			},
			"Text": {
				"Primary":     { "Light": "#0a1d22", "Dark": "#e3edf0" },
				"Secondary":   { "Light": "#3a5b65", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#647e87", "Dark": "#7a929a" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Brand": {
				"Primary":      { "Light": "#117a8b", "Dark": "#3ec0d4" },
				"PrimaryHover": { "Light": "#0e6271", "Dark": "#5fd0e0" },
				"Accent":       { "Light": "#d97706", "Dark": "#fb923c" }
			},
			"Border": {
				"Default": { "Light": "#cfdce1", "Dark": "#2c3a3f" },
				"Strong":  { "Light": "#86a3ac", "Dark": "#4d5e64" }
			},
			"Status": {
				"Success": { "Light": "#0f7a52", "Dark": "#34d399" },
				"Warning": { "Light": "#b45309", "Dark": "#fbbf24" },
				"Error":   { "Light": "#9f1239", "Dark": "#fb7185" },
				"Info":    { "Light": "#1e6fbe", "Dark": "#60a5fa" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Inter, system-ui, sans-serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.25rem"
			},
			"Weight": {
				"Regular": "400",
				"Bold": "700"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "14px",
			"LG": "20px",
			"XL": "28px"
		},
		"Radius": {
			"SM": "4px",
			"MD": "10px",
			"LG": "16px"
		}
	},
	"Brand": {
		"Name": "Corp"
	},
	"Aliases": {
		"--pict-modal-overlay-bg":          "Color.Background.Tertiary",
		"--pict-modal-bg":                  "Color.Background.Panel",
		"--pict-modal-fg":                  "Color.Text.Primary",
		"--pict-modal-border":              "Color.Border.Default",
		"--pict-modal-shadow":              "Color.Border.Strong",
		"--pict-modal-header-bg":           "Color.Background.Secondary",
		"--pict-modal-header-fg":           "Color.Text.Primary",
		"--pict-modal-header-border":       "Color.Border.Default",
		"--pict-modal-btn-bg":              "Color.Background.Secondary",
		"--pict-modal-btn-fg":              "Color.Text.Primary",
		"--pict-modal-btn-hover-bg":        "Color.Background.Hover",
		"--pict-modal-btn-primary-bg":      "Color.Brand.Primary",
		"--pict-modal-btn-primary-fg":      "Color.Text.OnBrand",
		"--pict-modal-btn-primary-hover-bg":"Color.Brand.PrimaryHover",
		"--pict-modal-btn-danger-bg":       "Color.Status.Error",
		"--pict-modal-btn-danger-fg":       "Color.Text.OnBrand",
		"--pict-modal-btn-danger-hover-bg": "Color.Status.Error",
		"--pict-modal-toast-bg":            "Color.Background.Panel",
		"--pict-modal-toast-fg":            "Color.Text.Primary",
		"--pict-modal-toast-shadow":        "Color.Border.Strong",
		"--pict-modal-toast-success-bg":    "Color.Status.Success",
		"--pict-modal-toast-error-bg":      "Color.Status.Error",
		"--pict-modal-toast-warning-bg":    "Color.Status.Warning",
		"--pict-modal-toast-info-bg":       "Color.Status.Info",
		"--pict-modal-tooltip-bg":          "Color.Background.Tertiary",
		"--pict-modal-tooltip-fg":          "Color.Text.Primary",
		"--pict-modal-font-family":         "Typography.Family.Sans",

		"--pict-um-bg":          "Color.Background.Panel",
		"--pict-um-fg":          "Color.Text.Primary",
		"--pict-um-muted":       "Color.Text.Muted",
		"--pict-um-accent":      "Color.Brand.Primary",
		"--pict-um-border":      "Color.Border.Default",
		"--pict-um-border-soft": "Color.Border.Light",
		"--pict-um-input-bg":    "Color.Background.Primary",
		"--pict-um-pill-bg":     "Color.Background.Tertiary",
		"--pict-um-font":        "Typography.Family.Sans"
	}
}

},{}],49:[function(require,module,exports){
module.exports={
	"Hash": "playground-starter",
	"Name": "Playground Starter",
	"Version": "0.0.1",
	"Description": "A complete paired light/dark starter theme. Edit any token and watch the gallery reflow.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ebebeb", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#f0f0f0", "Dark": "#2a2a2a" }
			},
			"Text": {
				"Primary":     { "Light": "#1a1a1a", "Dark": "#ededed" },
				"Secondary":   { "Light": "#454545", "Dark": "#bdbdbd" },
				"Muted":       { "Light": "#6b6b6b", "Dark": "#888888" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Brand": {
				"Primary":      { "Light": "#3357c7", "Dark": "#6b8eff" },
				"PrimaryHover": { "Light": "#2848b3", "Dark": "#88a4ff" },
				"Accent":       { "Light": "#c75033", "Dark": "#ff8a6b" }
			},
			"Border": {
				"Default": { "Light": "#d6d6d6", "Dark": "#3a3a3a" },
				"Strong":  { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"Warning": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"Error":   { "Light": "#b62828", "Dark": "#ff7373" },
				"Info":    { "Light": "#1f6fb5", "Dark": "#5fb4ff" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.25rem"
			},
			"Weight": {
				"Regular": "400",
				"Bold": "700"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px"
		},
		"Radius": {
			"SM": "2px",
			"MD": "6px",
			"LG": "10px"
		}
	},
	"Brand": {
		"Name": "Playground"
	},
	"Aliases": {
		"--pict-modal-overlay-bg":          "Color.Background.Tertiary",
		"--pict-modal-bg":                  "Color.Background.Panel",
		"--pict-modal-fg":                  "Color.Text.Primary",
		"--pict-modal-border":              "Color.Border.Default",
		"--pict-modal-shadow":              "Color.Border.Strong",
		"--pict-modal-header-bg":           "Color.Background.Secondary",
		"--pict-modal-header-fg":           "Color.Text.Primary",
		"--pict-modal-header-border":       "Color.Border.Default",
		"--pict-modal-btn-bg":              "Color.Background.Secondary",
		"--pict-modal-btn-fg":              "Color.Text.Primary",
		"--pict-modal-btn-hover-bg":        "Color.Background.Hover",
		"--pict-modal-btn-primary-bg":      "Color.Brand.Primary",
		"--pict-modal-btn-primary-fg":      "Color.Text.OnBrand",
		"--pict-modal-btn-primary-hover-bg":"Color.Brand.PrimaryHover",
		"--pict-modal-btn-danger-bg":       "Color.Status.Error",
		"--pict-modal-btn-danger-fg":       "Color.Text.OnBrand",
		"--pict-modal-btn-danger-hover-bg": "Color.Status.Error",
		"--pict-modal-toast-bg":            "Color.Background.Panel",
		"--pict-modal-toast-fg":            "Color.Text.Primary",
		"--pict-modal-toast-shadow":        "Color.Border.Strong",
		"--pict-modal-toast-success-bg":    "Color.Status.Success",
		"--pict-modal-toast-error-bg":      "Color.Status.Error",
		"--pict-modal-toast-warning-bg":    "Color.Status.Warning",
		"--pict-modal-toast-info-bg":       "Color.Status.Info",
		"--pict-modal-tooltip-bg":          "Color.Background.Tertiary",
		"--pict-modal-tooltip-fg":          "Color.Text.Primary",
		"--pict-modal-font-family":         "Typography.Family.Sans",

		"--pict-um-bg":          "Color.Background.Panel",
		"--pict-um-fg":          "Color.Text.Primary",
		"--pict-um-muted":       "Color.Text.Muted",
		"--pict-um-accent":      "Color.Brand.Primary",
		"--pict-um-border":      "Color.Border.Default",
		"--pict-um-border-soft": "Color.Border.Light",
		"--pict-um-input-bg":    "Color.Background.Primary",
		"--pict-um-pill-bg":     "Color.Background.Tertiary",
		"--pict-um-font":        "Typography.Family.Sans"
	}
}

},{}],50:[function(require,module,exports){
module.exports={
	"Hash": "retold-content-system",
	"Name": "Retold Content System",
	"Version": "0.0.1",
	"Description": "Default palette for the Retold Content System editor — warm beige with teal accents. Light side preserves the original retold-content-system.css palette verbatim; dark side keeps the teal accent and warms the backgrounds into a deep walnut/charcoal range so dark mode reads as the same family of values rather than a generic dark theme.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F3EE", "Dark": "#1F1B17" },
				"Secondary": { "Light": "#FAF8F4", "Dark": "#2A251F" },
				"Tertiary":  { "Light": "#F0EDE8", "Dark": "#332D26" },
				"Panel":     { "Light": "#FFFFFF", "Dark": "#26221C" },
				"Hover":     { "Light": "#EDE9E3", "Dark": "#383028" },
				"Selected":  { "Light": "#DCE9E7", "Dark": "#1E3833" }
			},
			"Text": {
				"Primary":     { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Secondary":   { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Muted":       { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Placeholder": { "Light": "#A89E91", "Dark": "#6E6457" },
				"OnBrand":     { "Light": "#FFFFFF", "Dark": "#1F1B17" }
			},
			"Brand": {
				"Primary":      { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"PrimaryHover": { "Light": "#3A9E92", "Dark": "#65CBBE" },
				"Accent":       { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"AccentHover":  { "Light": "#3A9E92", "Dark": "#65CBBE" }
			},
			"Border": {
				"Default": { "Light": "#DDD6CA", "Dark": "#3F362C" },
				"Light":   { "Light": "#E8E2D7", "Dark": "#33291F" },
				"Strong":  { "Light": "#C4BDB0", "Dark": "#5A4F40" }
			},
			"Status": {
				"Success": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"Warning": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"Error":   { "Light": "#D9534F", "Dark": "#E87B78" },
				"Info":    { "Light": "#5DA6C7", "Dark": "#7FBDD8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#F5F0E8", "Dark": "#26221C" },
				"Thumb": { "Light": "#C4BDB0", "Dark": "#4A4036" },
				"Hover": { "Light": "#8A7F72", "Dark": "#6A5F50" }
			},
			"Selection": {
				"Background": { "Light": "#CDE3E0", "Dark": "#2E5B55" },
				"Text":       { "Light": "#3D3229", "Dark": "#E8DCC8" }
			},
			"Focus": {
				"Outline": { "Light": "#2E7D74", "Dark": "#4FB3A6" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(61, 50, 41, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#A0532E", "Dark": "#E89A6E" },
				"String":      { "Light": "#3F8A52", "Dark": "#8FD493" },
				"Number":      { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Comment":     { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Operator":    { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"Punctuation": { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Function":    { "Light": "#2E5E96", "Dark": "#7FBDD8" },
				"Variable":    { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Type":        { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Builtin":     { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Property":    { "Light": "#A0532E", "Dark": "#E89A6E" },
				"Tag":         { "Light": "#A0532E", "Dark": "#E89A6E" },
				"AttrName":    { "Light": "#A86B00", "Dark": "#E8A94D" },
				"AttrValue":   { "Light": "#3F8A52", "Dark": "#8FD493" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth":    "250px",
			"TopbarHeight":    "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Content",
		"Tagline": "Author content for the Retold ecosystem."
	}
}

},{}],51:[function(require,module,exports){
module.exports={
	"Hash": "retold-default",
	"Name": "Retold Default",
	"Version": "0.0.1",
	"Description": "The reference paired light/dark theme for the Retold ecosystem. Neutral palette suitable for any app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ebebeb", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#e0eaff", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":     { "Light": "#1a1a1a", "Dark": "#ededed" },
				"Secondary":   { "Light": "#454545", "Dark": "#bdbdbd" },
				"Muted":       { "Light": "#6b6b6b", "Dark": "#888888" },
				"Placeholder": { "Light": "#9a9a9a", "Dark": "#6a6a6a" }
			},
			"Brand": {
				"Primary":      { "Light": "#3357c7", "Dark": "#6b8eff" },
				"PrimaryHover": { "Light": "#2848b3", "Dark": "#88a4ff" },
				"Accent":       { "Light": "#c75033", "Dark": "#ff8a6b" }
			},
			"Border": {
				"Default": { "Light": "#d6d6d6", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#e9e9e9", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"Warning": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"Error":   { "Light": "#b62828", "Dark": "#ff7373" },
				"Info":    { "Light": "#1f6fb5", "Dark": "#5fb4ff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ebebeb", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#c2c2c2", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Selection": {
				"Background": { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"Text":       { "Light": "#1a1a1a", "Dark": "#ededed" }
			},
			"Focus": {
				"Outline": { "Light": "#3357c7", "Dark": "#6b8eff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Retold",
		"Tagline": "A suite of JavaScript modules for building web applications and APIs."
	},
	"CSS": [
		{
			"Hash": "retold-default-brand-accents",
			"Priority": 600,
			"Content": "/* retold-default — subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}

},{}],52:[function(require,module,exports){
module.exports={
	"Hash": "retold-manager",
	"Name": "Retold Manager",
	"Description": "Default palette for the Retold Manager application — GitHub-style dark on slate with a parallel light variant. Dark side mirrors retold-manager.css's original colors verbatim; light side is a sympathetic translation tuned for daytime use. The retold-manager.css :root block proxies its --color-* names through these --theme-color-* tokens (with the original hexes as fallbacks), so this theme drives the whole app cleanly and other catalog themes still skin most of it.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f6f8fa", "Dark": "#0e1116" },
				"Secondary": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Tertiary":  { "Light": "#e4e8ec", "Dark": "#1c2128" },
				"Panel":     { "Light": "#ffffff", "Dark": "#161b22" },
				"PanelAlt":  { "Light": "#f0f3f6", "Dark": "#1c2128" },
				"Hover":     { "Light": "#eaeef2", "Dark": "#1c2128" },
				"Selected":  { "Light": "#dbe7ff", "Dark": "#243454" }
			},
			"Border": {
				"Default":   { "Light": "#d0d7de", "Dark": "#30363d" },
				"Light":     { "Light": "#e1e4e8", "Dark": "#21262d" },
				"Strong":    { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Brand": {
				"Primary":      { "Light": "#0969da", "Dark": "#2f81f7" },
				"PrimaryHover": { "Light": "#0550ae", "Dark": "#1f6feb" },
				"Accent":       { "Light": "#0969da", "Dark": "#2f81f7" },
				"AccentHover":  { "Light": "#0550ae", "Dark": "#1f6feb" }
			},
			"Text": {
				"Primary":     { "Light": "#1f2328", "Dark": "#e6edf3" },
				"Secondary":   { "Light": "#3b424a", "Dark": "#c9d1d9" },
				"Muted":       { "Light": "#656d76", "Dark": "#8b949e" },
				"Placeholder": { "Light": "#8c959f", "Dark": "#6e7681" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"Danger":  { "Light": "#cf222e", "Dark": "#f85149" },
				"Warning": { "Light": "#9a6700", "Dark": "#d29922" },
				"Error":   { "Light": "#cf222e", "Dark": "#f85149" },
				"Info":    { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Scrollbar": {
				"Track": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Thumb": { "Light": "#c1c8cf", "Dark": "#30363d" },
				"Hover": { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Selection": {
				"Background": { "Light": "#cfe6ff", "Dark": "#243454" },
				"Text":       { "Light": "#1f2328", "Dark": "#e6edf3" }
			},
			"Focus": {
				"Outline": { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#cf222e", "Dark": "#ff7b72" },
				"String":      { "Light": "#0a3069", "Dark": "#a5d6ff" },
				"Number":      { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Comment":     { "Light": "#6e7781", "Dark": "#8b949e" },
				"Operator":    { "Light": "#cf222e", "Dark": "#ff7b72" },
				"Punctuation": { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Function":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"Variable":    { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Type":        { "Light": "#953800", "Dark": "#ffa657" },
				"Builtin":     { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Property":    { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Tag":         { "Light": "#116329", "Dark": "#7ee787" },
				"AttrName":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"AttrValue":   { "Light": "#0a3069", "Dark": "#a5d6ff" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, \"SF Pro\", \"Segoe UI\", sans-serif",
				"Mono": "ui-monospace, \"SF Mono\", Menlo, Monaco, \"Courier New\", monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "280px",
			"TopbarHeight":    "44px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],53:[function(require,module,exports){
module.exports={
	"Hash": "retold-mono",
	"Name": "Retold Mono",
	"Version": "0.0.2",
	"Description": "High-contrast monochrome theme — black on white in light mode, white on black in dark mode. Useful for print, simple admin tooling, and as a paired-mode reference theme that proves the toggle works on something visually unmistakable.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#101010" },
				"Tertiary":  { "Light": "#e2e2e2", "Dark": "#1c1c1c" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#ebebeb", "Dark": "#1a1a1a" },
				"Selected":  { "Light": "#d6d6d6", "Dark": "#2a2a2a" }
			},
			"Text": {
				"Primary":     { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary":   { "Light": "#222222", "Dark": "#dddddd" },
				"Muted":       { "Light": "#555555", "Dark": "#aaaaaa" },
				"Placeholder": { "Light": "#888888", "Dark": "#777777" }
			},
			"Brand": {
				"Primary":      { "Light": "#000000", "Dark": "#ffffff" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Border": {
				"Default": { "Light": "#888888", "Dark": "#666666" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#e0e0e0", "Dark": "#101010" },
				"Thumb": { "Light": "#888888", "Dark": "#666666" },
				"Hover": { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Selection": {
				"Background": { "Light": "#000000", "Dark": "#ffffff" },
				"Text":       { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.18)", "Dark": "rgba(255, 255, 255, 0.18)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#000000", "Dark": "#ffffff" },
				"String":      { "Light": "#555555", "Dark": "#cccccc" },
				"Number":      { "Light": "#000000", "Dark": "#ffffff" },
				"Comment":     { "Light": "#888888", "Dark": "#888888" },
				"Operator":    { "Light": "#000000", "Dark": "#ffffff" },
				"Punctuation": { "Light": "#444444", "Dark": "#bbbbbb" },
				"Function":    { "Light": "#000000", "Dark": "#ffffff" },
				"Variable":    { "Light": "#000000", "Dark": "#ffffff" },
				"Type":        { "Light": "#222222", "Dark": "#dddddd" },
				"Builtin":     { "Light": "#222222", "Dark": "#dddddd" },
				"Property":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"Tag":         { "Light": "#000000", "Dark": "#ffffff" },
				"AttrName":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"AttrValue":   { "Light": "#555555", "Dark": "#cccccc" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Times New Roman, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "600",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.15",
				"Normal": "1.4",
				"Loose": "1.65"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "0",
			"MD": "0",
			"LG": "0",
			"XL": "0",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 0 var(--theme-color-shadow-color)",
			"MD": "0 2px 0 var(--theme-color-shadow-color)",
			"LG": "0 4px 0 var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "0ms",
			"Normal": "0ms",
			"Slow": "0ms"
		}
	},
	"Brand": {
		"Name": "Retold Mono",
		"Tagline": "Black on white. White on black. Nothing else."
	},
	"CSS": [
		{
			"Hash": "retold-mono-brand-accents",
			"Priority": 600,
			"Content": "/* retold-mono — keeps the all-monochrome aesthetic but lets brand colors\n   in for narrow accent moments. The thick rule under H1 is brand primary;\n   the hair rule under H2 is brand secondary. Without a brand registered\n   they fall back to mono black/grey. */\na { text-decoration-color: var(--brand-color-primary-mode, currentColor); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 3px solid var(--brand-color-primary-mode, var(--theme-color-text-primary, #000)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-default, #888)); padding-bottom: 4px; }"
		}
	]
}

},{}],54:[function(require,module,exports){
module.exports={
	"Hash": "solarized-dark",
	"Name": "Solarized Dark",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Schoonover's classic palette Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#002B36",
				"Secondary": "#073642",
				"Tertiary": "#003B4A",
				"Panel": "#00303C",
				"Viewer": "#001E28",
				"Hover": "#0A4858",
				"Selected": "#155868",
				"Thumb": "#073642"
			},
			"Text": {
				"Primary": "#FDF6E3",
				"Secondary": "#EEE8D5",
				"Muted": "#93A1A1",
				"Dim": "#839496",
				"Placeholder": "#657B83"
			},
			"Brand": {
				"Accent": "#268BD2",
				"AccentHover": "#45A0E0"
			},
			"Border": {
				"Default": "#0A4050",
				"Light": "#125868"
			},
			"Status": {
				"Danger": "#DC322F",
				"DangerMuted": "#AA2A28"
			},
			"Scrollbar": {
				"Track": "#0A4050",
				"Hover": "#125868"
			},
			"Selection": {
				"Background": "rgba(38, 139, 210, 0.25)"
			},
			"Focus": {
				"Outline": "#268BD2"
			},
			"Syntax": {
				"Keyword":     "#859900",
				"String":      "#2AA198",
				"Number":      "#D33682",
				"Comment":     "#586E75",
				"Operator":    "#268BD2",
				"Punctuation": "#93A1A1",
				"Function":    "#B58900",
				"Variable":    "#FDF6E3",
				"Type":        "#B58900",
				"Builtin":     "#CB4B16",
				"Property":    "#268BD2",
				"Tag":         "#268BD2",
				"AttrName":    "#B58900",
				"AttrValue":   "#2AA198"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Source Code Pro', 'Fira Code', monospace",
				"Mono": "'Source Code Pro', 'Fira Code', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#EEE8D5",
		"Accent": "#268BD2",
		"Muted": "#839496",
		"Light": "#003B4A",
		"WarmBeige": "#073642",
		"TealTint": "#004050",
		"Lavender": "#003848",
		"AmberTint": "#0A3A30",
		"PdfFill": "#0A3028",
		"PdfText": "#DC322F"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],55:[function(require,module,exports){
module.exports={
	"Hash": "synthwave",
	"Name": "Synthwave",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Purple and pink neon Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A0A2E",
				"Secondary": "#140824",
				"Tertiary": "#200E38",
				"Panel": "#1C0C32",
				"Viewer": "#100620",
				"Hover": "#2A1848",
				"Selected": "#3A2060",
				"Thumb": "#140824"
			},
			"Text": {
				"Primary": "#E8C0F8",
				"Secondary": "#D0A8E8",
				"Muted": "#9878B8",
				"Dim": "#7858A8",
				"Placeholder": "#584088"
			},
			"Brand": {
				"Accent": "#FF71CE",
				"AccentHover": "#FF99DD"
			},
			"Border": {
				"Default": "#302050",
				"Light": "#402868"
			},
			"Status": {
				"Danger": "#FF4488",
				"DangerMuted": "#AA3366"
			},
			"Scrollbar": {
				"Track": "#302050",
				"Hover": "#402868"
			},
			"Selection": {
				"Background": "rgba(255, 113, 206, 0.25)"
			},
			"Focus": {
				"Outline": "#FF71CE"
			},
			"Syntax": {
				"Keyword":     "#FF6AD5",
				"String":      "#FFE066",
				"Number":      "#FF6AD5",
				"Comment":     "#9C8AC1",
				"Operator":    "#26F0F1",
				"Punctuation": "#C8B6E2",
				"Function":    "#26F0F1",
				"Variable":    "#FFE0FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF477E",
				"Tag":         "#FF477E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#FFE066"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Trebuchet MS', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0A8E8",
		"Accent": "#FF71CE",
		"Muted": "#7858A8",
		"Light": "#200E38",
		"WarmBeige": "#221040",
		"TealTint": "#1A0C30",
		"Lavender": "#1E0E36",
		"AmberTint": "#241028",
		"PdfFill": "#241020",
		"PdfText": "#FF4488"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],56:[function(require,module,exports){
module.exports={
	"Hash": "twilight",
	"Name": "Twilight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Dark grey, low light. Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format. Single-mode (no light/dark bifurcation). Aliases preserve the legacy `--retold-*` variable names so existing CSS keeps working through the migration.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1E1E1E",
				"Secondary": "#181818",
				"Tertiary": "#252525",
				"Panel": "#202020",
				"Viewer": "#141414",
				"Hover": "#2E2E2E",
				"Selected": "#404040",
				"Thumb": "#181818"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#C8C8C8",
				"Muted": "#909090",
				"Dim": "#707070",
				"Placeholder": "#585858"
			},
			"Brand": {
				"Accent": "#A0A0A0",
				"AccentHover": "#C0C0C0"
			},
			"Border": {
				"Default": "#333333",
				"Light": "#404040"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#404040",
				"Hover": "#505050"
			},
			"Selection": {
				"Background": "rgba(160, 160, 160, 0.25)"
			},
			"Focus": {
				"Outline": "#A0A0A0"
			},
			"Syntax": {
				"Keyword":     "#B58FFF",
				"String":      "#9CDFB0",
				"Number":      "#FFB870",
				"Comment":     "#6E6E6E",
				"Operator":    "#7CC5FF",
				"Punctuation": "#C0C0C0",
				"Function":    "#FFD080",
				"Variable":    "#E0E0E0",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF8B8B",
				"Tag":         "#FF8B8B",
				"AttrName":    "#FFB870",
				"AttrValue":   "#9CDFB0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#C8C8C8",
		"Accent": "#A0A0A0",
		"Muted": "#707070",
		"Light": "#252525",
		"WarmBeige": "#2A2A2A",
		"TealTint": "#222222",
		"Lavender": "#282828",
		"AmberTint": "#2E2A24",
		"PdfFill": "#2E2224",
		"PdfText": "#E06060"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],57:[function(require,module,exports){
/**
 * Theme-BottomBar — standard application footer row.
 *
 * The bottom-row counterpart to Theme-TopBar: a thin status / chrome bar
 * that sits at the absolute bottom of the application shell. Three
 * zones — status text on the left, info indicators in the middle, and
 * action buttons / toggles on the right.
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ Status text          [── Info slot (flex) ──]      [actions]   │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Renders into `#Theme-BottomBar` by default.
 *
 * Three slots host views drop content into:
 *   - `#Theme-BottomBar-Status`  — short status / state line (left)
 *   - `#Theme-BottomBar-Info`    — center info: connection, version,
 *                                  ambient indicators
 *   - `#Theme-BottomBar-Actions` — log toggle, debug controls, etc.
 *
 * Top border uses `--brand-color-secondary-mode` so the bottombar gets
 * a brand-tinted edge that's visually distinct from the topbar's
 * primary-color stripe.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BottomBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BottomBar',
	DefaultRenderable: 'Theme-BottomBar-Renderable',

	// ViewIdentifier of a host view that fills #Theme-BottomBar-Status.
	StatusView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Info.
	InfoView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Actions.
	ActionsView: null,

	// Height of the bar in pixels. Drives the min-height on the chrome
	// row so it fills the panel cleanly even when the parent chain
	// (pict-section-modal shell uses min-height: 100% on its panel
	// content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 32,

	Templates:
	[
		{
			Hash: 'Theme-BottomBar-Template',
			Template: /*html*/`
<div class="pict-theme-bottombar">
	<div class="pict-theme-bottombar-status" id="Theme-BottomBar-Status"></div>
	<div class="pict-theme-bottombar-info" id="Theme-BottomBar-Info"></div>
	<div class="pict-theme-bottombar-actions" id="Theme-BottomBar-Actions"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BottomBar-Renderable',
			TemplateHash: 'Theme-BottomBar-Template',
			ContentDestinationAddress: '#Theme-BottomBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-bottombar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 32). A fixed px value avoids the
	   percent-height resolution trap the pict-section-modal shell sets
	   up — see the comment on Theme-TopBar's CSS for the full story. */
	min-height: 32px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-secondary, transparent);
	font-size: var(--theme-typography-size-xs, 12px);
	color: var(--theme-color-text-secondary, #4a5568);
	/* Single medium brand-primary stripe at the top of the bottombar.
	   The topbar carries the full two-stripe identifier; on the
	   bottombar (which is only 32px tall) a single 2px primary line is
	   enough to seat the brand colour at the bottom of the page
	   without competing for visual weight against the content row. */
	border-top: 2px solid var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
.pict-theme-bottombar-status {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 50%;
}
.pict-theme-bottombar-info {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	min-width: 0;
	overflow: hidden;
}
.pict-theme-bottombar-actions {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
}`,
	CSSPriority: 500
};

class PictViewThemeBottomBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-bottombar
		// — see the matching block in Theme-TopBar's onAfterRender for why.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-bottombar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		let tmpRenderSlot = (pIdentifier) =>
		{
			if (!pIdentifier) return;
			let tmpView = this.pict.views[pIdentifier];
			if (tmpView) { tmpView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-BottomBar: slot view "' + pIdentifier + '" not registered');
			}
		};
		tmpRenderSlot(this.options.StatusView);
		tmpRenderSlot(this.options.InfoView);
		tmpRenderSlot(this.options.ActionsView);

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Mirrors Theme-TopBar's setNavView / setUserView — call from a
	// router callback to swap the bottom bar's slot content as the
	// route changes (different status formats per page, etc.).

	setStatusView(pViewIdentifier)  { this._setSlotView('StatusView',  '#Theme-BottomBar-Status',  pViewIdentifier); }
	setInfoView(pViewIdentifier)    { this._setSlotView('InfoView',    '#Theme-BottomBar-Info',    pViewIdentifier); }
	setActionsView(pViewIdentifier) { this._setSlotView('ActionsView', '#Theme-BottomBar-Actions', pViewIdentifier); }

	_setSlotView(pOptionKey, pDestSelector, pViewIdentifier)
	{
		this.options[pOptionKey] = pViewIdentifier || null;
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-BottomBar: view "' + pViewIdentifier + '" not registered');
		}
	}
}

module.exports = PictViewThemeBottomBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],58:[function(require,module,exports){
/**
 * Theme-Brand-Mark — single-row inline brand mark (icon + name).
 *
 * The drop-in counterpart to Theme-BrandStrip for apps that put the
 * brand wordmark *inside* their topbar (next to action buttons) rather
 * than as a multi-row chrome below the nav.
 *
 * Layout:
 *
 *   ┌─────────────────────────┐
 *   │ [icon]  App Name        │
 *   └─────────────────────────┘
 *
 * Colors come from the brand's primary/secondary; the icon (when SVG
 * with `stroke="currentColor"`) inherits `--brand-color-primary-mode`,
 * which auto-swaps between PrimaryLight (default mode) and PrimaryDark
 * (`.theme-dark`).
 *
 * Reads from libThemeBrand and re-renders on `onChange`. Renders an
 * empty span when no brand is registered.
 *
 * Drop-in destination: `<div id="Theme-Brand-Mark"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Brand-Mark',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Brand-Mark',
	DefaultRenderable: 'Theme-Brand-Mark-Renderable',

	// Optional: when false the icon is omitted (text-only wordmark).
	ShowIcon: true,
	// Optional: when false the name is omitted (icon-only mark).
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-Brand-Mark-Template',
			Template: /*html*/`{~TS:Theme-Brand-Mark-Body-Template:AppData.PictSectionTheme.BrandMark.BodySlot~}`
		},
		{
			Hash: 'Theme-Brand-Mark-Body-Template',
			Template: /*html*/`
<span class="pict-theme-brand-mark" title="{~D:Record.Tooltip~}">
	{~TS:Theme-Brand-Mark-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-Brand-Mark-IconImg-Template:Record.IconImgSlot~}
	{~TS:Theme-Brand-Mark-Name-Template:Record.NameSlot~}
</span>`
		},
		{
			// Inline SVG: trusted markup; let it ride. SVG icons that
			// reference `currentColor` inherit `--brand-color-primary-mode`.
			Hash: 'Theme-Brand-Mark-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			Hash: 'Theme-Brand-Mark-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		},
		{
			Hash: 'Theme-Brand-Mark-Name-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-name">{~D:Record.Name~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Brand-Mark-Renderable',
			TemplateHash: 'Theme-Brand-Mark-Template',
			ContentDestinationAddress: '#Theme-Brand-Mark',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brand-mark {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	/* line-height: 1 collapses the inherited ~1.2 line-box around the
	   name glyphs. Without this the inline-flex container is taller
	   than its visible content, the line-box adds asymmetric space
	   above the caps, and the whole mark looks pushed up vs.
	   neighbouring buttons that sit on standard 12px-text baselines. */
	line-height: 1;
	color: var(--brand-color-primary-mode, var(--theme-color-text-primary, #1a1a1a));
	user-select: none;
}
.pict-theme-brand-mark-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	color: currentColor;
}
.pict-theme-brand-mark-icon img,
.pict-theme-brand-mark-icon svg {
	width: 100%;
	height: 100%;
	display: block;
}
.pict-theme-brand-mark-name {
	/* Font size dropped from 15 → 14 so the brand name reads closer
	   to the typical 12px action-button text height; bigger glyphs
	   reaching higher into the row are why the mark looked optically
	   high. The 2px brand-secondary underline keeps the mark feeling
	   distinctly branded; padding-bottom: 1px was an asymmetric nudge
	   that shifted the visual center up — removed. */
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.4px;
	border-bottom: 2px solid var(--brand-color-secondary-mode, transparent);
	white-space: nowrap;
}
/* Compact form — at narrow viewports the brand mark collapses to
   icon-only. The icon alone still reads as the brand (the deterministic
   logo is designed to be recognisable without the wordmark) and freeing
   up the wordmark's width keeps the nav buttons reachable on tablet /
   small-laptop widths. The threshold matches the topbar's compact
   breakpoint in Theme-TopBar. */
@media (max-width: 720px) {
	.pict-theme-brand-mark-name {
		display: none;
	}
}`,
	CSSPriority: 500
};

class PictViewThemeBrandMark extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandMark = { BodySlot: [] };
			return;
		}

		// Single-element array slot drives the {~TS:~} render. Empty
		// slots for icon-img/icon-svg/name suppress those sub-templates.
		let tmpShowIcon = (this.options.ShowIcon !== false);
		let tmpShowName = (this.options.ShowName !== false);

		let tmpIconSVGSlot = (tmpShowIcon && tmpBrand.IconType === 'svg' && tmpBrand.Icon)
			? [{ IconHTML: tmpBrand.Icon }] : [];
		let tmpIconImgSlot = (tmpShowIcon && tmpBrand.IconType === 'image' && tmpBrand.Icon)
			? [{ IconURL: tmpBrand.Icon }] : [];
		let tmpNameSlot = (tmpShowName && tmpBrand.Name)
			? [{ Name: tmpBrand.Name }] : [];

		this.pict.AppData.PictSectionTheme.BrandMark =
		{
			BodySlot:
			[{
				Tooltip: tmpBrand.Tagline || tmpBrand.Name || '',
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot,
				NameSlot:    tmpNameSlot
			}]
		};
	}
}

module.exports = PictViewThemeBrandMark;
module.exports.default_configuration = _ViewConfiguration;

},{"../Theme-Brand.js":30,"pict-view":68}],59:[function(require,module,exports){
/**
 * Theme-BrandStrip — the subtle two-line brand signature that sits
 * under the application's navigation.
 *
 * Layout:
 *
 *   ┌─────────────────────────────────────────────────────────────┐
 *   │ [icon]  App Name                                            │
 *   │ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ │  ← primary stripe (3× tall)
 *   │ ─────────────────────────────────────────────────────────── │  ← secondary stripe (1× tall)
 *   └─────────────────────────────────────────────────────────────┘
 *
 * The icon + name row is colored using the brand's primary color (and
 * the secondary as an underline accent on the name). Clicking the row
 * does nothing by default — hosts that want it to navigate or open a
 * dropdown can pass an `OnClickName` hook in the view options.
 *
 * Reads the active brand from libThemeBrand. Subscribes to
 * libThemeBrand.onChange so swapping the brand at runtime updates the
 * strip immediately. Renders nothing (an empty span) when no brand is
 * registered.
 *
 * Drop-in destination: `<div id="Theme-BrandStrip"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BrandStrip',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BrandStrip',
	DefaultRenderable: 'Theme-BrandStrip-Renderable',

	// Stripe heights in pixels. Primary is conventionally 3× secondary,
	// per the design brief, but exposed here so hosts can tune.
	PrimaryStripeHeight: 3,
	SecondaryStripeHeight: 1,

	// When false, the icon + name row is omitted and only the two
	// stripes render. Useful for very tight chrome where the brand
	// name is already in the topbar.
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-BrandStrip-Template',
			Template: /*html*/`
{~TS:Theme-BrandStrip-Body-Template:AppData.PictSectionTheme.BrandStrip.BodySlot~}`
		},
		{
			Hash: 'Theme-BrandStrip-Body-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip" title="{~D:Record.Tooltip~}">
	{~TS:Theme-BrandStrip-NameRow-Template:Record.NameRowSlot~}
	<div class="pict-theme-brandstrip-stripes">
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-primary"
		     style="height: {~D:Record.PrimaryHeight~}px;"></div>
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-secondary"
		     style="height: {~D:Record.SecondaryHeight~}px;"></div>
	</div>
</div>`
		},
		{
			Hash: 'Theme-BrandStrip-NameRow-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip-row">
	{~TS:Theme-BrandStrip-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-BrandStrip-IconImg-Template:Record.IconImgSlot~}
	<span class="pict-theme-brandstrip-name">{~D:Record.Name~}</span>
</div>`
		},
		{
			// SVG icon: leading <svg> markup is trusted (host-supplied,
			// not user-supplied) so we let it through verbatim. Theme-Icons
			// SVGs use stroke="currentColor" so they pick up the brand
			// primary color from the row's `color: var(--brand-color-primary)`.
			Hash: 'Theme-BrandStrip-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			// <img> icon: src can be a data URL or a regular URL.
			Hash: 'Theme-BrandStrip-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BrandStrip-Renderable',
			TemplateHash: 'Theme-BrandStrip-Template',
			ContentDestinationAddress: '#Theme-BrandStrip',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brandstrip {
	display: flex;
	flex-direction: column;
	gap: 4px;
	user-select: none;
}
.pict-theme-brandstrip-row {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px 4px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--brand-color-primary, var(--theme-color-text-muted, #6b6b6b));
}
.pict-theme-brandstrip-name {
	border-bottom: 2px solid var(--brand-color-secondary, transparent);
	padding-bottom: 1px;
}
.pict-theme-brandstrip-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px; height: 16px;
	color: var(--brand-color-primary, currentColor);
}
.pict-theme-brandstrip-icon img,
.pict-theme-brandstrip-icon svg {
	width: 100%; height: 100%;
	display: block;
}
.pict-theme-brandstrip-stripes {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.pict-theme-brandstrip-stripe {
	width: 100%;
}
.pict-theme-brandstrip-stripe-primary {
	background: var(--brand-color-primary, transparent);
}
.pict-theme-brandstrip-stripe-secondary {
	background: var(--brand-color-secondary, transparent);
}`,
	CSSPriority: 500
};

class PictViewThemeBrandStrip extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		// No brand → empty BodySlot → renderable emits nothing.
		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandStrip = { BodySlot: [] };
			return;
		}

		let tmpShowName = (this.options.ShowName !== false);

		// Pick the right per-icon-type slot. Only one of these will be
		// non-empty so the template renders the right element.
		let tmpIconSVGSlot = [];
		let tmpIconImgSlot = [];
		if (tmpBrand.IconType === 'svg' && tmpBrand.Icon)
		{
			tmpIconSVGSlot = [{ IconHTML: tmpBrand.Icon }];
		}
		else if (tmpBrand.IconType === 'image' && tmpBrand.Icon)
		{
			tmpIconImgSlot = [{ IconURL: tmpBrand.Icon }];
		}

		let tmpNameRowSlot = tmpShowName
			? [{
				Name: tmpBrand.Name,
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot
			}]
			: [];

		let tmpTooltip = tmpBrand.Name + (tmpBrand.Tagline ? ' — ' + tmpBrand.Tagline : '');

		this.pict.AppData.PictSectionTheme.BrandStrip =
		{
			BodySlot:
			[{
				Tooltip: tmpTooltip,
				NameRowSlot: tmpNameRowSlot,
				PrimaryHeight: this.options.PrimaryStripeHeight || 3,
				SecondaryHeight: this.options.SecondaryStripeHeight || 1
			}]
		};
	}
}

PictViewThemeBrandStrip.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeBrandStrip;

},{"../Theme-Brand.js":30,"pict-view":68}],60:[function(require,module,exports){
/**
 * Theme-Button — an embeddable SVG button (sun/moon glyph) suitable for
 * application top bars. Clicking it opens a pict-section-modal popup
 * containing the Theme-Picker dropdown and the Theme-ModeToggle.
 *
 * Drop-in destination: `<div id="Theme-Button"></div>`. The button itself
 * is a tiny self-contained SVG that picks its color from the theme via
 * `currentColor` so it inherits the surrounding text color.
 *
 * Requires `pict-section-modal` to be registered (under the view hash
 * `Pict-Section-Modal` by default). If it isn't, clicking the button
 * falls back to a `console.warn` and a no-op.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Button',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Button',
	DefaultRenderable: 'Theme-Button-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Identifiers of the picker / toggle / scale views that the popup
	// will mount. Each one is optional — if a view isn't registered the
	// matching row is silently skipped (no broken DOM placeholders).
	PickerViewHash: 'Theme-Picker',
	ModeToggleViewHash: 'Theme-ModeToggle',
	ScaleSelectViewHash: 'Theme-ScaleSelect',

	// Visible button label / title (tooltip).
	Title: 'Theme',
	AriaLabel: 'Open theme menu',

	// Modal title.
	ModalTitle: 'Theme',

	// Modal width (CSS).
	ModalWidth: '320px',

	Templates:
	[
		{
			Hash: 'Theme-Button-Template',
			// SVG sourced from the shared Theme-Icons module so the
			// topbar glyph matches the picker + mode toggle exactly.
			Template: /*html*/`
<button type="button"
        class="pict-theme-button"
        aria-label="{~D:AppData.PictSectionTheme.Button.AriaLabel~}"
        title="{~D:AppData.PictSectionTheme.Button.Title~}"
        onclick="_Pict.views['Theme-Button'].openMenu();">
	${libThemeIcons.iconSun(16)}
</button>`
		},
		{
			Hash: 'Theme-Button-Modal-Template',
			Template: /*html*/`
<div class="pict-theme-button-menu">
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Theme</label>
		<div id="Theme-Picker"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Mode</label>
		<div id="Theme-ModeToggle"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Scale</label>
		<div id="Theme-ScaleSelect"></div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Button-Renderable',
			TemplateHash: 'Theme-Button-Template',
			ContentDestinationAddress: '#Theme-Button',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	/* Sized to match a typical 12px-font / 6px-12px-padding text button
	   (~28px tall) so this drops cleanly into a topbar row alongside
	   action buttons without standing taller and crashing the row's
	   visual rhythm. Squareish — width matches height for the icon. */
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-button:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-brand-primary, #2563eb);
	border-color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-button-icon { width: 16px; height: 16px; }
.pict-theme-button-menu { display: flex; flex-direction: column; gap: 14px; }
.pict-theme-button-menu-row { display: flex; flex-direction: column; gap: 6px; }
.pict-theme-button-menu-label {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

class PictViewThemeButton extends libPictView
{
	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the theme menu in a modal.
	 */
	openMenu()
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined')
			{
				console.warn('Theme-Button: pict-section-modal view not found at "'
					+ (this.options.ModalViewHash || 'Pict-Section-Modal')
					+ '" — cannot open theme menu.');
			}
			return null;
		}

		let tmpHTML = this.pict.parseTemplateByHash('Theme-Button-Modal-Template', {});

		let tmpSelf = this;
		return tmpModal.show(
		{
			title: this.options.ModalTitle || 'Theme',
			content: tmpHTML,
			width: this.options.ModalWidth || '320px',
			closeable: true,
			buttons: [],
			onOpen: function ()
			{
				// Mount the picker + toggle into the freshly-created
				// modal DOM. The views look up their own destinations
				// so a simple render() is enough.
				tmpSelf._mountSubViews();
			}
		});
	}

	// ================================================================
	// Internals
	// ================================================================

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	_mountSubViews()
	{
		let tmpPicker = this.pict.views[this.options.PickerViewHash || 'Theme-Picker'];
		if (tmpPicker)
		{
			tmpPicker.render();
		}
		let tmpToggle = this.pict.views[this.options.ModeToggleViewHash || 'Theme-ModeToggle'];
		if (tmpToggle)
		{
			tmpToggle.render();
		}
		let tmpScale = this.pict.views[this.options.ScaleSelectViewHash || 'Theme-ScaleSelect'];
		if (tmpScale)
		{
			tmpScale.render();
		}
	}

	_refreshAppData()
	{
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Button =
		{
			Title: this.options.Title || 'Theme',
			AriaLabel: this.options.AriaLabel || 'Open theme menu'
		};
	}
}

PictViewThemeButton.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeButton;

},{"../Theme-Icons.js":31,"pict-view":68}],61:[function(require,module,exports){
/**
 * Theme-ModeToggle — three-segment toggle for Light / Dark / System mode.
 *
 * Calls `provider.setMode(...)` on click. Greys itself out (and the
 * Dark / System buttons) when the active theme is single-mode (since
 * single-mode themes ignore mode requests internally).
 *
 * Like the Picker, subscribes to `provider.onApply` so the active button
 * highlight stays in sync with theme changes from elsewhere.
 *
 * Drop-in destination: `<div id="Theme-ModeToggle"></div>`.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ModeToggle',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ModeToggle',
	DefaultRenderable: 'Theme-ModeToggle-Renderable',

	ProviderHash: 'Theme',

	// Allow hosts to relabel buttons (i18n). Order is fixed.
	Labels:
	{
		Light:  'Light',
		Dark:   'Dark',
		System: 'System'
	},

	// Show the inline sun / moon / monitor SVG icons next to the labels.
	ShowIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-ModeToggle-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-wrap">
	<div class="pict-theme-modetoggle{~NE:AppData.PictSectionTheme.ModeToggle.Disabled^ pict-theme-modetoggle-disabled~}"
	     role="group" aria-label="Color mode"
	     title="{~D:AppData.PictSectionTheme.ModeToggle.WrapTitle~}">
		{~TS:Theme-ModeToggle-Button-Template:AppData.PictSectionTheme.ModeToggle.Buttons~}
	</div>
	{~TS:Theme-ModeToggle-LockedNote-Template:AppData.PictSectionTheme.ModeToggle.LockedNoteSlot~}
</div>`
		},
		{
			Hash: 'Theme-ModeToggle-Button-Template',
			Template: /*html*/`
<button type="button"
        class="pict-theme-modetoggle-btn{~NE:Record.Active^ pict-theme-modetoggle-btn-active~}{~NE:Record.LockedOut^ pict-theme-modetoggle-btn-lockedout~}"
        title="{~D:Record.Title~}"
        aria-pressed="{~D:Record.Active~}"
        aria-disabled="{~D:Record.LockedOut~}"
        onclick="_Pict.views['Theme-ModeToggle'].pickMode('{~D:Record.Mode~}');">
	{~TS:Theme-ModeToggle-Icon-Light:Record.IconLight~}{~TS:Theme-ModeToggle-Icon-Dark:Record.IconDark~}{~TS:Theme-ModeToggle-Icon-System:Record.IconSystem~}<span class="pict-theme-modetoggle-label">{~D:Record.Label~}</span>
</button>`
		},
		{
			Hash: 'Theme-ModeToggle-LockedNote-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-locked-note" role="note">
	<svg class="pict-theme-modetoggle-locked-icon" viewBox="0 0 24 24" fill="none"
	     stroke="currentColor" stroke-width="2" stroke-linecap="round"
	     stroke-linejoin="round" aria-hidden="true">
		<rect x="4" y="11" width="16" height="9" rx="2"/>
		<path d="M8 11V7a4 4 0 0 1 8 0v4"/>
	</svg>
	<span>{~D:Record.Message~}</span>
</div>`
		},
		// Icon templates pull SVG markup from the shared Theme-Icons
		// module so the picker, toggle, and topbar button stay visually
		// consistent — change the glyph in one place, every consumer
		// updates.
		{
			Hash: 'Theme-ModeToggle-Icon-Light',
			Template: libThemeIcons.iconSun()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-Dark',
			Template: libThemeIcons.iconMoon()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-System',
			Template: libThemeIcons.iconSystem()
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ModeToggle-Renderable',
			TemplateHash: 'Theme-ModeToggle-Template',
			ContentDestinationAddress: '#Theme-ModeToggle',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-modetoggle-wrap { display: inline-flex; flex-direction: column; gap: 6px; }
.pict-theme-modetoggle {
	display: inline-flex;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	border-radius: 6px;
	overflow: hidden;
	background: var(--theme-color-background-secondary, #fbfbfc);
	font-size: 12px;
}
.pict-theme-modetoggle-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	border: 0;
	background: transparent;
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	border-right: 1px solid var(--theme-color-border-default, #cfd5dd);
	transition: background-color 120ms ease, color 120ms ease;
}
.pict-theme-modetoggle-btn:last-child { border-right: 0; }
.pict-theme-modetoggle-btn:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-text-primary, #1f2933);
}
.pict-theme-modetoggle-btn-active {
	background: var(--theme-color-brand-primary, #2563eb);
	color: var(--theme-color-text-on-brand, #ffffff);
}
.pict-theme-modetoggle-btn-active:hover {
	background: var(--theme-color-brand-primary-hover, #1e54cc);
	color: var(--theme-color-text-on-brand, #ffffff);
}
/* When the active theme is single-mode the entire group becomes
   non-interactive. The locked-out buttons (the ones the theme cannot
   switch to) get a strikethrough so the cause is unmistakable; the
   active button stays styled normally so users can still see which
   mode the theme IS using. */
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn {
	pointer-events: none;
	cursor: not-allowed;
}
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn-lockedout {
	opacity: 0.45;
	text-decoration: line-through;
	text-decoration-thickness: 1.5px;
}
/* Icons come from Theme-Icons.js with explicit width/height baked into
   the <svg>. We only need to nudge their vertical alignment with the
   button label. */
.pict-theme-modetoggle .pict-theme-icon {
	display: inline-block; vertical-align: -2px;
}
.pict-theme-modetoggle-label { line-height: 1; }
.pict-theme-modetoggle-locked-note {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	line-height: 1.3;
	color: var(--theme-color-text-muted, #6b6b6b);
	padding: 0 2px;
}
.pict-theme-modetoggle-locked-icon {
	width: 12px; height: 12px;
	flex: 0 0 12px;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

// The icon SVGs themselves live as templates above (Theme-ModeToggle-Icon-*).
// Per CLAUDE.md "AppData stores data, not HTML" — we drive icon selection
// with one-or-zero element arrays (`Record.IconLight = [{}]` to render the
// Light icon, `[]` to skip it). Each template is keyed off `Record.Mode`.

class PictViewThemeModeToggle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — flip mode on the active theme. Single-mode themes
	 * silently ignore (the toggle is shown disabled in that case anyway).
	 */
	pickMode(pMode)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;
		let tmpOk = tmpProvider.setMode(pMode);

		if (tmpOk && typeof this.options.OnModeChange === 'function')
		{
			try { this.options.OnModeChange(pMode); }
			catch (pErr) { /* host hook failure */ }
		}

		// setMode fires onApply listeners which trigger our own re-render.
		// If single-mode rejected the change, force a re-render so the UI
		// state is still consistent.
		if (!tmpOk)
		{
			this.render();
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : null;
		let tmpActiveMode = (tmpActive && tmpActive.Mode) || 'light';

		// Detect single-mode (Strategy === 'single') so we can lock the
		// toggle and surface the reason the buttons aren't responding.
		let tmpDisabled = false;
		let tmpLockedToMode = null;
		let tmpThemeName = null;
		if (tmpActive && tmpActive.Hash && tmpProvider && typeof tmpProvider.getTheme === 'function')
		{
			let tmpBundle = tmpProvider.getTheme(tmpActive.Hash);
			let tmpStrategy = (tmpBundle && tmpBundle.Modes && tmpBundle.Modes.Strategy) || 'single';
			tmpDisabled = (tmpStrategy === 'single');
			if (tmpDisabled)
			{
				tmpLockedToMode = (tmpBundle.Modes && tmpBundle.Modes.Default) || tmpActiveMode || 'light';
				tmpThemeName = tmpBundle.Name || tmpBundle.Hash || 'this theme';
			}
		}

		let tmpLabels = this.options.Labels || _ViewConfiguration.Labels;
		let tmpShowIcons = (this.options.ShowIcons !== false);

		// Use one-or-zero element arrays to drive each icon template so
		// the icon SVG never gets stuffed into AppData as a raw string.
		let tmpModeRows =
		[
			{ Mode: 'light',  Label: tmpLabels.Light  || 'Light' },
			{ Mode: 'dark',   Label: tmpLabels.Dark   || 'Dark' },
			{ Mode: 'system', Label: tmpLabels.System || 'System' }
		];
		let tmpButtons = [];
		for (let i = 0; i < tmpModeRows.length; i++)
		{
			let tmpRow = tmpModeRows[i];
			let tmpIsActive = (tmpActiveMode === tmpRow.Mode);
			// "Locked out" = single-mode theme AND this button is not the
			// mode the theme is fixed to. The active button keeps normal
			// styling so users can still see which mode is in use.
			let tmpLockedOut = tmpDisabled && (tmpRow.Mode !== tmpLockedToMode);
			let tmpTitle;
			if (tmpLockedOut)
			{
				let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
				tmpTitle = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode — pick a different theme to switch.';
			}
			else
			{
				tmpTitle = tmpRow.Label + ' mode';
			}
			tmpButtons.push(
			{
				Mode: tmpRow.Mode,
				Label: tmpRow.Label,
				Title: tmpTitle,
				Active: tmpIsActive,
				LockedOut: tmpLockedOut,
				IconLight:  (tmpShowIcons && tmpRow.Mode === 'light')  ? [{}] : [],
				IconDark:   (tmpShowIcons && tmpRow.Mode === 'dark')   ? [{}] : [],
				IconSystem: (tmpShowIcons && tmpRow.Mode === 'system') ? [{}] : []
			});
		}

		// One-or-zero element array drives the locked-note template
		// (per CLAUDE.md "single-element-array trick"). Empty array →
		// note skipped entirely.
		let tmpLockedNoteSlot = [];
		let tmpWrapTitle = '';
		if (tmpDisabled)
		{
			let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
			let tmpMessage = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode';
			tmpLockedNoteSlot = [{ Message: tmpMessage }];
			tmpWrapTitle = tmpMessage + ' — pick a different theme to switch modes.';
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ModeToggle =
		{
			ActiveMode: tmpActiveMode,
			Disabled: tmpDisabled,
			LockedToMode: tmpLockedToMode,
			ThemeName: tmpThemeName,
			Buttons: tmpButtons,
			LockedNoteSlot: tmpLockedNoteSlot,
			WrapTitle: tmpWrapTitle
		};
	}
}

PictViewThemeModeToggle.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeModeToggle;

},{"../Theme-Icons.js":31,"pict-view":68}],62:[function(require,module,exports){
/**
 * Theme-Picker — a custom dropdown that lists every theme registered
 * with the Theme provider, grouped by category.
 *
 * Renders as a trigger button showing the active theme name + a chevron.
 * Click → opens a `pict-section-modal` dropdown menu where each row is
 * the theme name plus an inline SVG glyph indicating the modes the
 * theme supports (sun for light-only, moon for dark-only, sun+moon for
 * paired). This is why we ditched the native <select>: option elements
 * can't render SVG, only plain text, and the unicode crescent
 * substitutes that earlier looked like dental glyphs.
 *
 * Subscribes to `provider.onApply` so a theme switch from elsewhere
 * (the modal-tucked picker, a hotkey, persistence restore) keeps the
 * trigger button in sync.
 *
 * Drop-in destination: `<div id="Theme-Picker"></div>`.
 *
 * # Modal section dependency
 *
 * Requires pict-section-modal to be registered (the dropdown popover
 * is a modal-section feature, not a hand-rolled DOM widget). When
 * pict-section-theme.install() is used, the host always has the modal
 * section available because Theme-Button needs it too. If you add this
 * view manually without the modal section, the trigger button will
 * still render but clicking it logs a warning and no-ops.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

// AppData address used to surface picker state to templates.
const APPDATA_ADDRESS = 'PictSectionTheme.Picker';

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Picker',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Picker',
	DefaultRenderable: 'Theme-Picker-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Optional categories block — array describing the optgroup order.
	// If omitted we discover categories from the provider's themes in
	// first-seen order.
	Categories: null,

	// Show the per-row mode-capability glyph (sun / moon / sun+moon) as
	// the leading icon on each dropdown item. Default on. Pass false if
	// you want a plainer menu.
	ShowModeIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-Picker-Template',
			// Trigger button that mirrors a native <select>'s look but
			// can carry SVG content. Clicking opens the modal dropdown.
			Template: /*html*/`
<button type="button" class="pict-theme-picker"
        title="{~D:AppData.PictSectionTheme.Picker.TriggerTooltip~}"
        onclick="_Pict.views['Theme-Picker'].openMenu(this);">
	{~TS:Theme-Picker-Trigger-Glyph:AppData.PictSectionTheme.Picker.TriggerGlyphSlot~}
	<span class="pict-theme-picker-name">{~D:AppData.PictSectionTheme.Picker.ActiveLabel~}</span>
	<span class="pict-theme-picker-chevron">{~D:AppData.PictSectionTheme.Picker.ChevronHTML~}</span>
</button>`
		},
		{
			// Wrapped in a 1-or-0 element array so the trigger glyph is
			// optional (ShowModeIcons: false → empty slot, no leading
			// icon). Per CLAUDE.md "AppData stores data, not HTML".
			Hash: 'Theme-Picker-Trigger-Glyph',
			Template: /*html*/`<span class="pict-theme-picker-trigger-glyph">{~D:Record.IconHTML~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Picker-Renderable',
			TemplateHash: 'Theme-Picker-Template',
			ContentDestinationAddress: '#Theme-Picker',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-picker {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 200px;
	max-width: 100%;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
	text-align: left;
	transition: border-color 120ms ease, box-shadow 120ms ease;
}
.pict-theme-picker:hover { border-color: var(--theme-color-text-muted, #6b6b6b); }
.pict-theme-picker:focus, .pict-theme-picker:focus-visible {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.pict-theme-picker .pict-theme-picker-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-theme-picker .pict-theme-picker-chevron {
	color: var(--theme-color-text-muted, #6b6b6b);
	display: inline-flex;
	align-items: center;
}
.pict-theme-picker-trigger-glyph {
	display: inline-flex; align-items: center;
	color: var(--theme-color-text-muted, #6b6b6b);
}

/* Skin the modal-dropdown items with cleaner spacing for our glyphs. */
.pict-theme-picker-menu .pict-modal-dropdown-item-icon {
	width: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	color: var(--theme-color-text-muted, #6b6b6b);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active {
	background: var(--theme-color-background-selected, #e0eaff);
	color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active .pict-modal-dropdown-item-icon {
	color: var(--theme-color-brand-primary, #2563eb);
}`,
	CSSPriority: 500
};

class PictViewThemePicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the rich dropdown menu via pict-section-modal.
	 * @param {HTMLElement} pAnchor - the trigger button (click target)
	 */
	openMenu(pAnchor)
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-Picker: pict-section-modal not registered — cannot open menu.');
			}
			return null;
		}

		let tmpItems = this._buildMenuItems();
		let tmpSelf = this;
		return tmpModal.dropdown(pAnchor,
		{
			items: tmpItems,
			align: 'left',
			minWidth: '260px',
			maxHeight: '60vh',
			className: 'pict-theme-picker-menu',
			closeOnSelect: true,
			onSelect: function (pHash) { tmpSelf.pick(pHash); }
		});
	}

	/**
	 * Apply the picked theme. Public so external callers can drive the
	 * picker programmatically too (hotkeys, tests, etc.).
	 */
	pick(pHash)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;

		// Preserve the current user-facing mode if the new theme
		// supports modes. Single-mode themes will clamp internally.
		let tmpActive = tmpProvider.getActiveTheme();
		let tmpMode = tmpActive ? tmpActive.Mode : null;

		let tmpOk = tmpProvider.applyTheme(pHash, tmpMode);

		if (tmpOk && typeof this.options.OnPick === 'function')
		{
			try { this.options.OnPick(pHash); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	/**
	 * Build the modal-dropdown `items` array from the registered themes
	 * + the catalog's category metadata. One Header row per category,
	 * one item per theme with a leading SVG capability glyph.
	 */
	_buildMenuItems()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		let tmpCatalog = this._loadCatalog();
		let tmpCategoryByHash = {};
		let tmpCategoryOrder = [];
		if (Array.isArray(this.options.Categories))
		{
			tmpCategoryOrder = this.options.Categories.slice();
		}
		for (let i = 0; i < tmpCatalog.length; i++)
		{
			let tmpEntry = tmpCatalog[i];
			let tmpCat = tmpEntry.Category || 'Other';
			tmpCategoryByHash[tmpEntry.Hash] = tmpCat;
			if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
		}

		let tmpBuckets = {};
		for (let i = 0; i < tmpThemes.length; i++)
		{
			let tmpTheme = tmpThemes[i];
			let tmpCat = tmpCategoryByHash[tmpTheme.Hash] || 'Other';
			if (!tmpBuckets[tmpCat])
			{
				tmpBuckets[tmpCat] = [];
				if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
			}
			tmpBuckets[tmpCat].push(tmpTheme);
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpItems = [];
		for (let i = 0; i < tmpCategoryOrder.length; i++)
		{
			let tmpCat = tmpCategoryOrder[i];
			if (!tmpBuckets[tmpCat] || tmpBuckets[tmpCat].length === 0) continue;
			tmpItems.push({ Header: tmpCat });
			for (let j = 0; j < tmpBuckets[tmpCat].length; j++)
			{
				let tmpTheme = tmpBuckets[tmpCat][j];
				let tmpIcon = tmpShowIcons
					? libThemeIcons.iconForTheme(tmpTheme.Strategy, tmpTheme.DefaultMode, 14)
					: '';
				tmpItems.push(
				{
					Hash: tmpTheme.Hash,
					Label: tmpTheme.Name || tmpTheme.Hash,
					Icon: tmpIcon,
					Style: (tmpTheme.Hash === tmpActiveHash) ? 'active' : null,
					Tooltip: this._capabilityLabel(tmpTheme)
				});
			}
		}

		return tmpItems;
	}

	_capabilityLabel(pTheme)
	{
		let tmpStrategy = pTheme.Strategy || 'single';
		if (tmpStrategy === 'single')
		{
			let tmpMode = pTheme.DefaultMode || 'light';
			return (pTheme.Name || pTheme.Hash) + ' — '
				+ (tmpMode === 'dark' ? 'dark only' : 'light only');
		}
		return (pTheme.Name || pTheme.Hash) + ' — light + dark';
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		// Find the active theme's metadata for the trigger glyph.
		let tmpActiveTheme = null;
		for (let i = 0; i < tmpThemes.length; i++)
		{
			if (tmpThemes[i].Hash === tmpActiveHash) { tmpActiveTheme = tmpThemes[i]; break; }
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpTriggerGlyphSlot = [];
		if (tmpShowIcons && tmpActiveTheme)
		{
			tmpTriggerGlyphSlot = [{
				IconHTML: libThemeIcons.iconForTheme(tmpActiveTheme.Strategy, tmpActiveTheme.DefaultMode, 14)
			}];
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Picker =
		{
			ActiveHash: tmpActiveHash,
			ActiveLabel: tmpActiveTheme ? (tmpActiveTheme.Name || tmpActiveTheme.Hash) : 'Choose a theme',
			TriggerTooltip: tmpActiveTheme
				? this._capabilityLabel(tmpActiveTheme) + ' — click to change'
				: 'Choose a theme',
			TriggerGlyphSlot: tmpTriggerGlyphSlot,
			ChevronHTML: libThemeIcons.iconChevronDown(10)
		};
		this.pict.AppData.PictSectionTheme.AllThemes = tmpThemes;
	}

	_loadCatalog()
	{
		try { return require('../themes/_catalog.js'); }
		catch (pError) { return []; }
	}
}

PictViewThemePicker.default_configuration = _ViewConfiguration;
PictViewThemePicker.APPDATA_ADDRESS = APPDATA_ADDRESS;

module.exports = PictViewThemePicker;

},{"../Theme-Icons.js":31,"../themes/_catalog.js":37,"pict-view":68}],63:[function(require,module,exports){
/**
 * Theme-ScaleSelect — dropdown that picks a viewport scale (zoom).
 *
 * Independent of the active theme bundle: scale is a per-user
 * preference stored alongside ThemeHash + Mode in localStorage. Reads
 * presets from the Theme-Scale helper (or a host-supplied `Presets`
 * array). Subscribes to Theme-Scale.onChange so external scale changes
 * (the persisted boot apply, hotkeys, other code) keep the dropdown's
 * selected option in sync.
 *
 * Drop-in destination: `<div id="Theme-ScaleSelect"></div>`.
 */

const libPictView = require('pict-view');
const libThemeScale = require('../Theme-Scale.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ScaleSelect',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ScaleSelect',
	DefaultRenderable: 'Theme-ScaleSelect-Renderable',

	// Optional override of the preset list. Each entry: { Value: <number>, Label: <string> }.
	// When omitted we use libThemeScale.PRESETS.
	Presets: null,

	Templates:
	[
		{
			Hash: 'Theme-ScaleSelect-Template',
			Template: /*html*/`
<select class="pict-theme-scaleselect"
        title="{~D:AppData.PictSectionTheme.ScaleSelect.Tooltip~}"
        onchange="_Pict.views['Theme-ScaleSelect'].pickScale(parseFloat(this.value));">
	{~TS:Theme-ScaleSelect-Option-Template:AppData.PictSectionTheme.ScaleSelect.Options~}
</select>`
		},
		{
			Hash: 'Theme-ScaleSelect-Option-Template',
			Template: /*html*/`
<option value="{~D:Record.Value~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ScaleSelect-Renderable',
			TemplateHash: 'Theme-ScaleSelect-Template',
			ContentDestinationAddress: '#Theme-ScaleSelect',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-scaleselect {
	min-width: 180px;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
}
.pict-theme-scaleselect:focus {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}`,
	CSSPriority: 500
};

class PictViewThemeScaleSelect extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromScale = null;
	}

	onAfterInitialize()
	{
		this._subscribeToScale();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onchange handler — apply a new scale and let the listener re-render.
	 * @param {number} pScale
	 */
	pickScale(pScale)
	{
		let tmpApplied = libThemeScale.applyScale(pScale);
		if (typeof this.options.OnScaleChange === 'function')
		{
			try { this.options.OnScaleChange(tmpApplied); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpApplied;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToScale()
	{
		if (this._unsubscribeFromScale) return;
		let tmpSelf = this;
		this._unsubscribeFromScale = libThemeScale.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpPresets = Array.isArray(this.options.Presets) ? this.options.Presets : libThemeScale.PRESETS;
		let tmpActive = libThemeScale.getActive();

		// "Closest" match — the saved scale may be a custom value (e.g.
		// 1.10 from a hotkey nudge) that doesn't exactly equal any preset.
		// We highlight the nearest option so the dropdown still reflects
		// roughly where the user is.
		let tmpClosestIdx = 0;
		let tmpClosestDelta = Infinity;
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpDelta = Math.abs(tmpPresets[i].Value - tmpActive);
			if (tmpDelta < tmpClosestDelta) { tmpClosestDelta = tmpDelta; tmpClosestIdx = i; }
		}

		let tmpOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpEntry = tmpPresets[i];
			tmpOptions.push(
			{
				Value: tmpEntry.Value,
				Label: tmpEntry.Label,
				Selected: (i === tmpClosestIdx)
			});
		}

		let tmpTooltip = 'Viewport scale — currently '
			+ Math.round(tmpActive * 100) + '%';

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ScaleSelect =
		{
			ActiveScale: tmpActive,
			Tooltip: tmpTooltip,
			Options: tmpOptions
		};
	}
}

PictViewThemeScaleSelect.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeScaleSelect;

},{"../Theme-Scale.js":33,"pict-view":68}],64:[function(require,module,exports){
/**
 * Theme-TopBar — standard application chrome row.
 *
 * Provides the boilerplate every Pict / retold app remakes: a flex row
 * with three zones — brand mark on the left, navigation in the middle,
 * configuration / user widgets on the right (with the theme button
 * pinned at the far edge).
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ [Brand-Mark]   [── Nav slot (flex-grow) ──]   [User-slot] [⚙]  │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Auto-mounts:
 *   - Theme-Brand-Mark in the brand slot (skip via MountBrandMark: false)
 *   - Theme-Button at the far right of the user area (skip via
 *     MountThemeButton: false)
 *
 * Host fills two empty slots via standard Pict view destinations:
 *   - `#Theme-TopBar-Nav`  — primary navigation / action buttons
 *   - `#Theme-TopBar-User` — app-specific user-area widgets (account,
 *                            log toggle, custom indicators)
 *
 * Renders into `#Theme-TopBar` by default. The host's layout shell
 * provides that destination — typically the top panel of a
 * pict-section-modal Shell.
 *
 * The bottom border uses `--brand-color-primary-mode` so the topbar
 * carries a thin brand stripe that auto-swaps with light/dark mode.
 *
 * Each app's nav / user-area views can stay app-specific; this view
 * eliminates the chrome boilerplate around them.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-TopBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-TopBar',
	DefaultRenderable: 'Theme-TopBar-Renderable',

	// When false, the host is responsible for mounting Theme-Brand-Mark
	// itself (or skipping the brand entirely).
	MountBrandMark: true,
	// When false, Theme-Button is not auto-mounted into the user slot.
	// Useful when the host wants to position the button somewhere else
	// or when no theme picker is desired.
	MountThemeButton: true,
	// ViewIdentifier of a host-supplied view that fills the nav slot
	// (#Theme-TopBar-Nav). Typical convention: a small per-app view
	// rendering primary action buttons / nav links / breadcrumbs.
	NavView: null,
	// ViewIdentifier of a host-supplied view that fills the user-area
	// slot (#Theme-TopBar-User). Theme-Button still auto-mounts at the
	// far edge — this view fills the slot before it.
	UserView: null,

	// Height of the bar in pixels. Drives the min-height on the
	// chrome row so it fills the panel cleanly even when the parent
	// chain (pict-section-modal shell uses min-height: 100% on its
	// panel content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 56,

	// Horizontal alignment of items inside the nav slot. The slot
	// itself stretches (flex: 1) between brand mark and user area;
	// this option controls where the nav content sits within that
	// stretched space. Default 'right' so action buttons hug the
	// user-area / theme button cluster (the convention every
	// retold-* app converged on). Override to 'left' to put the nav
	// flush against the brand, or 'center' to centre it across the
	// row. Maps to justify-content: flex-end / flex-start / center.
	NavAlign: 'right',

	// Viewport width (px) below which the topbar collapses to compact
	// mode: nav + user-area widgets hide, a burger button shows in
	// their place. Clicking the burger opens a pict-section-modal
	// popup with a clone of the nav + user DOM, so every action stays
	// reachable.
	//
	// Default 900px — the conventional "narrow desktop / small laptop"
	// cut-off where a topbar with ~4 nav buttons + a brand mark + a
	// user-area cluster genuinely starts crowding. Most users will
	// resize a window to this range (drag a split-pane, dock a window
	// next to another app, etc.); 600px would only trigger at true
	// mobile widths most desktop users never hit.
	//
	// Conventional ladder for picking a value:
	//   ~1024px  large breakpoint — nav-heavy apps with 6+ buttons
	//    ~900px  default — "narrow desktop window" (recommended)
	//    ~768px  tablet portrait — minimal-nav apps
	//    ~600px  mobile-only — single-button toolbars
	//        0   disable compact mode entirely
	CompactBreakpoint: 900,

	Templates:
	[
		{
			Hash: 'Theme-TopBar-Template',
			// The burger button is hidden by default and the regular nav /
			// user-slot are visible — flipped by the media query in CSS
			// at the CompactBreakpoint (default 600px). On click the
			// burger opens a pict-section-modal popup containing a clone
			// of the existing #Theme-TopBar-Nav + #Theme-TopBar-User DOM
			// — host apps don't need to provide a separate burger view.
			Template: /*html*/`
<div class="pict-theme-topbar">
	<div class="pict-theme-topbar-mark"><div id="Theme-Brand-Mark"></div></div>
	<div class="pict-theme-topbar-nav" id="Theme-TopBar-Nav"></div>
	<div class="pict-theme-topbar-user">
		<div class="pict-theme-topbar-user-slot" id="Theme-TopBar-User"></div>
		<div class="pict-theme-topbar-user-button"><div id="Theme-Button"></div></div>
		<button type="button" class="pict-theme-topbar-burger"
			aria-label="More navigation"
			title="Menu"
			onclick="_Pict.views['Theme-TopBar'].openBurgerMenu();">
			<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2"
				stroke-linecap="round" stroke-linejoin="round"
				aria-hidden="true">
				<path d="M3 6h18M3 12h18M3 18h18"/>
			</svg>
		</button>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-TopBar-Renderable',
			TemplateHash: 'Theme-TopBar-Template',
			ContentDestinationAddress: '#Theme-TopBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-topbar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 56). Avoids the percent-height resolution
	   trap: pict-section-modal's panel destination uses min-height: 100%
	   on its inner div, which means a child's height: 100% / min-height:
	   100% resolves against the parent's *property* (auto), not its
	   resolved size — and collapses the row to its content. A fixed px
	   value gives align-items: center real space to centre into. */
	min-height: 56px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-panel, transparent);
	/* Brand stripes are drawn by .pict-theme-topbar::after as an absolute
	   element overlaying the bottom 5px of the row. Using ::after rather
	   than border-bottom + box-shadow lets us put a transparent gap
	   between the two stripes (border / box-shadow can't draw gaps).
	   Position relative so the ::after positions to this row. */
	position: relative;
}
/* Two-stripe brand identifier at the bottom of the topbar:
     4px brand-primary (thicker — the dominant identifier)
     2px transparent gap (clearly readable separation)
     3px brand-secondary (thinner than primary but still substantial)
   Earlier iterations used 1–2px stripes; both read clearly at light
   mode but dark-mode secondary colors are often desaturated (lifted)
   so the eye can miss a thin band against a dark background. The
   current sizes push the secondary above the perception threshold
   regardless of palette. Stripes overlay the bottom 9px of the row;
   content (which centres in the full row via align-items: center)
   keeps its visual position. */
.pict-theme-topbar::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 9px;
	pointer-events: none;
	background: linear-gradient(
		to bottom,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 0,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 4px,
		transparent 4px,
		transparent 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 9px
	);
}
.pict-theme-topbar-mark {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
}
.pict-theme-topbar-nav {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	/* Default to right-aligning nav items inside the stretched slot —
	   the convention retold-* apps converged on. Overridden per-instance
	   from the NavAlign option in onAfterRender. */
	justify-content: flex-end;
	gap: 8px;
	min-width: 0;
	/* Horizontally scrollable when the nav overflows (narrow viewports
	   with many buttons) — better than overflow:hidden which would
	   silently clip buttons offscreen. The vertical axis stays clipped
	   so a tall accidental child doesn't blow up the row height. A
	   proper overflow menu is a future enhancement; this gets us safe
	   degradation today. */
	overflow-x: auto;
	overflow-y: hidden;
	/* Hide the scrollbar by default; modern browsers pick up the
	   trackpad scroll without it. Apps wanting a visible scrollbar
	   can override at higher specificity. */
	scrollbar-width: none;
}
.pict-theme-topbar-nav::-webkit-scrollbar { display: none; }
/* Active-route indicator. The convention every host app should follow:
   put aria-current="page" on the button (or anchor) representing the
   current route. The W3C-standard attribute reads correctly to screen
   readers and gets a brand-tinted highlight here. Apps that already
   ship their own active styling can override these rules — they're
   keyed off attribute selectors so no class collision is possible. */
.pict-theme-topbar-nav [aria-current="page"],
.pict-theme-topbar-user [aria-current="page"] {
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	background: var(--theme-color-background-hover, rgba(37, 99, 235, 0.08));
}
.pict-theme-topbar-user {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-slot {
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-button {
	display: flex;
	align-items: center;
}
/* Burger button — hidden by default; the media query (or the inline
   per-instance JS that swaps it via CompactBreakpoint) shows it once
   the viewport drops below the host's compact threshold. Sized to
   match Theme-Button (28×28) so the row's rhythm is preserved. */
.pict-theme-topbar-burger {
	display: none;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-topbar-burger:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Burger menu popup — applied to the cloned nav + user DOM inside
   pict-section-modal. The cloned children inherit their original
   styling (action buttons, badges, etc.) so the popup looks visually
   consistent with what was on the topbar. */
.pict-theme-burger-menu {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.pict-theme-burger-menu-section {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
/* Cloned children render as a vertical stack inside the popup — flip
   the horizontal flex layouts to column so each button takes a full
   row instead of cramming side-by-side at narrow width. */
.pict-theme-burger-menu .rm-topbar-nav,
.pict-theme-burger-menu .rm-topbar-user,
.pict-theme-burger-menu [class*="-topbar-nav"],
.pict-theme-burger-menu [class*="-topbar-user"] {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 6px;
}
.pict-theme-burger-menu button { width: 100%; text-align: left; }
.pict-theme-burger-menu .rm-topbar-nav-divider,
.pict-theme-burger-menu [class*="divider"] { display: none; }
/* Compact mode — defaults to a 900px breakpoint. The onAfterRender
   handler injects a per-instance <style> rule when the host passes a
   different CompactBreakpoint, so this @media block is the fallback
   for hosts that accept the default. */
@media (max-width: 900px) {
	.pict-theme-topbar-nav            { display: none !important; }
	.pict-theme-topbar-user-slot      { display: none !important; }
	.pict-theme-topbar-burger         { display: inline-flex; }
	/* In wide mode the flex-1 nav slot pushes the user-area to the
	   right edge. With the nav hidden the user-area would collapse
	   left of the now-empty middle; the auto-margin re-creates the
	   "push right" effect so the theme button + burger stay flush
	   against the right edge of the topbar. */
	.pict-theme-topbar-user           { margin-left: auto; }
}`,
	CSSPriority: 500
};

class PictViewThemeTopBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-topbar.
		// Using inline style so each instance can carry its own size
		// (different apps will pick different heights) without us having
		// to inject per-instance <style> blocks.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-topbar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		// Per-instance CompactBreakpoint. CSS @media rules can't reference
		// JS option values, so when the host overrides the default 600px
		// we inject a single-rule <style> with the chosen breakpoint and
		// !important to win over the static media query. Set to 0 to
		// disable compact mode entirely (the burger stays hidden).
		this._applyCompactBreakpoint();

		// Translate NavAlign ('left' | 'right' | 'center') to the matching
		// justify-content. Right is the default (and already in the static
		// CSS), but the inline style wins so an explicit option always
		// takes precedence over the cached stylesheet.
		if (typeof document !== 'undefined' && this.options.NavAlign)
		{
			let tmpJustify = ({
				left:   'flex-start',
				right:  'flex-end',
				center: 'center'
			})[this.options.NavAlign];
			if (tmpJustify)
			{
				let tmpNav = document.querySelector('.pict-theme-topbar-nav');
				if (tmpNav) { tmpNav.style.justifyContent = tmpJustify; }
			}
		}

		// Auto-mount the standard pieces. Host can opt out via the view
		// options (MountBrandMark / MountThemeButton).
		if (this.options.MountBrandMark !== false)
		{
			let tmpBrandMark = this.pict.views['Theme-Brand-Mark'];
			if (tmpBrandMark) { tmpBrandMark.render(); }
		}
		if (this.options.NavView)
		{
			let tmpNavView = this.pict.views[this.options.NavView];
			if (tmpNavView) { tmpNavView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: NavView "' + this.options.NavView + '" not registered');
			}
		}
		if (this.options.UserView)
		{
			let tmpUserView = this.pict.views[this.options.UserView];
			if (tmpUserView) { tmpUserView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: UserView "' + this.options.UserView + '" not registered');
			}
		}
		if (this.options.MountThemeButton !== false)
		{
			let tmpThemeButton = this.pict.views['Theme-Button'];
			if (tmpThemeButton) { tmpThemeButton.render(); }
		}

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Apps with chrome that morphs between routes (e.g. breadcrumb-style
	// navigation that differs by section) call setNavView / setUserView
	// from their router callback. The new view is rendered into the
	// matching slot and the option is persisted so subsequent re-renders
	// of the topbar (theme switches, etc.) keep the new view mounted.

	/**
	 * Swap the NavView (slot at `#Theme-TopBar-Nav`) at runtime.
	 * @param {string|null} pViewIdentifier
	 *   View hash to mount, or null to clear the slot.
	 */
	setNavView(pViewIdentifier)
	{
		this.options.NavView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-Nav', this.options.NavView);
	}

	/**
	 * Swap the UserView (slot at `#Theme-TopBar-User`) at runtime.
	 * @param {string|null} pViewIdentifier
	 */
	setUserView(pViewIdentifier)
	{
		this.options.UserView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-User', this.options.UserView);
	}

	_mountSlot(pDestSelector, pViewIdentifier)
	{
		// Clear the slot first — handles both the clear-only case
		// (pViewIdentifier is null) and the swap case (gives the
		// new view a clean slate when its renderable doesn't use
		// `replace` mode).
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-TopBar: view "' + pViewIdentifier + '" not registered');
		}
	}

	// ─── Compact mode + burger menu ──────────────────────────────────────
	// At narrow widths the nav + user-area slots collapse into a single
	// burger button that opens a pict-section-modal popup with the
	// cloned nav + user DOM. The default breakpoint is 600px; hosts that
	// want a different value pass CompactBreakpoint in ViewOptions.

	_applyCompactBreakpoint()
	{
		if (typeof document === 'undefined') return;
		// Default value of 900 lives in the static CSS @media block; we
		// only need to inject when the host explicitly overrode it.
		let tmpBreakpoint = this.options.CompactBreakpoint;
		if (tmpBreakpoint === undefined || tmpBreakpoint === null) return;
		if (tmpBreakpoint === 900) return;  // matches default — no override needed

		let tmpStyleId = 'pict-theme-topbar-compact-' + this.UUID;
		let tmpStyleEl = document.getElementById(tmpStyleId);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = tmpStyleId;
			document.head.appendChild(tmpStyleEl);
		}

		// 0 (or any non-positive value) disables compact mode by emitting
		// a never-matching media rule. The static CSS still has the 600px
		// rule, so we override it with a more-specific selector + the
		// chosen breakpoint. Specificity-wise the inline rule wins
		// because it's emitted after the static CSS and has !important
		// matching the static rule's importance.
		if (typeof tmpBreakpoint !== 'number' || tmpBreakpoint <= 0)
		{
			// Disable: force compact selectors to never apply by giving
			// the burger display: none unconditionally at all widths.
			tmpStyleEl.textContent =
				'.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'.pict-theme-topbar-burger         { display: none !important; }\n' +
				'.pict-theme-topbar-user           { margin-left: 0 !important; }\n';
		}
		else
		{
			tmpStyleEl.textContent =
				'@media (max-width: ' + tmpBreakpoint + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: none !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: none !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: inline-flex !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: auto !important; }\n' +
				'}\n' +
				'@media (min-width: ' + (tmpBreakpoint + 1) + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: none !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: 0 !important; }\n' +
				'}\n';
		}
	}

	/**
	 * Open the burger / overflow menu. Clones the current contents of
	 * `#Theme-TopBar-Nav` and `#Theme-TopBar-User` into a
	 * pict-section-modal popup so every action stays reachable at narrow
	 * widths. The cloned buttons keep their inline `onclick` handlers
	 * (those reference globals like `_Pict.PictApplication.*`, which
	 * resolve at click-time regardless of where the DOM lives).
	 *
	 * Override on the instance (`view.openBurgerMenu = function() {...}`)
	 * to customise the popup contents — e.g. emit a per-app menu view
	 * instead of cloning the topbar DOM.
	 */
	openBurgerMenu()
	{
		if (typeof document === 'undefined') return null;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-TopBar: pict-section-modal not registered — burger menu unavailable.');
			}
			return null;
		}

		let tmpSections = [];
		let tmpNav = document.querySelector('#Theme-TopBar-Nav');
		let tmpUser = document.querySelector('#Theme-TopBar-User');
		if (tmpNav && tmpNav.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpNav.innerHTML + '</div>');
		}
		if (tmpUser && tmpUser.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpUser.innerHTML + '</div>');
		}
		if (tmpSections.length === 0)
		{
			tmpSections.push('<div class="pict-theme-burger-menu-empty">No menu items configured.</div>');
		}

		let tmpHTML = '<div class="pict-theme-burger-menu">' + tmpSections.join('') + '</div>';

		return tmpModal.show(
		{
			title:    'Menu',
			content:  tmpHTML,
			width:    '280px',
			closeable: true,
			buttons:  []
		});
	}
}

module.exports = PictViewThemeTopBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],65:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],66:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":65,"fable-serviceproviderbase":2}],67:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],68:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":67,"fable-serviceproviderbase":2}],69:[function(require,module,exports){
module.exports={
	"Name": "Pict Docuserve",
	"Hash": "Docuserve",

	"MainViewportViewIdentifier": "Docuserve-Layout",

	"AutoSolveAfterInitialize": true,
	"AutoRenderMainViewportViewAfterInitialize": false,
	"AutoRenderViewsAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "Docuserve-Pict-Application"
		}
}

},{}],70:[function(require,module,exports){
const libPictApplication = require('pict-application');

// Provider
const libDocumentationProvider = require('./providers/Pict-Provider-Docuserve-Documentation.js');
const libDemosProvider         = require('./providers/Pict-Provider-Docuserve-Demos.js');

// Shared modal + theme stack
const libPictSectionModal = require('pict-section-modal');
const libPictSectionTheme = require('pict-section-theme');

// Views
const libViewLayout       = require('./views/PictView-Docuserve-Layout.js');
const libViewTopBarNav    = require('./views/PictView-Docuserve-TopBar-Nav.js');
const libViewTopBarUser   = require('./views/PictView-Docuserve-TopBar-User.js');
const libViewSidebar      = require('./views/PictView-Docuserve-Sidebar.js');
const libViewSplash       = require('./views/PictView-Docuserve-Splash.js');
const libViewContent      = require('./views/PictView-Docuserve-Content.js');
const libViewSearch       = require('./views/PictView-Docuserve-Search.js');
const libViewDemo         = require('./views/PictView-Docuserve-Demo.js');

class DocuserveApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Add the documentation provider
		this.pict.addProvider('Docuserve-Documentation', libDocumentationProvider.default_configuration, libDocumentationProvider);

		// Add the demos registry provider.  Libraries that ship demos
		// (e.g. pict-section-form, pict-section-code) call
		// `pict.providers['Docuserve-Demos'].registerAll([...])` at
		// app boot to populate it.
		this.pict.addProvider('Docuserve-Demos', libDemosProvider.default_configuration, libDemosProvider);

		// Modal section — drives the shell() + addPanel() layout machinery,
		// plus dialogs / tooltips / toasts.
		this.pict.addView('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);

		// Add views — the layout, sidebar, splash, content, search are
		// docuserve's own content surfaces.  The two TopBar-* slot views
		// fill the Theme-TopBar's Nav and User slots.
		this.pict.addView('Docuserve-Layout',       libViewLayout.default_configuration,       libViewLayout);
		this.pict.addView('Docuserve-TopBar-Nav',   libViewTopBarNav.default_configuration,    libViewTopBarNav);
		this.pict.addView('Docuserve-TopBar-User',  libViewTopBarUser.default_configuration,   libViewTopBarUser);
		this.pict.addView('Docuserve-Sidebar',      libViewSidebar.default_configuration,      libViewSidebar);
		this.pict.addView('Docuserve-Splash',       libViewSplash.default_configuration,       libViewSplash);
		this.pict.addView('Docuserve-Content',      libViewContent.default_configuration,      libViewContent);
		this.pict.addView('Docuserve-Search',       libViewSearch.default_configuration,       libViewSearch);
		this.pict.addView('Docuserve-Demo',         libViewDemo.default_configuration,         libViewDemo);

		// Theme section provider.  Wires the pict-provider-theme runtime,
		// the bundled theme catalog (retold-default, retold-content-system,
		// retold-manager, …), and the picker + mode-toggle + scale-select
		// + BrandMark + TopBar chrome views.  The TopBar mounts the two
		// slot views above (TopBar-Nav for navigation + version, TopBar-User
		// for search + external links).
		//
		// Host applications subclassing DocuserveApplication can pass their
		// own `Brand` block via constructor options.Brand or by overriding
		// in onAfterInitializeAsync before calling super.  The fallback
		// shape is intentionally minimal so vanilla pict-docuserve works
		// out of the box without any branding setup.
		let tmpBrand = (pOptions && pOptions.Brand) ? pOptions.Brand : null;
		this.pict.addProvider('Theme-Section',
		{
			ApplyDefault: 'retold-default',
			DefaultMode:  'system',
			DefaultScale: 1.0,
			Brand:        tmpBrand,
			// 'Button' is intentionally omitted — docuserve has no settings
			// panel to host theme controls.  We add a Theme-Button into the
			// User slot view instead (a topbar popover trigger).
			Views: ['Picker', 'ModeToggle', 'ScaleSelect', 'Button', 'BrandMark', 'TopBar'],
			ViewOptions:
			{
				// Height matches the topbar panel Size in the Layout view.
				TopBar: { NavView: 'Docuserve-TopBar-Nav', UserView: 'Docuserve-TopBar-User', Height: 56 }
			}
		}, libPictSectionTheme);
	}

	onAfterInitializeAsync(fCallback)
	{
		// Initialize application state
		this.pict.AppData.Docuserve =
		{
			CatalogLoaded: false,
			Catalog: null,
			CoverLoaded: false,
			Cover: null,
			SidebarLoaded: false,
			SidebarGroups: [],
			TopBarLoaded: false,
			TopBar: null,
			VersionLoaded: false,
			Version: null,
			ErrorPageLoaded: false,
			ErrorPageHTML: null,
			KeywordIndexLoaded: false,
			KeywordDocumentCount: 0,
			CurrentGroup: '',
			CurrentModule: '',
			CurrentPath: '',
			// Whether the sidebar is currently visible
			SidebarVisible: true,
			// Base URL for local docs (relative to where the app is served)
			DocsBaseURL: '',
			// URL for the catalog JSON
			CatalogURL: 'retold-catalog.json'
		};

		// Load the catalog, then render the layout
		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		tmpDocProvider.loadCatalog(() =>
		{
			// Set the page title to match the stamped <title> pattern
			// "<DisplayName> v<Version> Documentation" so the browser
			// tab and the static HTML metadata stay in sync.  Falls back
			// to the cover/topbar brand alone when no version is loaded.
			let tmpDocuserve = this.pict.AppData.Docuserve;
			let tmpDisplayName = '';
			if (tmpDocuserve.CoverLoaded && tmpDocuserve.Cover && tmpDocuserve.Cover.Title)
			{
				tmpDisplayName = tmpDocuserve.Cover.Title.replace(/<[^>]*>/g, '').trim();
			}
			else if (tmpDocuserve.TopBarLoaded && tmpDocuserve.TopBar && tmpDocuserve.TopBar.Brand)
			{
				tmpDisplayName = tmpDocuserve.TopBar.Brand.replace(/<[^>]*>/g, '').trim();
			}
			if (tmpDisplayName)
			{
				if (tmpDocuserve.VersionLoaded && tmpDocuserve.Version && tmpDocuserve.Version.Version)
				{
					document.title = `${tmpDisplayName} v${tmpDocuserve.Version.Version} Documentation`;
				}
				else
				{
					document.title = tmpDisplayName;
				}
			}

			// Render the layout shell, which triggers child view rendering
			this.pict.views['Docuserve-Layout'].render();

			return super.onAfterInitializeAsync(fCallback);
		});
	}

	/**
	 * Read the current window.location.hash and dispatch to the correct handler.
	 *
	 * Route patterns:
	 *   #/Home                         -> showView('Docuserve-Splash')
	 *   #/search/<query>               -> navigateToSearch(query)
	 *   #/page/<docpath>               -> navigateToPage(docpath)
	 *   #/doc/<group>/<module>          -> navigateToModule(group, module)
	 *   #/doc/<group>/<module>/<path>   -> navigateToModulePath(group, module, path)
	 */
	resolveHash()
	{
		let tmpHash = (window.location.hash || '').replace(/^#\/?/, '');

		if (!tmpHash || tmpHash === 'Home')
		{
			this.showView('Docuserve-Splash');
			return;
		}

		let tmpParts = tmpHash.split('/');

		if (tmpParts[0] === 'search')
		{
			let tmpQuery = decodeURIComponent(tmpParts.slice(1).join('/'));
			this.navigateToSearch(tmpQuery);
			return;
		}

		if (tmpParts[0] === 'page' && tmpParts.length >= 2)
		{
			// Rejoin everything after 'page/' in case the path has slashes
			let tmpDocPath = tmpParts.slice(1).join('/');
			this.navigateToPage(tmpDocPath);
			return;
		}

		if (tmpParts[0] === 'doc' && tmpParts.length >= 3)
		{
			let tmpGroup = tmpParts[1];
			let tmpModule = tmpParts[2];
			if (tmpParts.length >= 4)
			{
				let tmpPath = tmpParts.slice(3).join('/');
				this.navigateToModulePath(tmpGroup, tmpModule, tmpPath);
			}
			else
			{
				this.navigateToModule(tmpGroup, tmpModule);
			}
			return;
		}

		// #/demo/<group>/<module>/<hash> — interactive demo registered
		// with Docuserve-Demos.  Mounts the demo's view into the content
		// area + renders any Sources tabs alongside.
		if (tmpParts[0] === 'demo' && tmpParts.length >= 4)
		{
			let tmpGroup = tmpParts[1];
			let tmpModule = tmpParts[2];
			let tmpHash = tmpParts.slice(3).join('/');
			this.navigateToDemo(tmpGroup, tmpModule, tmpHash);
			return;
		}

		// Unknown route — treat as a page
		this.navigateToPage(tmpHash);
	}

	/**
	 * Navigate to an interactive demo registered with Docuserve-Demos.
	 *
	 * @param {string} pGroup  - catalog group key
	 * @param {string} pModule - module name
	 * @param {string} pHash   - demo hash (unique within group/module)
	 */
	navigateToDemo(pGroup, pModule, pHash)
	{
		let tmpDemoView  = this.pict.views['Docuserve-Demo'];
		let tmpSidebarView = this.pict.views['Docuserve-Sidebar'];

		this.pict.AppData.Docuserve.CurrentGroup  = pGroup;
		this.pict.AppData.Docuserve.CurrentModule = pModule;
		this.pict.AppData.Docuserve.CurrentDemo   = pHash;
		this.pict.AppData.Docuserve.CurrentPath   = '';

		if (tmpDemoView && typeof tmpDemoView.showDemo === 'function')
		{
			tmpDemoView.showDemo(pGroup, pModule, pHash);
		}

		// Keep the sidebar in sync — show module-scoped demos + nav.
		if (tmpSidebarView)
		{
			tmpSidebarView.renderSidebarGroups();
			if (typeof tmpSidebarView.renderModuleNav === 'function')
			{
				tmpSidebarView.renderModuleNav(pGroup, pModule);
			}
		}
	}

	/**
	 * Navigate to a hash route.
	 *
	 * Sets window.location.hash, which triggers the hashchange listener in the
	 * layout view, which calls resolveHash() automatically.
	 *
	 * @param {string} pRoute - The route path (e.g. '/Home', '/page/quick-start')
	 */
	navigateTo(pRoute)
	{
		window.location.hash = pRoute;
	}

	/**
	 * Show a specific view in the content area.
	 *
	 * @param {string} pViewIdentifier - The view identifier to render
	 */
	showView(pViewIdentifier)
	{
		if (pViewIdentifier in this.pict.views)
		{
			this.pict.AppData.Docuserve.CurrentGroup = '';
			this.pict.AppData.Docuserve.CurrentModule = '';
			this.pict.AppData.Docuserve.CurrentPath = '';

			this.pict.views[pViewIdentifier].render();

			// Update sidebar to clear module nav and refresh active states
			this.pict.views['Docuserve-Sidebar'].clearModuleNav();
			this.pict.views['Docuserve-Sidebar'].renderSidebarGroups();
		}
	}

	/**
	 * Navigate to a module's documentation.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 */
	navigateToModule(pGroup, pModule)
	{
		this.navigateToModulePath(pGroup, pModule, 'README.md');
	}

	/**
	 * Navigate to a specific path within a module's documentation.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 * @param {string} pPath - The document path
	 */
	navigateToModulePath(pGroup, pModule, pPath)
	{
		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpContentView = this.pict.views['Docuserve-Content'];
		let tmpSidebarView = this.pict.views['Docuserve-Sidebar'];

		// Update current navigation state
		this.pict.AppData.Docuserve.CurrentGroup = pGroup;
		this.pict.AppData.Docuserve.CurrentModule = pModule;
		this.pict.AppData.Docuserve.CurrentPath = pPath;

		// Render the content view shell and show loading
		tmpContentView.render();
		tmpContentView.showLoading();

		// Update sidebar to show active module and module-specific nav
		tmpSidebarView.renderSidebarGroups();
		tmpSidebarView.renderModuleNav(pGroup, pModule);

		// Resolve the document URL and fetch it
		let tmpURL = tmpDocProvider.resolveDocumentURL(pGroup, pModule, pPath || 'README.md');

		if (!tmpURL)
		{
			tmpContentView.displayContent(tmpDocProvider.getErrorPageHTML(pGroup + '/' + pModule));
			return;
		}

		let tmpDocPath = pPath || 'README.md';
		tmpDocProvider.fetchDocument(tmpURL, (pError, pHTML) =>
		{
			if (!pError)
			{
				tmpContentView.displayContent(pHTML);
				return;
			}

			// Remote fetch failed — try a local fallback using the
			// group/module/path as a relative path.  This handles cases
			// where the catalog contains entries (e.g. example apps)
			// that don't correspond to real GitHub repositories.
			let tmpLocalPath = pGroup + '/' + pModule + '/' + tmpDocPath;
			tmpDocProvider.fetchLocalDocument(tmpLocalPath, (pLocalError, pLocalHTML) =>
			{
				tmpContentView.displayContent(pLocalHTML);
			}, pGroup, pModule, tmpDocPath);
		}, pGroup, pModule, tmpDocPath);
	}

	/**
	 * Navigate to a local documentation page (e.g. architecture.md).
	 *
	 * @param {string} pDocPath - The doc path without extension
	 */
	navigateToPage(pDocPath)
	{
		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpContentView = this.pict.views['Docuserve-Content'];
		let tmpSidebarView = this.pict.views['Docuserve-Sidebar'];

		// Update state
		this.pict.AppData.Docuserve.CurrentGroup = '';
		this.pict.AppData.Docuserve.CurrentModule = '';
		this.pict.AppData.Docuserve.CurrentPath = pDocPath;

		// Render the content view shell and show loading
		tmpContentView.render();
		tmpContentView.showLoading();

		// Clear module-specific sidebar nav
		tmpSidebarView.clearModuleNav();
		tmpSidebarView.renderSidebarGroups();

		// Fetch the local document
		let tmpPath = pDocPath;
		if (!tmpPath.match(/\.md$/))
		{
			tmpPath = tmpPath + '.md';
		}

		tmpDocProvider.fetchLocalDocument(tmpPath, (pError, pHTML) =>
		{
			// fetchDocument always provides displayable HTML in pHTML,
			// even on error, so we can use it directly.
			tmpContentView.displayContent(pHTML);
		});
	}

	/**
	 * Navigate to the search page with an optional query.
	 *
	 * @param {string} pQuery - The search query (may be empty for blank search page)
	 */
	navigateToSearch(pQuery)
	{
		let tmpSidebarView = this.pict.views['Docuserve-Sidebar'];
		let tmpSearchView = this.pict.views['Docuserve-Search'];

		// Update state
		this.pict.AppData.Docuserve.CurrentGroup = '';
		this.pict.AppData.Docuserve.CurrentModule = '';
		this.pict.AppData.Docuserve.CurrentPath = '';

		// Clear module-specific sidebar nav
		tmpSidebarView.clearModuleNav();
		tmpSidebarView.renderSidebarGroups();

		// Render the search view with the query
		tmpSearchView.render();
		tmpSearchView.showSearch(pQuery || '');
	}
}

module.exports = DocuserveApplication;

module.exports.default_configuration = require('./Pict-Application-Docuserve-Configuration.json');

},{"./Pict-Application-Docuserve-Configuration.json":69,"./providers/Pict-Provider-Docuserve-Demos.js":71,"./providers/Pict-Provider-Docuserve-Documentation.js":72,"./views/PictView-Docuserve-Content.js":73,"./views/PictView-Docuserve-Demo.js":74,"./views/PictView-Docuserve-Layout.js":75,"./views/PictView-Docuserve-Search.js":76,"./views/PictView-Docuserve-Sidebar.js":77,"./views/PictView-Docuserve-Splash.js":78,"./views/PictView-Docuserve-TopBar-Nav.js":79,"./views/PictView-Docuserve-TopBar-User.js":80,"pict-application":5,"pict-section-modal":23,"pict-section-theme":29}],71:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/**
 * Highest demo-entry schema version this provider understands.
 *
 * Each demo entry declares `DemoSchemaVersion` (defaults to 1 when
 * omitted).  Entries above this constant are rejected at register()
 * with a console warning — the host library was built against newer
 * docuserve features the running provider doesn't have wired yet.
 * Hosts in this position should either upgrade pict-docuserve or
 * publish a v1-compatible fallback demo alongside the v2 entry.
 *
 * Bump this constant when adding new fields / behaviours to the
 * registry contract (and document the new field in the entry-shape
 * comment block below).  Existing libraries continue to register
 * their v1 entries unchanged.
 *
 * @type {number}
 */
const MAX_DEMO_SCHEMA_VERSION = 1;

/**
 * Pict-Provider-Docuserve-Demos
 *
 * Runtime registry of interactive demos that docuserve renders alongside
 * documentation pages.  Each library that ships demos exports a small
 * registration function (typically `registerWithDocuserve(pict)`) which
 * calls `register()` here with one or more demo entries.
 *
 * # Demo entry shape (schema v1)
 *
 *   {
 *     DemoSchemaVersion: <number?>  - defaults to 1.  Bump when a library
 *                                     uses fields added in a later
 *                                     schema; older docuserve versions
 *                                     reject the entry with a warning.
 *     Hash:        <string>   - unique within (Group, Module) (e.g. 'login-form')
 *     Group:       <string>   - the catalog group key (e.g. 'pict')
 *     Module:      <string>   - the module name (e.g. 'pict-section-form')
 *     Name:        <string>   - human-readable label for the sidebar / title
 *     Description: <string>   - one-paragraph summary (rendered above the demo)
 *     Spec:        <object>   - JSON config the Mount function consumes
 *     Mount:       <function> - signature (pict, container, spec) => void
 *                               renders the live demo inside `container`
 *     Sources:     <array>    - optional [{ Name, Language, Content }] tabs
 *                               for the source viewer (uses pict-section-code)
 *     Playground:  <bool?>    - opt-in to the editable spec mode.  Reserved
 *                               for a future revision; ignored by the first
 *                               cut of the demo view.
 *   }
 *
 * # Lookups
 *
 *   provider.register(entry)          - add a single entry (returns the stored entry)
 *   provider.registerAll(entries)     - bulk register an array
 *   provider.get(group, module, hash) - resolve by route triple
 *   provider.listAll()                - every registered entry, in registration order
 *   provider.listByModule(g, m)       - entries scoped to one module (sidebar grouping)
 *   provider.hasDemos(g, m)           - quick truthy check
 *   provider.maxSchemaVersion         - highest schema version this provider supports
 *
 * # Why a registry instead of a catalog file
 *
 * Demos ship inside their host library's bundle so they version with the
 * code they exercise.  Each library calls `pict.providers['Docuserve-Demos']
 * .registerAll(...)` at boot; the registry is purely in-memory.  No
 * build-time generation step, no stale catalog drift.
 */
class PictProviderDocuserveDemos extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._byKey = {};         // Group/Module/Hash → entry
		this._byModule = {};      // Group/Module → entry[] (insertion order)
		this._all = [];           // every entry, in registration order
	}

	/**
	 * Highest demo entry schema version this provider can register.
	 * Exposed for libraries that want to feature-detect before calling
	 * register() (e.g. to skip a v2 entry on a v1-only docuserve).
	 *
	 * @type {number}
	 */
	get maxSchemaVersion()
	{
		return MAX_DEMO_SCHEMA_VERSION;
	}

	/**
	 * Register one demo entry.  Re-registering the same Group/Module/Hash
	 * overwrites cleanly (useful for hot-reload scenarios).
	 *
	 * @param {object} pEntry
	 * @returns {object|null} the stored entry, or null if the shape was invalid
	 */
	register(pEntry)
	{
		if (!pEntry || typeof pEntry !== 'object')
		{
			this.log.warn('Docuserve-Demos.register: entry must be an object');
			return null;
		}

		// Schema-version gate.  Older docuserve instances reject entries
		// that declare a schema version they can't honour; the library
		// that produced the entry was authored against newer docuserve
		// features.  Defaults to 1 when omitted (the v1 contract).
		let tmpSchemaVersion = (typeof pEntry.DemoSchemaVersion === 'number') ? pEntry.DemoSchemaVersion : 1;
		if (tmpSchemaVersion > MAX_DEMO_SCHEMA_VERSION)
		{
			this.log.warn('Docuserve-Demos.register: entry schema v' + tmpSchemaVersion
				+ ' exceeds this provider\'s max v' + MAX_DEMO_SCHEMA_VERSION
				+ ' — skipping ' + (pEntry.Group || '?') + '/' + (pEntry.Module || '?') + '/' + (pEntry.Hash || '?')
				+ '.  Upgrade pict-docuserve to register newer-schema demos.');
			return null;
		}

		if (typeof pEntry.Hash !== 'string' || pEntry.Hash.length < 1)
		{
			this.log.warn('Docuserve-Demos.register: entry.Hash is required');
			return null;
		}
		if (typeof pEntry.Group !== 'string' || pEntry.Group.length < 1)
		{
			this.log.warn('Docuserve-Demos.register: entry.Group is required (e.g. "pict")');
			return null;
		}
		if (typeof pEntry.Module !== 'string' || pEntry.Module.length < 1)
		{
			this.log.warn('Docuserve-Demos.register: entry.Module is required (e.g. "pict-section-form")');
			return null;
		}
		if (typeof pEntry.Mount !== 'function')
		{
			this.log.warn('Docuserve-Demos.register: entry.Mount must be a function (pict, container, spec)');
			return null;
		}

		let tmpKey = pEntry.Group + '/' + pEntry.Module + '/' + pEntry.Hash;
		let tmpModuleKey = pEntry.Group + '/' + pEntry.Module;

		// Replace existing if any (in-place to preserve order).
		let tmpExisting = this._byKey[tmpKey];
		if (tmpExisting)
		{
			let tmpAllIdx = this._all.indexOf(tmpExisting);
			if (tmpAllIdx >= 0) { this._all[tmpAllIdx] = pEntry; }
			let tmpModList = this._byModule[tmpModuleKey] || [];
			let tmpModIdx = tmpModList.indexOf(tmpExisting);
			if (tmpModIdx >= 0) { tmpModList[tmpModIdx] = pEntry; }
			this._byKey[tmpKey] = pEntry;
			return pEntry;
		}

		this._byKey[tmpKey] = pEntry;
		this._all.push(pEntry);
		if (!this._byModule[tmpModuleKey]) { this._byModule[tmpModuleKey] = []; }
		this._byModule[tmpModuleKey].push(pEntry);
		return pEntry;
	}

	/**
	 * Bulk-register an array of demos.  Skips entries that fail validation;
	 * the caller's own console will already have the per-entry warnings.
	 *
	 * @param {Array<object>} pEntries
	 * @returns {number} count of successfully registered entries
	 */
	registerAll(pEntries)
	{
		if (!Array.isArray(pEntries)) { return 0; }
		let tmpCount = 0;
		for (let i = 0; i < pEntries.length; i++)
		{
			if (this.register(pEntries[i])) { tmpCount++; }
		}
		return tmpCount;
	}

	get(pGroup, pModule, pHash)
	{
		return this._byKey[pGroup + '/' + pModule + '/' + pHash] || null;
	}

	listAll()
	{
		return this._all.slice();
	}

	listByModule(pGroup, pModule)
	{
		let tmpList = this._byModule[pGroup + '/' + pModule];
		return tmpList ? tmpList.slice() : [];
	}

	hasDemos(pGroup, pModule)
	{
		let tmpList = this._byModule[pGroup + '/' + pModule];
		return !!(tmpList && tmpList.length > 0);
	}
}

module.exports = PictProviderDocuserveDemos;
module.exports.default_configuration =
{
	ProviderIdentifier: 'Docuserve-Demos'
};
module.exports.MAX_DEMO_SCHEMA_VERSION = MAX_DEMO_SCHEMA_VERSION;

},{"pict-provider":7}],72:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libLunr = require('lunr');
const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Documentation Provider for Docuserve
 *
 * Loads the Indoctrinate-generated catalog and keyword index,
 * fetches markdown documents from local paths or raw GitHub URLs,
 * and parses them into HTML for rendering.
 */
class DocuserveDocumentationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._Catalog = null;
		this._ContentCache = {};

		// Create an instance of the content provider for markdown parsing
		this._ContentProvider = this.pict.addProvider('Pict-Content', libPictContentProvider.default_configuration, libPictContentProvider);
	}

	/**
	 * Create a link resolver closure for the content provider.
	 *
	 * Wraps docuserve-specific link resolution (catalog-aware routing,
	 * GitHub URL matching) into a callback compatible with the
	 * pict-section-content link resolver pattern.
	 *
	 * @param {string} [pCurrentGroup] - The current group key
	 * @param {string} [pCurrentModule] - The current module name
	 * @param {string} [pCurrentDocPath] - The current document path
	 * @returns {Function} A link resolver callback
	 */
	_createLinkResolver(pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		return (pHref, pLinkText) =>
		{
			// Convert internal doc links to hash routes
			if (pHref.match(/^\//) || pHref.match(/^[^:]+\.md/))
			{
				let tmpRoute = this.convertDocLink(pHref, pCurrentGroup, pCurrentModule, pCurrentDocPath);
				return { href: tmpRoute };
			}
			// Check if this is a GitHub URL that matches a catalog module
			let tmpCatalogRoute = this.resolveGitHubURLToRoute(pHref);
			if (tmpCatalogRoute)
			{
				return { href: tmpCatalogRoute };
			}
			// Use default behavior for other links
			return null;
		};
	}

	/**
	 * Create an image resolver closure for the content provider.
	 *
	 * Resolves relative image URLs against the directory of the document
	 * being rendered, so that images referenced with relative paths in
	 * markdown (e.g. `![graph](diagram.svg)`) resolve correctly even
	 * when the page uses hash-based routing.
	 *
	 * @param {string} pDocURL - The URL the markdown document was fetched from
	 * @returns {Function} An image resolver callback: (pSrc, pAlt) => resolvedSrc
	 */
	_createImageResolver(pDocURL)
	{
		// Extract the directory portion of the document URL
		let tmpBaseDir = '';
		if (pDocURL)
		{
			let tmpLastSlash = pDocURL.lastIndexOf('/');
			if (tmpLastSlash >= 0)
			{
				tmpBaseDir = pDocURL.substring(0, tmpLastSlash + 1);
			}
		}

		return (pSrc, pAlt) =>
		{
			// Leave absolute URLs, data URIs, and root-relative paths unchanged
			if (pSrc.match(/^https?:\/\//) || pSrc.match(/^data:/) || pSrc.match(/^\//))
			{
				return pSrc;
			}
			// Prepend the document's directory to make relative paths work
			return tmpBaseDir + pSrc;
		};
	}

	/**
	 * Load all documentation data sources: catalog, _cover.md, _sidebar.md.
	 *
	 * Loads the catalog first (it provides the fallback data), then attempts
	 * to load _cover.md and _sidebar.md in parallel.  If those markdown files
	 * exist they drive the splash and sidebar views; otherwise the catalog
	 * data is used as a fallback.
	 *
	 * @param {Function} fCallback - Callback when all loading is complete
	 */
	loadCatalog(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};

		let tmpCatalogURL = this.pict.AppData.Docuserve.CatalogURL || 'retold-catalog.json';

		let tmpLoadOptionalFiles = () =>
		{
			// Load _cover.md, _sidebar.md, _topbar.md, errorpage.md and keyword index in parallel.
			// When all are done, if we still have no sidebar data, try to auto-discover
			// a README.md so the site works with plain markdown folders.
			let tmpPending = 6;
			let tmpFinish = () =>
			{
				tmpPending--;
				if (tmpPending <= 0)
				{
					// If no sidebar data was populated by catalog or _sidebar.md,
					// try to auto-discover a README.md to provide minimal navigation.
					if (!this.pict.AppData.Docuserve.SidebarGroups || this.pict.AppData.Docuserve.SidebarGroups.length < 1)
					{
						this.autoDiscoverSidebar(tmpCallback);
					}
					else
					{
						return tmpCallback();
					}
				}
			};

			this.loadCover(tmpFinish);
			this.loadSidebar(tmpFinish);
			this.loadTopbar(tmpFinish);
			this.loadErrorPage(tmpFinish);
			this.loadKeywordIndex(tmpFinish);
			this.loadVersion(tmpFinish);
		};

		fetch(tmpCatalogURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					this.log.info(`Docuserve: No catalog at [${tmpCatalogURL}]; running in standalone mode.`);
					return null;
				}
				return pResponse.json();
			})
			.then((pCatalog) =>
			{
				if (pCatalog)
				{
					this._Catalog = pCatalog;
					this.pict.AppData.Docuserve.Catalog = pCatalog;
					this.pict.AppData.Docuserve.CatalogLoaded = true;

					// Build sidebar navigation data from the catalog as default
					this.buildSidebarData(pCatalog);
				}

				tmpLoadOptionalFiles();
			})
			.catch((pError) =>
			{
				this.log.info(`Docuserve: Catalog load error (${pError}); continuing in standalone mode.`);
				tmpLoadOptionalFiles();
			});
	}

	/**
	 * Auto-discover sidebar content when no catalog or _sidebar.md is available.
	 *
	 * Attempts to fetch README.md from the docs root.  If found, creates a
	 * minimal sidebar with a single "Docs" group containing a README entry.
	 * This lets pict-docuserve work with nothing but a folder of markdown.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	autoDiscoverSidebar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'README.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (pMarkdown)
				{
					// Extract a title from the first heading in the README
					let tmpTitleMatch = pMarkdown.match(/^#+\s+(.+)/m);
					let tmpTitle = tmpTitleMatch ? tmpTitleMatch[1].trim() : 'Docs';

					// Build a minimal sidebar group so the sidebar has something to show
					this.pict.AppData.Docuserve.SidebarGroups =
					[
						{
							Name: tmpTitle,
							Key: 'docs',
							Route: '#/page/README',
							Modules: []
						}
					];

					// Also set this as a fallback cover title if we have no cover
					if (!this.pict.AppData.Docuserve.CoverLoaded)
					{
						this.pict.AppData.Docuserve.Cover =
						{
							Title: tmpTitle,
							Tagline: '',
							Description: '',
							Highlights: [],
							Actions: [{ Text: 'Read the Docs', Href: 'README.md' }]
						};
						this.pict.AppData.Docuserve.CoverLoaded = true;
					}
				}
				else
				{
					this.log.info('Docuserve: No README.md found; sidebar will be empty.');
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.info(`Docuserve: README.md discovery failed (${pError}).`);
				return tmpCallback();
			});
	}

	/**
	 * Fetch and parse _cover.md into structured data for the splash view.
	 *
	 * The expected _cover.md format follows the docsify convention:
	 *   # Title
	 *   > Tagline
	 *   Description paragraph text.
	 *   - **Group** — description
	 *   [Link Text](url)
	 *
	 * Parsed result stored in this.pict.AppData.Docuserve.Cover:
	 *   { Title, Tagline, Description, Highlights: [{Label, Text}], Actions: [{Text, Href}] }
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadCover(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_cover.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _cover.md found; splash will use catalog data.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.Cover = this.parseCover(pMarkdown);
				this.pict.AppData.Docuserve.CoverLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _cover.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _cover.md markdown text into a structured object.
	 *
	 * @param {string} pMarkdown - Raw _cover.md content
	 * @returns {Object} Parsed cover data
	 */
	parseCover(pMarkdown)
	{
		let tmpCover = {
			Title: '',
			Tagline: '',
			Description: '',
			Highlights: [],
			Actions: []
		};

		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i].trim();

			if (!tmpLine)
			{
				continue;
			}

			// Heading — the title
			let tmpHeadingMatch = tmpLine.match(/^#+\s+(.+)/);
			if (tmpHeadingMatch)
			{
				tmpCover.Title = tmpHeadingMatch[1].trim();
				continue;
			}

			// Blockquote — the tagline
			let tmpBlockquoteMatch = tmpLine.match(/^>\s*(.*)/);
			if (tmpBlockquoteMatch)
			{
				tmpCover.Tagline = tmpBlockquoteMatch[1].trim();
				continue;
			}

			// Bullet list — highlights (e.g. "- **Fable** — Core ecosystem, DI, config")
			let tmpBulletMatch = tmpLine.match(/^[-*+]\s+(.*)/);
			if (tmpBulletMatch)
			{
				let tmpBulletContent = tmpBulletMatch[1];
				// Try to split on bold label: **Label** — rest
				let tmpLabelMatch = tmpBulletContent.match(/^\*\*([^*]+)\*\*\s*[-—:]\s*(.*)/);
				if (tmpLabelMatch)
				{
					tmpCover.Highlights.push({ Label: tmpLabelMatch[1].trim(), Text: tmpLabelMatch[2].trim() });
				}
				else
				{
					tmpCover.Highlights.push({ Label: '', Text: tmpBulletContent.trim() });
				}
				continue;
			}

			// Bare link — action button (e.g. "[Get Started](getting-started.md)")
			let tmpLinkMatch = tmpLine.match(/^\[([^\]]+)\]\(([^)]+)\)\s*$/);
			if (tmpLinkMatch)
			{
				tmpCover.Actions.push({ Text: tmpLinkMatch[1].trim(), Href: tmpLinkMatch[2].trim() });
				continue;
			}

			// Otherwise it's description text
			if (!tmpCover.Description)
			{
				tmpCover.Description = tmpLine;
			}
			else
			{
				tmpCover.Description += ' ' + tmpLine;
			}
		}

		return tmpCover;
	}

	/**
	 * Fetch and parse _sidebar.md into structured navigation data.
	 *
	 * The expected _sidebar.md format follows the docsify convention:
	 *   - [Home](/)
	 *   - Group Title
	 *     - [module-name](/group/module/)
	 *   - [Group Title](group.md)
	 *     - [module-name](/group/module/)
	 *
	 * If _sidebar.md is successfully loaded and parsed, its data replaces
	 * the catalog-inferred SidebarGroups in AppData.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadSidebar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_sidebar.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _sidebar.md found; sidebar will use catalog data.');
					return tmpCallback();
				}

				let tmpSidebarData = this.parseSidebarMarkdown(pMarkdown);
				if (tmpSidebarData && tmpSidebarData.length > 0)
				{
					this.pict.AppData.Docuserve.SidebarGroups = tmpSidebarData;
					this.pict.AppData.Docuserve.SidebarLoaded = true;
				}
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _sidebar.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Fetch and parse _topbar.md into structured data for the top bar view.
	 *
	 * The expected _topbar.md format:
	 *   # Brand Name
	 *   - [Link Text](url)
	 *   - [Link Text](url)
	 *
	 * The heading becomes the brand/title shown on the left.  List items become
	 * navigation links.  External links (starting with http) render on the
	 * right side; internal links render in the centre nav area.
	 *
	 * Parsed result stored in this.pict.AppData.Docuserve.TopBar:
	 *   { Brand, NavLinks: [{Text, Href, External}], ExternalLinks: [{Text, Href}] }
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadTopbar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_topbar.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _topbar.md found; top bar will use defaults.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.TopBar = this.parseTopbar(pMarkdown);
				this.pict.AppData.Docuserve.TopBarLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _topbar.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _topbar.md markdown text into a structured object.
	 *
	 * @param {string} pMarkdown - Raw _topbar.md content
	 * @returns {Object} Parsed top bar data { Brand, NavLinks, ExternalLinks }
	 */
	parseTopbar(pMarkdown)
	{
		let tmpTopBar = {
			Brand: '',
			NavLinks: [],
			ExternalLinks: []
		};

		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i].trim();

			if (!tmpLine)
			{
				continue;
			}

			// Heading — the brand name
			let tmpHeadingMatch = tmpLine.match(/^#+\s+(.+)/);
			if (tmpHeadingMatch)
			{
				tmpTopBar.Brand = tmpHeadingMatch[1].trim();
				continue;
			}

			// Bullet list item with link
			let tmpBulletMatch = tmpLine.match(/^[-*+]\s+(.*)/);
			if (tmpBulletMatch)
			{
				let tmpContent = tmpBulletMatch[1].trim();
				let tmpLinkMatch = tmpContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

				if (tmpLinkMatch)
				{
					let tmpText = tmpLinkMatch[1].trim();
					let tmpHref = tmpLinkMatch[2].trim();

					// External links (http/https) go to the right side
					if (tmpHref.match(/^https?:\/\//))
					{
						tmpTopBar.ExternalLinks.push({ Text: tmpText, Href: tmpHref });
					}
					else
					{
						// Internal link — convert to hash route
						let tmpRoute = this.convertSidebarLink(tmpHref);
						tmpTopBar.NavLinks.push({ Text: tmpText, Href: tmpRoute });
					}
				}
				continue;
			}
		}

		return tmpTopBar;
	}

	/**
	 * Fetch and parse _version.json — an optional sidecar generated by
	 * `quack prepare-docs` that describes the module version, generation
	 * timestamp and git commit for display in the topbar and sidebar.
	 *
	 * Parsed result stored in this.pict.AppData.Docuserve.Version:
	 *   { Name, Version, Description, GeneratedAt, GitCommit }
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadVersion(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_version.json')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pVersion) =>
			{
				if (!pVersion)
				{
					this.log.info('Docuserve: No _version.json found; version placard disabled.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.Version = pVersion;
				this.pict.AppData.Docuserve.VersionLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _version.json: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Fetch and parse errorpage.md into HTML for use as a custom error page.
	 *
	 * The errorpage.md is a standard markdown file.  If it contains the
	 * placeholder `{{path}}` anywhere in its source, that token will be
	 * replaced with the actual requested path at display time (via
	 * getErrorPageHTML).
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadErrorPage(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'errorpage.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No errorpage.md found; errors will use default page.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.ErrorPageHTML = this._ContentProvider.parseMarkdown(pMarkdown);
				this.pict.AppData.Docuserve.ErrorPageLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading errorpage.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Load the keyword search index (retold-keyword-index.json).
	 *
	 * If the index file exists, hydrates a lunr.Index for client-side search
	 * and stores the document metadata map.  If the file is not found, search
	 * features will simply not appear in the UI.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadKeywordIndex(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'retold-keyword-index.json')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pIndexData) =>
			{
				if (!pIndexData || !pIndexData.LunrIndex || !pIndexData.Documents)
				{
					this.log.info('Docuserve: No keyword index found; search will be unavailable.');
					return tmpCallback();
				}

				try
				{
					this._LunrIndex = libLunr.Index.load(pIndexData.LunrIndex);
					this._KeywordDocuments = pIndexData.Documents;
					this.pict.AppData.Docuserve.KeywordIndexLoaded = true;
					this.pict.AppData.Docuserve.KeywordDocumentCount = pIndexData.DocumentCount || 0;
					this.log.info(`Docuserve: Keyword index loaded (${pIndexData.DocumentCount || 0} documents).`);
				}
				catch (pError)
				{
					this.log.warn(`Docuserve: Error hydrating lunr index: ${pError}`);
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading keyword index: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Check whether a group/module pair exists in the loaded catalog.
	 *
	 * Used by search() to decide whether a result should route to
	 * #/doc/ (catalog module → GitHub raw URL) or #/page/ (local doc).
	 *
	 * @param {string} pGroup - The group key (e.g. "fable")
	 * @param {string} pModule - The module name (e.g. "fable")
	 * @returns {boolean} True if the module is found in the catalog
	 */
	isModuleInCatalog(pGroup, pModule)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return false;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name === pModule)
				{
					return true;
				}
			}
		}

		return false;
	}

	/**
	 * Find the catalog group key that contains a given module name.
	 *
	 * Searches all groups in the catalog for a module with the given name.
	 * This is used to resolve sidebar links where the path uses a conceptual
	 * group name (e.g. "fable") that doesn't match the catalog group key
	 * (e.g. "modules").
	 *
	 * @param {string} pModuleName - The module name to find (e.g. "fable")
	 * @returns {string|null} The catalog group key (e.g. "modules") or null
	 */
	findModuleGroupKey(pModuleName)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return null;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				if (tmpGroup.Modules[j].Name === pModuleName)
				{
					return tmpGroup.Key;
				}
			}
		}

		return null;
	}

	/**
	 * Check whether a group key exists in the loaded catalog.
	 *
	 * Used to dynamically validate group keys instead of hardcoding them.
	 *
	 * @param {string} pGroupKey - The group key (e.g. "fable", "example_applications")
	 * @returns {boolean} True if the group is found in the catalog
	 */
	isGroupInCatalog(pGroupKey)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return false;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			if (this._Catalog.Groups[i].Key === pGroupKey)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Search the keyword index for documents matching a query.
	 *
	 * Returns an array of result objects sorted by relevance:
	 *   [{ Key, Title, Group, Module, DocPath, Score, Route }]
	 *
	 * @param {string} pQuery - The search query
	 * @returns {Array} Search results (empty if no index or no matches)
	 */
	search(pQuery)
	{
		if (!this._LunrIndex || !this._KeywordDocuments || !pQuery || !pQuery.trim())
		{
			return [];
		}

		let tmpResults = [];

		try
		{
			let tmpLunrResults = this._LunrIndex.search(pQuery);

			for (let i = 0; i < tmpLunrResults.length; i++)
			{
				let tmpRef = tmpLunrResults[i].ref;
				let tmpScore = tmpLunrResults[i].score;
				let tmpDoc = this._KeywordDocuments[tmpRef];

				if (!tmpDoc)
				{
					continue;
				}

				// Build the hash route from the document key (group/module/docpath)
				let tmpParts = tmpRef.split('/');
				let tmpRoute = '';
				if (tmpParts.length >= 2)
				{
					// Check whether this group/module exists in the catalog.
					// If it does, route to #/doc/ which fetches from GitHub.
					// If not, fall back to #/page/ which fetches locally.
					let tmpGroup = tmpParts[0];
					let tmpModule = tmpParts[1];

					if (this.isModuleInCatalog(tmpGroup, tmpModule))
					{
						tmpRoute = '#/doc/' + tmpRef;
					}
					else
					{
						// Local document — route via #/page/ using the full ref path
						tmpRoute = '#/page/' + tmpRef;
					}
				}

				tmpResults.push({
					Key: tmpRef,
					Title: tmpDoc.Title || tmpRef,
					Group: tmpDoc.Group || '',
					Module: tmpDoc.Module || '',
					DocPath: tmpDoc.DocPath || '',
					Score: tmpScore,
					Route: tmpRoute
				});
			}
		}
		catch (pError)
		{
			this.log.warn(`Docuserve: Search error: ${pError}`);
		}

		return tmpResults;
	}

	/**
	 * Get the error page HTML for a given requested path.
	 *
	 * If a custom errorpage.md was loaded, its parsed HTML is returned with
	 * the `{{path}}` placeholder replaced by the actual requested path.
	 * Otherwise a default not-found HTML block is returned.
	 *
	 * @param {string} pRequestedPath - The path that was not found
	 * @returns {string} HTML to display
	 */
	getErrorPageHTML(pRequestedPath)
	{
		let tmpPath = pRequestedPath || 'unknown';

		if (this.pict.AppData.Docuserve.ErrorPageLoaded && this.pict.AppData.Docuserve.ErrorPageHTML)
		{
			// Replace the {{path}} placeholder with the actual requested path
			return this.pict.AppData.Docuserve.ErrorPageHTML.replace(/\{\{path\}\}/g, this._ContentProvider.escapeHTML(tmpPath));
		}

		// Default fallback
		return '<div class="docuserve-not-found">'
			+ '<h2>Page Not Found</h2>'
			+ '<p>The document <code>' + this._ContentProvider.escapeHTML(tmpPath) + '</code> could not be loaded.</p>'
			+ '<p><a href="#/Home">Return to the home page</a></p>'
			+ '</div>';
	}

	/**
	 * Parse _sidebar.md into the SidebarGroups format the sidebar view consumes.
	 *
	 * Returns an array of group objects:
	 *   [{ Name, Key, Route, Modules: [{ Name, HasDocs, Group, Route }] }]
	 *
	 * Top-level items (no indent) become groups.  Indented child items become
	 * modules within the preceding group.  The special "Home" entry is stored
	 * as a group with no modules.
	 *
	 * @param {string} pMarkdown - Raw _sidebar.md content
	 * @returns {Array} Parsed sidebar groups
	 */
	parseSidebarMarkdown(pMarkdown)
	{
		let tmpGroups = [];
		let tmpCurrentGroup = null;
		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			if (!tmpLine.trim())
			{
				continue;
			}

			// Detect indent level: child items have 2+ leading spaces
			let tmpIndentMatch = tmpLine.match(/^(\s*)/);
			let tmpIndent = tmpIndentMatch ? tmpIndentMatch[1].length : 0;
			let tmpContent = tmpLine.trim();

			// Must start with a list marker
			let tmpListMatch = tmpContent.match(/^[-*+]\s+(.*)/);
			if (!tmpListMatch)
			{
				continue;
			}

			let tmpItemContent = tmpListMatch[1].trim();

			// Parse link if present: [Text](href)
			let tmpLinkMatch = tmpItemContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

			if (tmpIndent < 2)
			{
				// Top-level item — this is a group header or standalone link
				if (tmpLinkMatch)
				{
					let tmpName = tmpLinkMatch[1].trim();
					let tmpHref = tmpLinkMatch[2].trim();

					// Derive a group key from the href or name
					let tmpKey = this.deriveGroupKey(tmpName, tmpHref);
					let tmpRoute = this.convertSidebarLink(tmpHref);

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpKey,
						Route: tmpRoute,
						Modules: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else
				{
					// Plain text group header (no link)
					let tmpName = tmpItemContent;
					let tmpKey = tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpKey,
						Route: '',
						Modules: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
			}
			else if (tmpCurrentGroup)
			{
				// Indented item — this is a module within the current group
				if (tmpLinkMatch)
				{
					let tmpModuleName = tmpLinkMatch[1].trim();
					let tmpModuleHref = tmpLinkMatch[2].trim();
					let tmpModuleRoute = this.convertSidebarLink(tmpModuleHref);

					tmpCurrentGroup.Modules.push({
						Name: tmpModuleName,
						HasDocs: true,
						Group: tmpCurrentGroup.Key,
						Route: tmpModuleRoute
					});
				}
				else
				{
					// Plain text child entry (no docs link)
					tmpCurrentGroup.Modules.push({
						Name: tmpItemContent,
						HasDocs: false,
						Group: tmpCurrentGroup.Key,
						Route: ''
					});
				}
			}
		}

		return tmpGroups;
	}

	/**
	 * Convert a docsify-style sidebar link href into a docuserve hash route.
	 *
	 * Handles these forms:
	 *   /                        -> #/Home
	 *   /group/module/           -> #/doc/group/module
	 *   /group/module/path.md    -> #/doc/group/module/path.md
	 *   something.md             -> #/page/something
	 *
	 * @param {string} pHref - The original sidebar link href
	 * @returns {string} The converted hash route
	 */
	convertSidebarLink(pHref)
	{
		if (!pHref)
		{
			return '';
		}

		// Root home link
		if (pHref === '/')
		{
			return '#/Home';
		}

		// Bare hash link (e.g. "#fable") — docsify convention for the home/readme page.
		// Navigate to the first available content route in the sidebar, skipping
		// #/Home since the cover page is already displaying that.
		if (pHref.match(/^#[^/]/))
		{
			let tmpSidebarGroups = this.pict.AppData.Docuserve.SidebarGroups;
			if (tmpSidebarGroups)
			{
				for (let g = 0; g < tmpSidebarGroups.length; g++)
				{
					let tmpModules = tmpSidebarGroups[g].Modules;
					if (tmpModules)
					{
						for (let m = 0; m < tmpModules.length; m++)
						{
							if (tmpModules[m].HasDocs && tmpModules[m].Route && tmpModules[m].Route !== '#/Home')
							{
								return tmpModules[m].Route;
							}
						}
					}
					if (tmpSidebarGroups[g].Route && tmpSidebarGroups[g].Route !== '#/Home')
					{
						return tmpSidebarGroups[g].Route;
					}
				}
			}
			return '#/Home';
		}

		// Strip leading/trailing slashes for parsing
		let tmpPath = pHref.replace(/^\//, '').replace(/\/$/, '');

		if (!tmpPath)
		{
			return '#/Home';
		}

		let tmpParts = tmpPath.split('/');

		// Check if it's a module path (group/module) — both the group
		// AND the module must exist in the catalog, otherwise treat it
		// as a local page reference (e.g. docs subfolder).
		if (tmpParts.length >= 2)
		{
			if (this.isGroupInCatalog(tmpParts[0]) && this.isModuleInCatalog(tmpParts[0], tmpParts[1]))
			{
				return '#/doc/' + tmpPath;
			}

			// Fallback: the path may use a conceptual group name (e.g. "fable/fable")
			// where the first part isn't a catalog group key. Try to find the module
			// (second part) in any catalog group and rewrite the route.
			let tmpActualGroup = this.findModuleGroupKey(tmpParts[1]);
			if (tmpActualGroup)
			{
				let tmpRemainder = tmpParts.slice(2).join('/');
				if (tmpRemainder)
				{
					return '#/doc/' + tmpActualGroup + '/' + tmpParts[1] + '/' + tmpRemainder;
				}
				return '#/doc/' + tmpActualGroup + '/' + tmpParts[1];
			}
		}

		// Local page reference
		if (tmpPath.match(/\.md$/))
		{
			return '#/page/' + tmpPath.replace(/\.md$/, '');
		}

		return '#/page/' + tmpPath;
	}

	/**
	 * Derive a short group key from a sidebar group name or href.
	 *
	 * @param {string} pName - The display name (e.g. "Fable — Core Ecosystem")
	 * @param {string} pHref - The link href (e.g. "fable.md")
	 * @returns {string} A short key (e.g. "fable")
	 */
	deriveGroupKey(pName, pHref)
	{
		// Try href first — "fable.md" -> "fable"
		if (pHref && pHref !== '/')
		{
			let tmpFromHref = pHref.replace(/^\//, '').replace(/\.md$/, '').replace(/\/$/, '');
			if (tmpFromHref && !tmpFromHref.includes('/'))
			{
				return tmpFromHref.toLowerCase();
			}
		}

		// Fall back to first word of name lowercased
		let tmpFirstWord = pName.split(/[\s—\-:]+/)[0];
		return tmpFirstWord.toLowerCase().replace(/[^a-z0-9]/g, '');
	}

	/**
	 * Build structured sidebar data from the catalog for the sidebar view.
	 *
	 * @param {Object} pCatalog - The parsed retold-catalog.json
	 */
	buildSidebarData(pCatalog)
	{
		let tmpSidebarGroups = [];

		for (let i = 0; i < pCatalog.Groups.length; i++)
		{
			let tmpGroup = pCatalog.Groups[i];
			let tmpGroupEntry = {
				Name: tmpGroup.Name,
				Key: tmpGroup.Key,
				Description: tmpGroup.Description,
				Modules: []
			};

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				tmpGroupEntry.Modules.push({
					Name: tmpModule.Name,
					HasDocs: tmpModule.HasDocs,
					Group: tmpGroup.Key,
					Route: '#/doc/' + tmpGroup.Key + '/' + tmpModule.Name
				});
			}

			tmpSidebarGroups.push(tmpGroupEntry);
		}

		this.pict.AppData.Docuserve.SidebarGroups = tmpSidebarGroups;
	}

	/**
	 * Resolve a document URL from group/module/path to a fetchable URL.
	 *
	 * @param {string} pGroup - The group key (e.g. 'fable')
	 * @param {string} pModule - The module name (e.g. 'fable')
	 * @param {string} pPath - The document path within the module docs (e.g. 'README.md')
	 * @returns {string} The resolved URL
	 */
	resolveDocumentURL(pGroup, pModule, pPath)
	{
		if (!this._Catalog)
		{
			return null;
		}

		let tmpOrg = this._Catalog.GitHubOrg || 'stevenvelozo';
		let tmpDefaultBranch = this._Catalog.DefaultBranch || 'master';

		// Find the module in the catalog
		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				let tmpBranch = tmpModule.Branch || tmpDefaultBranch;
				let tmpDocPath = pPath || 'README.md';
				return 'https://raw.githubusercontent.com/' + tmpOrg + '/' + tmpModule.Repo + '/' + tmpBranch + '/docs/' + tmpDocPath;
			}
		}

		return null;
	}

	/**
	 * Resolve a GitHub repository URL to an internal hash route.
	 *
	 * If the URL matches a module in the loaded catalog, returns the
	 * corresponding #/doc/ route so the link navigates within docuserve
	 * instead of leaving to GitHub.
	 *
	 * @param {string} pURL - A GitHub URL (e.g. "https://github.com/stevenvelozo/fable")
	 * @returns {string|null} The hash route (e.g. "#/doc/fable/fable") or null if not a catalog module
	 */
	resolveGitHubURLToRoute(pURL)
	{
		if (!this._Catalog || !this._Catalog.Groups || !pURL)
		{
			return null;
		}

		// Match https://github.com/{org}/{repo} with optional trailing path/slash
		let tmpMatch = pURL.match(/^https?:\/\/github\.com\/([^/]+)\/([^/]+)/);
		if (!tmpMatch)
		{
			return null;
		}

		let tmpOrg = tmpMatch[1];
		let tmpRepo = tmpMatch[2];

		// Only resolve URLs that match the catalog's GitHub org
		if (tmpOrg !== this._Catalog.GitHubOrg)
		{
			return null;
		}

		// Search catalog for a module with a matching Repo
		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Repo === tmpRepo)
				{
					return '#/doc/' + tmpGroup.Key + '/' + tmpModule.Name;
				}
			}
		}

		return null;
	}

	/**
	 * Resolve the GitHub Pages documentation URL for a module.
	 *
	 * Returns a URL like https://stevenvelozo.github.io/pict-view/ if the
	 * module exists in the catalog.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 * @returns {string|null} The GitHub Pages URL or null
	 */
	resolveGitHubPagesURL(pGroup, pModule)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return null;
		}

		let tmpOrg = this._Catalog.GitHubOrg || 'stevenvelozo';

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				if (!tmpModule.HasDocs)
				{
					return null;
				}

				return 'https://' + tmpOrg + '.github.io/' + tmpModule.Repo + '/';
			}
		}

		return null;
	}

	/**
	 * Get the module-specific sidebar entries for a given group/module.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 * @returns {Array|null} The sidebar entries or null
	 */
	getModuleSidebar(pGroup, pModule)
	{
		if (!this._Catalog)
		{
			return null;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				return tmpModule.Sidebar || null;
			}
		}

		return null;
	}

	/**
	 * Fetch a markdown document and convert it to HTML.
	 *
	 * @param {string} pURL - The URL to fetch
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 * @param {string} [pCurrentGroup] - The current group key for link resolution
	 * @param {string} [pCurrentModule] - The current module name for link resolution
	 * @param {string} [pCurrentDocPath] - The current document path for link resolution
	 */
	fetchDocument(pURL, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};

		if (!pURL)
		{
			return tmpCallback('No URL provided', '');
		}

		// Check cache
		if (this._ContentCache[pURL])
		{
			return tmpCallback(null, this._ContentCache[pURL]);
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					return tmpCallback('Document not found', this.getErrorPageHTML(pURL));
				}

				let tmpHTML = this._ContentProvider.parseMarkdown(pMarkdown, this._createLinkResolver(pCurrentGroup, pCurrentModule, pCurrentDocPath), this._createImageResolver(pURL));
				this._ContentCache[pURL] = tmpHTML;
				return tmpCallback(null, tmpHTML);
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error fetching document [${pURL}]: ${pError}`);
				return tmpCallback(pError, this.getErrorPageHTML(pURL));
			});
	}

	/**
	 * Fetch a local document relative to the docs folder.
	 *
	 * @param {string} pPath - The relative path (e.g. 'architecture.md')
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 * @param {string} [pCurrentGroup] - The current group key for link resolution
	 * @param {string} [pCurrentModule] - The current module name for link resolution
	 * @param {string} [pCurrentDocPath] - The current document path for link resolution
	 */
	fetchLocalDocument(pPath, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';
		let tmpURL = tmpDocsBase + pPath;
		this.fetchDocument(tmpURL, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath);
	}

	/**
	 * Convert a docsify-style internal link to a hash route for docuserve.
	 *
	 * When module context is provided, relative links (e.g. "api.md" or
	 * "./settings-manager.md") are resolved within the current module and
	 * document directory rather than falling back to the docs root.
	 *
	 * @param {string} pHref - The original link href
	 * @param {string} [pCurrentGroup] - The current group key (e.g. "fable")
	 * @param {string} [pCurrentModule] - The current module name (e.g. "fable")
	 * @param {string} [pCurrentDocPath] - The current document path within the module (e.g. "services/README.md")
	 * @returns {string} The converted hash route
	 */
	convertDocLink(pHref, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		// Strip leading ./ prefix for relative paths
		let tmpPath = pHref.replace(/^\.\//, '');
		// Remove leading slash
		tmpPath = tmpPath.replace(/^\//, '');

		// If it looks like an absolute module path (group/module/...), route directly.
		// Both the group AND the module must exist in the catalog, otherwise treat
		// as a local page reference (e.g. docs subfolder like modules/modules.md).
		let tmpParts = tmpPath.split('/');
		if (tmpParts.length >= 2)
		{
			if (this.isGroupInCatalog(tmpParts[0]) && this.isModuleInCatalog(tmpParts[0], tmpParts[1]))
			{
				return '#/doc/' + tmpPath;
			}
		}

		// If we have module context, resolve relative to current document's directory
		if (pCurrentGroup && pCurrentModule)
		{
			// Determine the directory of the current document
			let tmpDocDir = '';
			if (pCurrentDocPath)
			{
				let tmpDirParts = pCurrentDocPath.split('/');
				if (tmpDirParts.length > 1)
				{
					tmpDirParts.pop(); // Remove filename
					tmpDocDir = tmpDirParts.join('/') + '/';
				}
			}
			return '#/doc/' + pCurrentGroup + '/' + pCurrentModule + '/' + tmpDocDir + tmpPath;
		}

		// Local doc page (no module context)
		if (tmpPath.match(/\.md$/))
		{
			let tmpPageKey = tmpPath.replace(/\.md$/, '');
			return '#/page/' + tmpPageKey;
		}

		return '#/page/' + tmpPath;
	}

}

module.exports = DocuserveDocumentationProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Docuserve-Documentation",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"lunr":3,"pict-provider":7,"pict-section-content":11}],73:[function(require,module,exports){
const libPictContentView = require('pict-section-content');

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Content",

	DefaultRenderable: "Docuserve-Content-Display",
	DefaultDestinationAddress: "#Docuserve-Content-Container",

	AutoRender: false,

	// The parent pict-section-content CSS must be included here because
	// pict-view's Object.assign replaces the CSS property entirely when
	// the child provides its own.  We cannot read the parent's
	// default_configuration.CSS at module scope because browserify's
	// module initialisation order does not guarantee it is populated yet.
	CSS: /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
			color: var(--docuserve-text);
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--docuserve-text-dim);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--docuserve-text-strong);
			border-bottom: 1px solid var(--docuserve-border);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--docuserve-text-strong);
			border-bottom: 1px solid var(--docuserve-border-soft);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--docuserve-text-strong);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--docuserve-text-muted);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--docuserve-text);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--docuserve-accent);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		/* Plain <pre> (no wrap) - rare; keep for safety */
		.pict-content pre {
			background: var(--docuserve-code-bg);
			color: var(--docuserve-code-text);
			padding: 1.25em;
			border-radius: 6px;
			border: 1px solid var(--docuserve-code-border);
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
		}
		/* Inline code */
		.pict-content code {
			background: var(--docuserve-inline-code-bg);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: var(--docuserve-inline-code-text);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
		}
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		/* Fenced code block wrapper emitted by pict-section-content */
		.pict-content-code-wrap {
			position: relative;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
			font-size: 14px;
			line-height: 1.5;
			border-radius: 6px;
			border: 1px solid var(--docuserve-code-border);
			overflow: auto;
			margin: 1em 0;
			background: var(--docuserve-code-bg);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			position: absolute;
			top: 0;
			left: 0;
			width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background: var(--docuserve-code-gutter-bg);
			border-right: 1px solid var(--docuserve-code-gutter-border);
			color: var(--docuserve-code-gutter-text);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--docuserve-code-bg);
			color: var(--docuserve-code-text);
			padding: 1.25em 1.25em 1.25em 52px;
			border: none;
			border-radius: 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		/* Syntax tokens — these rules must match the span classes emitted by
		   pict-section-code's highlighter.  Also apply without .pict-content-code-wrap
		   as a belt-and-suspenders for any <pre><code> not emitted from a fence. */
		.pict-content-code-wrap .keyword,
		.pict-content pre code .keyword { color: var(--docuserve-tok-keyword); }
		.pict-content-code-wrap .string,
		.pict-content pre code .string { color: var(--docuserve-tok-string); }
		.pict-content-code-wrap .number,
		.pict-content pre code .number { color: var(--docuserve-tok-number); }
		.pict-content-code-wrap .comment,
		.pict-content pre code .comment { color: var(--docuserve-tok-comment); font-style: italic; }
		.pict-content-code-wrap .operator,
		.pict-content pre code .operator { color: var(--docuserve-tok-operator); }
		.pict-content-code-wrap .punctuation,
		.pict-content pre code .punctuation { color: var(--docuserve-tok-punctuation); }
		.pict-content-code-wrap .function-name,
		.pict-content pre code .function-name { color: var(--docuserve-tok-function); }
		.pict-content-code-wrap .property,
		.pict-content pre code .property { color: var(--docuserve-tok-property); }
		.pict-content-code-wrap .tag,
		.pict-content pre code .tag { color: var(--docuserve-tok-tag); }
		.pict-content-code-wrap .attr-name,
		.pict-content pre code .attr-name { color: var(--docuserve-tok-attr-name); }
		.pict-content-code-wrap .attr-value,
		.pict-content pre code .attr-value { color: var(--docuserve-tok-attr-value); }
		.pict-content blockquote {
			border-left: 4px solid var(--docuserve-blockquote-border);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--docuserve-blockquote-bg);
			color: var(--docuserve-blockquote-text);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--docuserve-text);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--docuserve-border);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--docuserve-table-header-bg);
			border: 1px solid var(--docuserve-border);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--docuserve-text-strong);
		}
		.pict-content table td {
			border: 1px solid var(--docuserve-border);
			padding: 0.5em 0.8em;
			color: var(--docuserve-text);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--docuserve-table-row-alt-bg);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--docuserve-mermaid-bg);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
			border: 1px solid var(--docuserve-border-soft);
		}
		/* Force dark text inside mermaid SVGs so diagrams stay readable
		   in dark mode (mermaid bg is always light). */
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}
		.docuserve-module-external-link {
			padding: 0.5em 0;
			margin-bottom: 0.5em;
			border-bottom: 1px solid var(--docuserve-border-soft);
			font-size: 0.85em;
			text-align: right;
		}
		.docuserve-module-external-link a {
			color: var(--docuserve-accent);
			text-decoration: none;
		}
		.docuserve-module-external-link a:hover {
			text-decoration: underline;
		}
		.docuserve-not-found {
			text-align: center;
			padding: 3em 1em;
			color: var(--docuserve-text-muted);
		}
		.docuserve-not-found h2 {
			color: var(--docuserve-text-dim);
			font-size: 1.5em;
			border-bottom: none;
		}
		.docuserve-not-found code {
			background: var(--docuserve-inline-code-bg);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: var(--docuserve-inline-code-text);
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--docuserve-accent);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--docuserve-bg-elevated);
			color: var(--docuserve-text-muted);
			border: 1px solid var(--docuserve-border);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--docuserve-accent);
			color: var(--theme-color-background-panel, #FFFFFF);
			border-color: var(--docuserve-accent);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--docuserve-accent);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--docuserve-accent);
			color: var(--theme-color-background-panel, #FFFFFF);
			border-color: var(--docuserve-accent);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: #B23A3A;
			color: var(--theme-color-background-panel, #FFFFFF);
			border-color: #B23A3A;
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--docuserve-text);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--docuserve-bg-elevated);
			color: var(--docuserve-text-strong);
			border-bottom: 1px solid var(--docuserve-border);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--docuserve-text-strong);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--docuserve-text-muted);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--docuserve-border-soft);
			color: var(--docuserve-text-strong);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--docuserve-accent);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--docuserve-accent);
			color: var(--theme-color-background-panel, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--docuserve-bg-elevated);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--docuserve-mermaid-bg);
			color: var(--theme-color-text-primary, #2A241E);
			padding: 16px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg text,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg .nodeLabel,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg .edgeLabel,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg .label,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg span,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg foreignObject p,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg foreignObject div,
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Docuserve-Content-Body">
	<div class="pict-content-loading">Loading documentation...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Content-Display",
			TemplateHash: "Docuserve-Content-Template",
			DestinationAddress: "#Docuserve-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class DocuserveContentView extends libPictContentView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * When viewing a module's documentation, prepends a link to the
	 * module's own GitHub Pages documentation site.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 */
	displayContent(pHTMLContent)
	{
		let tmpHTML = pHTMLContent;
		let tmpGroup = this.pict.AppData.Docuserve.CurrentGroup;
		let tmpModule = this.pict.AppData.Docuserve.CurrentModule;

		if (tmpGroup && tmpModule)
		{
			let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
			if (tmpDocProvider)
			{
				let tmpPagesURL = tmpDocProvider.resolveGitHubPagesURL(tmpGroup, tmpModule);
				if (tmpPagesURL)
				{
					tmpHTML = '<div class="docuserve-module-external-link">'
						+ '<a href="' + tmpPagesURL + '" target="_blank" rel="noopener">'
						+ '&#x2197; View ' + tmpModule + ' documentation site'
						+ '</a>'
						+ '</div>'
						+ tmpHTML;
				}
			}
		}

		super.displayContent(tmpHTML, 'Docuserve-Content-Body');
	}

	/**
	 * Show a loading indicator.
	 */
	showLoading()
	{
		super.showLoading('Loading documentation...', 'Docuserve-Content-Body');
	}
}

module.exports = DocuserveContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-section-content":11}],74:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Docuserve-Demo — renders one interactive demo registered with the
 * Docuserve-Demos provider.
 *
 * Layout (themed via pict-provider-theme tokens):
 *
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │ <Demo Name>                                                  │
 *   │ <description paragraph>                                      │
 *   ├──────────────────────────────────┬───────────────────────────┤
 *   │ Live                             │ Sources                   │
 *   │  - the demo's Mount() function   │  - tabs per Sources entry │
 *   │    renders into this container   │  - rendered through       │
 *   │                                  │    pict-section-code      │
 *   │                                  │                           │
 *   └──────────────────────────────────┴───────────────────────────┘
 *
 * If a demo declares no Sources, the right pane is omitted and the live
 * area uses the full width.
 *
 * Re-mount strategy: every call to `showDemo(...)` rebuilds the inner
 * containers from scratch, then calls the demo's Mount(pict, container,
 * spec).  This keeps state isolated between demos and gives library
 * authors a clean container to render into.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Demo",

	DefaultRenderable: "Docuserve-Demo-Display",
	DefaultDestinationAddress: "#Docuserve-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-demo
		{
			padding: 1.5em 2em;
			max-width: 1200px;
			margin: 0 auto;
			color: var(--theme-color-text-primary, #2A241E);
		}
		.docuserve-demo-header
		{
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.75em;
			margin-bottom: 1.25em;
		}
		.docuserve-demo-title
		{
			font-size: 1.5em;
			font-weight: 600;
			margin: 0 0 0.3em;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.docuserve-demo-meta
		{
			font-size: 0.78em;
			color: var(--theme-color-text-muted, #8A7F72);
			letter-spacing: 0.04em;
			text-transform: uppercase;
			margin: 0 0 0.6em;
		}
		.docuserve-demo-meta a
		{
			color: inherit;
			text-decoration: none;
		}
		.docuserve-demo-meta a:hover
		{
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: underline;
		}
		.docuserve-demo-description
		{
			font-size: 0.95em;
			line-height: 1.55;
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.docuserve-demo-body
		{
			display: flex;
			gap: 1.5em;
			min-height: 320px;
			align-items: stretch;
		}
		.docuserve-demo-live
		{
			flex: 1 1 60%;
			min-width: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			padding: 1em;
			overflow: auto;
		}
		.docuserve-demo-live.full-width
		{
			flex: 1 1 100%;
		}
		.docuserve-demo-sources
		{
			flex: 1 1 40%;
			min-width: 0;
			background: var(--theme-color-background-secondary, #FAF8F4);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			overflow: hidden;
			display: flex;
			flex-direction: column;
		}
		.docuserve-demo-sources-tabs
		{
			display: flex;
			align-items: stretch;
			background: var(--theme-color-background-tertiary, #F0EDE8);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
		}
		.docuserve-demo-sources-tab
		{
			padding: 0.55em 0.9em;
			background: transparent;
			border: none;
			border-right: 1px solid var(--theme-color-border-light, #E8E2D7);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.8em;
			font-weight: 500;
			cursor: pointer;
			font-family: var(--theme-typography-family-mono, ui-monospace, monospace);
		}
		.docuserve-demo-sources-tab:hover
		{
			background: var(--theme-color-background-hover, #EDE9E3);
		}
		.docuserve-demo-sources-tab.active
		{
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: inset 0 -2px 0 0 var(--theme-color-brand-primary, #2E7D74);
		}
		.docuserve-demo-sources-body
		{
			flex: 1;
			min-height: 0;
			overflow: auto;
			background: var(--theme-color-background-panel, #FFFFFF);
		}
		.docuserve-demo-source-pane
		{
			display: none;
			padding: 0.5em;
		}
		.docuserve-demo-source-pane.active
		{
			display: block;
		}
		.docuserve-demo-source-pane pre
		{
			margin: 0;
			padding: 0.75em 1em;
			font-family: var(--theme-typography-family-mono, ui-monospace, monospace);
			font-size: 0.82em;
			line-height: 1.5;
			background: var(--theme-color-background-secondary, #F6F3EE);
			border: 1px solid var(--theme-color-border-light, #E5DED1);
			border-radius: 4px;
			overflow: auto;
			white-space: pre;
			color: var(--theme-color-text-primary, #2A241E);
		}
		.docuserve-demo-empty
		{
			padding: 2em;
			text-align: center;
			color: var(--theme-color-text-muted, #8A7F72);
			font-style: italic;
		}

		@media (max-width: 900px)
		{
			.docuserve-demo-body { flex-direction: column; }
			.docuserve-demo-live, .docuserve-demo-sources { flex: 1 1 auto; }
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Demo-Template",
			Template: /*html*/`
<div class="docuserve-demo">
	<div class="docuserve-demo-header">
		<div class="docuserve-demo-meta" id="Docuserve-Demo-Meta"></div>
		<h1 class="docuserve-demo-title" id="Docuserve-Demo-Title">Demo</h1>
		<div class="docuserve-demo-description" id="Docuserve-Demo-Description"></div>
	</div>
	<div class="docuserve-demo-body" id="Docuserve-Demo-Body">
		<div class="docuserve-demo-live" id="Docuserve-Demo-Live"></div>
		<div class="docuserve-demo-sources" id="Docuserve-Demo-Sources" style="display:none">
			<div class="docuserve-demo-sources-tabs" id="Docuserve-Demo-Sources-Tabs"></div>
			<div class="docuserve-demo-sources-body" id="Docuserve-Demo-Sources-Body"></div>
		</div>
	</div>
</div>`
		},
		{
			Hash: "Docuserve-Demo-Empty-Template",
			Template: /*html*/`<div class="docuserve-demo"><div class="docuserve-demo-empty">No demo registered at this route.</div></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Demo-Display",
			TemplateHash: "Docuserve-Demo-Template",
			DestinationAddress: "#Docuserve-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class DocuserveDemoView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Render the empty "no demo registered" message into the content
	 * container.  Used as a 404 for unknown demo routes.
	 */
	showEmpty()
	{
		let tmpHTML = this.pict.parseTemplateByHash('Docuserve-Demo-Empty-Template', {});
		this.pict.ContentAssignment.assignContent('#Docuserve-Content-Container', tmpHTML);
	}

	/**
	 * Render a demo by Hash + Group + Module triple, then call its
	 * Mount() function to instantiate the live view.  Sources (if any)
	 * are rendered into the right pane with tabbed switching.
	 */
	showDemo(pGroup, pModule, pHash)
	{
		let tmpDemos = this.pict.providers['Docuserve-Demos'];
		if (!tmpDemos)
		{
			this.log.warn('Docuserve-Demo: Docuserve-Demos provider not registered');
			this.showEmpty();
			return;
		}

		let tmpEntry = tmpDemos.get(pGroup, pModule, pHash);
		if (!tmpEntry)
		{
			this.log.warn('Docuserve-Demo: no demo registered for ' + pGroup + '/' + pModule + '/' + pHash);
			this.showEmpty();
			return;
		}

		// Render the shell.  AutoRender is false; this view's
		// onAfterRender doesn't run because we call assignContent
		// directly with the parsed template — but the shell renderable
		// path would also work.  Either way the inner containers
		// (#Docuserve-Demo-Live etc.) get freshly created.
		let tmpHTML = this.pict.parseTemplateByHash('Docuserve-Demo-Template', {});
		this.pict.ContentAssignment.assignContent('#Docuserve-Content-Container', tmpHTML);
		this.pict.CSSMap.injectCSS();

		// Populate header
		let tmpTitleEl = document.getElementById('Docuserve-Demo-Title');
		let tmpMetaEl  = document.getElementById('Docuserve-Demo-Meta');
		let tmpDescEl  = document.getElementById('Docuserve-Demo-Description');
		if (tmpTitleEl) { tmpTitleEl.textContent = tmpEntry.Name || tmpEntry.Hash; }
		if (tmpMetaEl)
		{
			tmpMetaEl.innerHTML = this._escapeHTML(tmpEntry.Group) + ' · '
				+ '<a href="#/doc/' + this._escapeHTML(tmpEntry.Group) + '/' + this._escapeHTML(tmpEntry.Module) + '">' + this._escapeHTML(tmpEntry.Module) + '</a>';
		}
		if (tmpDescEl) { tmpDescEl.textContent = tmpEntry.Description || ''; }

		// Populate live container by calling the demo's Mount.
		let tmpLiveEl = document.getElementById('Docuserve-Demo-Live');
		let tmpSourcesEl = document.getElementById('Docuserve-Demo-Sources');
		if (tmpLiveEl)
		{
			let tmpHasSources = Array.isArray(tmpEntry.Sources) && tmpEntry.Sources.length > 0;
			if (tmpSourcesEl)
			{
				tmpSourcesEl.style.display = tmpHasSources ? '' : 'none';
				tmpLiveEl.classList.toggle('full-width', !tmpHasSources);
			}

			try
			{
				tmpEntry.Mount(this.pict, tmpLiveEl, tmpEntry.Spec || {});
			}
			catch (pError)
			{
				this.log.warn('Docuserve-Demo: Mount() threw for ' + pHash + ': ' + (pError && pError.message ? pError.message : pError));
				tmpLiveEl.innerHTML = '<div class="docuserve-demo-empty">Demo failed to mount: ' + this._escapeHTML(pError && pError.message ? pError.message : String(pError)) + '</div>';
			}
		}

		// Populate sources tabs.
		if (Array.isArray(tmpEntry.Sources) && tmpEntry.Sources.length > 0)
		{
			this._renderSources(tmpEntry.Sources);
		}
	}

	_renderSources(pSources)
	{
		let tmpTabsEl = document.getElementById('Docuserve-Demo-Sources-Tabs');
		let tmpBodyEl = document.getElementById('Docuserve-Demo-Sources-Body');
		if (!tmpTabsEl || !tmpBodyEl) { return; }

		let tmpTabsHTML = '';
		let tmpBodyHTML = '';
		for (let i = 0; i < pSources.length; i++)
		{
			let tmpSrc = pSources[i];
			let tmpActiveCls = (i === 0) ? ' active' : '';
			let tmpLabel = this._escapeHTML(tmpSrc.Name || ('source-' + (i + 1)));
			tmpTabsHTML += '<button type="button" class="docuserve-demo-sources-tab' + tmpActiveCls + '" '
				+ 'data-source-idx="' + i + '" '
				+ 'onclick="_Pict.views[\'Docuserve-Demo\']._switchSourceTab(' + i + ')">'
				+ tmpLabel + '</button>';
			tmpBodyHTML += '<div class="docuserve-demo-source-pane' + tmpActiveCls + '" data-source-idx="' + i + '">'
				+ '<pre><code>' + this._escapeHTML(tmpSrc.Content || '') + '</code></pre>'
				+ '</div>';
		}
		tmpTabsEl.innerHTML = tmpTabsHTML;
		tmpBodyEl.innerHTML = tmpBodyHTML;
	}

	_switchSourceTab(pIdx)
	{
		let tmpTabs = document.querySelectorAll('.docuserve-demo-sources-tab');
		let tmpPanes = document.querySelectorAll('.docuserve-demo-source-pane');
		for (let i = 0; i < tmpTabs.length; i++)
		{
			let tmpIdx = parseInt(tmpTabs[i].getAttribute('data-source-idx'), 10);
			tmpTabs[i].classList.toggle('active', tmpIdx === pIdx);
		}
		for (let i = 0; i < tmpPanes.length; i++)
		{
			let tmpIdx = parseInt(tmpPanes[i].getAttribute('data-source-idx'), 10);
			tmpPanes[i].classList.toggle('active', tmpIdx === pIdx);
		}
	}

	_escapeHTML(pText)
	{
		if (pText == null) { return ''; }
		return String(pText)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = DocuserveDemoView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],75:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Docuserve-Layout — application chrome built on pict-section-modal's
 * shell() API.
 *
 * Layout:
 *
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │ #Theme-TopBar  (top, fixed, 56px)                            │
 *   │   BrandMark + Docuserve-TopBar-Nav + Docuserve-TopBar-User   │
 *   ├────────┬─────────────────────────────────────────────────────┤
 *   │ #Doc-  │ #Docuserve-Content-Container  (center)              │
 *   │ userve │   - splash / content / search views render here     │
 *   │ -Side- │                                                     │
 *   │ bar-   │                                                     │
 *   │ Cont…  │                                                     │
 *   │ (left, │                                                     │
 *   │ resiz) │                                                     │
 *   └────────┴─────────────────────────────────────────────────────┘
 *
 * The legacy `data-theme="dark|light"` toggle, custom topbar markup, and
 * hand-rolled body flex layout are all retired here in favour of the
 * pict-section-theme + pict-section-modal stack.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Layout",

	DefaultRenderable: "Docuserve-Layout-Shell",
	DefaultDestinationAddress: "#Docuserve-Application-Container",

	AutoRender: false,

	CSS: /*css*/`
		html, body { height: 100%; margin: 0; padding: 0; }
		body
		{
			background: var(--theme-color-background-primary, #FDFBF7);
			color:      var(--theme-color-text-primary,       #2A241E);
			font-family: var(--theme-typography-family-sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif);
		}
		/* height: 100% (not 100vh) — Theme-Scale applies CSS zoom on
		   <html>; vh units render against the un-zoomed viewport and
		   push panels off-screen at non-1.0 scale. */
		#Docuserve-Application-Container
		{
			height: 100%;
			min-height: 0;
			overflow: hidden;
		}
		.pict-modal-shell-host   { height: 100%; }
		.pict-modal-shell        { background: var(--theme-color-background-primary, #FDFBF7); }
		.pict-modal-shell-panel  { background: var(--theme-color-background-panel,   #FFFFFF); }
		.pict-modal-shell-center { background: var(--theme-color-background-primary, #FDFBF7); }

		/* Center workspace — content / splash / search views write into
		   #Docuserve-Content-Container which the shell provisions as the
		   center destination. */
		#Docuserve-Content-Container
		{
			height: 100%;
			min-height: 0;
			overflow-y: auto;
		}

		/* The Sidebar view writes into the panel's destination
		   (#Docuserve-Sidebar-Container).  Its own CSS lives in
		   PictView-Docuserve-Sidebar — here we just guarantee the panel
		   wrap is scrollable and themed. */
		#Docuserve-Sidebar-Container
		{
			height: 100%;
			min-height: 0;
			overflow-y: auto;
			background: var(--theme-color-background-secondary, var(--docuserve-sidebar-bg, #FAF7F1));
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Layout-Shell-Template",
			// Minimal template — the shell owns the real DOM. The mount
			// div is where the shell attaches; everything else (topbar,
			// sidebar, center) is built by shell.addPanel + shell.center.
			Template: /*html*/`<div id="Docuserve-Layout-Mount" style="height:100%"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Layout-Shell",
			TemplateHash: "Docuserve-Layout-Shell-Template",
			DestinationAddress: "#Docuserve-Application-Container",
			RenderMethod: "replace"
		}
	]
};

class DocuserveLayoutView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._shell = null;
		this._shellPanelsBuilt = false;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		if (!this._shellPanelsBuilt)
		{
			this._buildShell();
			this._shellPanelsBuilt = true;
		}

		// Resolve the current hash on initial load — splash / content /
		// search views render into the shell-managed center destination.
		this.pict.PictApplication.resolveHash();

		this._wireHashChangeListener();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_buildShell()
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.shell !== 'function')
		{
			if (this.log && this.log.warn) { this.log.warn('Docuserve-Layout: pict-section-modal.shell not available'); }
			return;
		}

		let tmpMount = document.getElementById('Docuserve-Layout-Mount');
		if (!tmpMount)
		{
			if (this.log && this.log.warn) { this.log.warn('Docuserve-Layout: #Docuserve-Layout-Mount missing'); }
			return;
		}

		this._shell = tmpModal.shell(tmpMount, { PersistenceKey: 'docuserve-shell' });

		// Top — Theme-TopBar (BrandMark + NavView + UserView slots; Theme-Button on the far right).
		this._shell.addPanel(
		{
			Hash: 'topbar',
			Side: 'top',
			Mode: 'fixed',
			Size: 56,
			ContentDestinationId: 'Theme-TopBar',
			ContentView: 'Theme-TopBar'
		});

		// Left — sidebar.  Resizable + collapsible + responsive-drawer
		// below 900px wide (the sidebar flips to a top drawer above the
		// content area when the viewport gets narrow).
		this._shell.addPanel(
		{
			Hash: 'sidebar',
			Side: 'left',
			Mode: 'resizable',
			Size: 280,
			MinSize: 200,
			MaxSize: 500,
			Title: 'Documentation',
			ContentDestinationId: 'Docuserve-Sidebar-Container',
			ContentView: 'Docuserve-Sidebar',
			ResponsiveDrawer: 900
		});

		// Center — the content area where splash / content / search render.
		this._shell.center({ ContentDestinationId: 'Docuserve-Content-Container' });
	}

	_wireHashChangeListener()
	{
		if (this._hashListenerBound) { return; }
		this._hashListenerBound = true;
		let tmpSelf = this;
		window.addEventListener('hashchange', () =>
		{
			tmpSelf.pict.PictApplication.resolveHash();
		});
	}

	// ─────────────────────────────────────────────
	//  Public panel accessors (used by views that need to toggle the
	//  sidebar — e.g. mobile menu buttons).
	// ─────────────────────────────────────────────

	getSidebarPanel() { return this._shell ? this._shell.getPanel('sidebar') : null; }

	toggleSidebar()
	{
		let tmpPanel = this.getSidebarPanel();
		if (tmpPanel) { tmpPanel.toggle(); }
	}
}

module.exports = DocuserveLayoutView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],76:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Search",

	DefaultRenderable: "Docuserve-Search-Display",
	DefaultDestinationAddress: "#Docuserve-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-search {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.docuserve-search-header {
			margin-bottom: 1.5em;
		}
		.docuserve-search-header h1 {
			font-size: 1.75em;
			color: var(--theme-color-text-primary, #3D3229);
			margin: 0 0 0.75em 0;
		}
		.docuserve-search-input {
			width: 100%;
			padding: 0.75em 1em;
			font-size: 1.1em;
			border: 2px solid #D4CCBE;
			border-radius: 6px;
			outline: none;
			box-sizing: border-box;
			transition: border-color 0.15s;
		}
		.docuserve-search-input:focus {
			border-color: #2E7D74;
		}
		.docuserve-search-status {
			margin-top: 0.75em;
			font-size: 0.9em;
			color: #8A7F72;
		}
		.docuserve-search-results {
			margin-top: 1em;
		}
		.docuserve-search-result {
			display: block;
			padding: 1em 1.25em;
			margin-bottom: 0.5em;
			border: 1px solid #EAE3D8;
			border-radius: 6px;
			text-decoration: none;
			color: inherit;
			transition: border-color 0.15s, box-shadow 0.15s;
		}
		.docuserve-search-result:hover {
			border-color: #2E7D74;
			box-shadow: 0 2px 8px rgba(46, 125, 116, 0.1);
		}
		.docuserve-search-result-title {
			font-size: 1.05em;
			font-weight: 600;
			color: #2E7D74;
			margin-bottom: 0.25em;
		}
		.docuserve-search-result-breadcrumb {
			font-size: 0.8em;
			color: #8A7F72;
			margin-bottom: 0.2em;
		}
		.docuserve-search-result-path {
			font-size: 0.8em;
			color: #A39889;
			font-family: monospace;
		}
		.docuserve-search-empty {
			text-align: center;
			padding: 3em 1em;
			color: #8A7F72;
			font-size: 1em;
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Search-Template",
			Template: /*html*/`
<div class="docuserve-search">
	<div class="docuserve-search-header">
		<h1>Search Documentation</h1>
		<input type="text" class="docuserve-search-input" id="Docuserve-Search-Input" placeholder="Search across all modules...">
		<div id="Docuserve-Search-Status" class="docuserve-search-status"></div>
	</div>
	<div id="Docuserve-Search-Results" class="docuserve-search-results"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Search-Display",
			TemplateHash: "Docuserve-Search-Template",
			DestinationAddress: "#Docuserve-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class DocuserveSearchView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._SearchDebounceTimer = null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		// Attach the search input listener
		let tmpInput = document.getElementById('Docuserve-Search-Input');
		if (tmpInput)
		{
			tmpInput.addEventListener('input', () =>
			{
				if (this._SearchDebounceTimer)
				{
					clearTimeout(this._SearchDebounceTimer);
				}

				this._SearchDebounceTimer = setTimeout(() =>
				{
					this.performSearch(tmpInput.value);
				}, 250);
			});
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Show the search page with an optional initial query.
	 *
	 * @param {string} pQuery - The initial search query
	 */
	showSearch(pQuery)
	{
		let tmpInput = document.getElementById('Docuserve-Search-Input');
		if (tmpInput)
		{
			tmpInput.value = pQuery || '';
			tmpInput.focus();
		}

		if (pQuery && pQuery.trim())
		{
			this.performSearch(pQuery);
		}
		else
		{
			let tmpDocCount = this.pict.AppData.Docuserve.KeywordDocumentCount || 0;
			let tmpStatusMsg = tmpDocCount > 0
				? 'Search across ' + tmpDocCount + ' documents.'
				: 'Enter a search term to find documentation.';
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Status', tmpStatusMsg);
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Results', '');
		}

		// Scroll to top
		let tmpContentContainer = document.getElementById('Docuserve-Content-Container');
		if (tmpContentContainer)
		{
			tmpContentContainer.scrollTop = 0;
		}
	}

	/**
	 * Perform a search and render the results.
	 *
	 * @param {string} pQuery - The search query
	 */
	performSearch(pQuery)
	{
		if (!pQuery || !pQuery.trim())
		{
			let tmpDocCount = this.pict.AppData.Docuserve.KeywordDocumentCount || 0;
			let tmpStatusMsg = tmpDocCount > 0
				? 'Search across ' + tmpDocCount + ' documents.'
				: 'Enter a search term to find documentation.';
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Status', tmpStatusMsg);
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Results', '');
			return;
		}

		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpResults = tmpDocProvider.search(pQuery);

		// Update status
		if (tmpResults.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Status',
				'No results found for \'' + this.escapeHTML(pQuery) + '\'.');
			this.pict.ContentAssignment.assignContent('#Docuserve-Search-Results', '');
			return;
		}

		this.pict.ContentAssignment.assignContent('#Docuserve-Search-Status',
			tmpResults.length + ' result' + (tmpResults.length !== 1 ? 's' : '') + ' for \'' + this.escapeHTML(pQuery) + '\'');

		// Render results
		let tmpHTML = '';

		for (let i = 0; i < tmpResults.length; i++)
		{
			let tmpResult = tmpResults[i];
			let tmpBreadcrumb = '';
			if (tmpResult.Group && tmpResult.Module)
			{
				tmpBreadcrumb = tmpResult.Group + ' &rsaquo; ' + tmpResult.Module;
			}

			tmpHTML += '<a class="docuserve-search-result" href="' + tmpResult.Route + '">';
			tmpHTML += '<div class="docuserve-search-result-title">' + this.escapeHTML(tmpResult.Title) + '</div>';
			if (tmpBreadcrumb)
			{
				tmpHTML += '<div class="docuserve-search-result-breadcrumb">' + tmpBreadcrumb + '</div>';
			}
			if (tmpResult.DocPath)
			{
				tmpHTML += '<div class="docuserve-search-result-path">' + this.escapeHTML(tmpResult.DocPath) + '</div>';
			}
			tmpHTML += '</a>';
		}

		this.pict.ContentAssignment.assignContent('#Docuserve-Search-Results', tmpHTML);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = DocuserveSearchView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],77:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Sidebar",

	DefaultRenderable: "Docuserve-Sidebar-Content",
	DefaultDestinationAddress: "#Docuserve-Sidebar-Container",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-sidebar {
			display: flex;
			flex-direction: column;
			background: var(--docuserve-sidebar-bg);
			border-right: 1px solid var(--docuserve-sidebar-border);
			padding: 1em 0;
			padding-top: 0;
			min-height: 100%;
			position: relative;
			transition: background-color 0.15s ease;
		}
		.docuserve-sidebar-header {
			display: flex;
			justify-content: flex-end;
			padding: 0.4em 0.5em 0;
		}
		.docuserve-sidebar-close {
			background: none;
			border: none;
			color: var(--docuserve-text-dim);
			font-size: 1.2em;
			cursor: pointer;
			padding: 0.2em 0.4em;
			line-height: 1;
		}
		.docuserve-sidebar-close:hover {
			color: var(--docuserve-accent);
		}
		.docuserve-sidebar-search {
			padding: 0 1em 1em 1em;
			border-bottom: 1px solid var(--docuserve-sidebar-border-soft);
			margin-bottom: 0.5em;
		}
		.docuserve-sidebar-search input {
			width: 100%;
			padding: 0.5em 0.75em;
			background: var(--docuserve-sidebar-search-bg);
			color: var(--docuserve-text);
			border: 1px solid var(--docuserve-sidebar-search-border);
			border-radius: 4px;
			font-size: 0.85em;
			outline: none;
			box-sizing: border-box;
		}
		.docuserve-sidebar-search input:focus {
			border-color: var(--docuserve-accent);
		}
		.docuserve-sidebar-search-results {
			margin-top: 0.5em;
		}
		.docuserve-sidebar-search-results a {
			display: block;
			padding: 0.4em 0.5em;
			color: var(--docuserve-sidebar-text);
			text-decoration: none;
			font-size: 0.82em;
			border-radius: 3px;
			transition: background-color 0.1s;
			cursor: pointer;
		}
		.docuserve-sidebar-search-results a:hover {
			background-color: var(--docuserve-sidebar-hover-bg);
			color: var(--docuserve-sidebar-hover-text);
		}
		.docuserve-sidebar-search-result-title {
			font-weight: 600;
			color: var(--docuserve-text-strong);
		}
		.docuserve-sidebar-search-results a:hover .docuserve-sidebar-search-result-title {
			color: var(--docuserve-sidebar-hover-text);
		}
		.docuserve-sidebar-search-result-meta {
			font-size: 0.9em;
			color: var(--docuserve-text-dim);
		}
		.docuserve-sidebar-search-all {
			display: block;
			padding: 0.4em 0.5em;
			font-size: 0.82em;
			color: var(--docuserve-accent);
			text-decoration: none;
			font-weight: 600;
			cursor: pointer;
			border-top: 1px solid var(--docuserve-sidebar-border-soft);
			margin-top: 0.25em;
			padding-top: 0.5em;
		}
		.docuserve-sidebar-search-all:hover {
			text-decoration: underline;
		}
		.docuserve-sidebar-home {
			padding: 0.5em 1.25em;
			font-weight: 600;
			font-size: 0.85em;
			text-transform: uppercase;
			letter-spacing: 0.03em;
		}
		.docuserve-sidebar-home a {
			color: var(--docuserve-sidebar-module-text);
			text-decoration: none;
			cursor: pointer;
			user-select: none;
		}
		.docuserve-sidebar-home a:hover {
			color: var(--docuserve-sidebar-hover-text);
		}
		.docuserve-sidebar-group {
			margin-top: 0.25em;
		}
		.docuserve-sidebar-group-title {
			display: block;
			padding: 0.5em 1.25em;
			font-weight: 600;
			font-size: 0.85em;
			color: var(--docuserve-sidebar-group-title);
			text-decoration: none;
			text-transform: uppercase;
			letter-spacing: 0.03em;
			cursor: pointer;
			user-select: none;
			transition: background-color 0.1s, color 0.1s;
		}
		.docuserve-sidebar-group-title:hover {
			color: var(--docuserve-sidebar-hover-text);
			background-color: var(--docuserve-sidebar-hover-bg);
		}
		a.docuserve-sidebar-group-title.active {
			color: var(--docuserve-sidebar-active-text);
			background-color: var(--docuserve-sidebar-active-bg);
		}
		.docuserve-sidebar-modules {
			list-style: none;
			margin: 0;
			padding: 0;
		}
		.docuserve-sidebar-modules li {
			padding: 0;
		}
		.docuserve-sidebar-modules a {
			display: block;
			padding: 0.3em 1.25em 0.3em 2em;
			color: var(--docuserve-sidebar-module-text);
			text-decoration: none;
			font-size: 0.85em;
			transition: background-color 0.1s, color 0.1s;
			cursor: pointer;
		}
		.docuserve-sidebar-modules a:hover {
			background-color: var(--docuserve-sidebar-hover-bg);
			color: var(--docuserve-sidebar-hover-text);
		}
		.docuserve-sidebar-modules a.active {
			color: var(--docuserve-sidebar-active-text);
			font-weight: 600;
			background-color: var(--docuserve-sidebar-active-bg);
		}
		.docuserve-sidebar-modules .no-docs {
			display: block;
			padding: 0.3em 1.25em 0.3em 2em;
			color: var(--docuserve-text-dim);
			font-size: 0.85em;
		}
		.docuserve-sidebar-module-nav {
			border-top: 1px solid var(--docuserve-sidebar-border-soft);
			margin-top: 0.5em;
			padding-top: 0.5em;
		}
		.docuserve-sidebar-module-nav-section {
			padding: 0.4em 1.25em;
			font-weight: 600;
			font-size: 0.8em;
			color: var(--docuserve-text-dim);
			text-transform: uppercase;
			letter-spacing: 0.02em;
		}
		.docuserve-sidebar-module-nav a {
			display: block;
			padding: 0.25em 1.25em 0.25em 2.25em;
			color: var(--docuserve-sidebar-module-text);
			text-decoration: none;
			font-size: 0.82em;
			transition: background-color 0.1s, color 0.1s;
			cursor: pointer;
		}
		.docuserve-sidebar-module-nav a:hover {
			background-color: var(--docuserve-sidebar-hover-bg);
			color: var(--docuserve-sidebar-hover-text);
		}
		.docuserve-sidebar-footer {
			margin-top: auto;
			padding: 0.9em 1.25em 1em 1.25em;
			border-top: 1px solid var(--docuserve-sidebar-border-soft);
		}
		.docuserve-sidebar-footer:empty {
			display: none;
		}
		.docuserve-version-placard {
			font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
			line-height: 1.35;
		}
		.docuserve-version-name {
			font-size: 0.78em;
			font-weight: 600;
			color: var(--docuserve-text-muted);
			letter-spacing: 0.02em;
		}
		.docuserve-version-number {
			font-size: 0.82em;
			font-weight: 500;
			color: var(--docuserve-accent);
		}
		.docuserve-version-meta {
			font-size: 0.7em;
			color: var(--docuserve-text-dim);
			margin-top: 0.15em;
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Sidebar-Template",
			Template: /*html*/`
<div class="docuserve-sidebar">
	<div class="docuserve-sidebar-header">
		<button class="docuserve-sidebar-close" onclick="{~P~}.views['Docuserve-Sidebar'].toggleSidebar()">&times;</button>
	</div>
	<div id="Docuserve-Sidebar-Search" class="docuserve-sidebar-search" style="display:none;">
		<input type="text" placeholder="Search docs..." id="Docuserve-Sidebar-Search-Input">
		<div id="Docuserve-Sidebar-Search-Results" class="docuserve-sidebar-search-results"></div>
	</div>
	<div class="docuserve-sidebar-home">
		<a onclick="{~P~}.PictApplication.navigateTo('/Home')">Home</a>
	</div>
	<div id="Docuserve-Sidebar-Groups"></div>
	<div id="Docuserve-Sidebar-ModuleNav"></div>
	<div id="Docuserve-Sidebar-Footer" class="docuserve-sidebar-footer"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Sidebar-Content",
			TemplateHash: "Docuserve-Sidebar-Template",
			DestinationAddress: "#Docuserve-Sidebar-Container",
			RenderMethod: "replace"
		}
	]
};

class DocusserveSidebarView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._SidebarSearchDebounceTimer = null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.renderSidebarGroups();
		this.renderSidebarFooter();

		// Conditionally show the search box if the keyword index is loaded
		let tmpSearchContainer = document.getElementById('Docuserve-Sidebar-Search');
		if (tmpSearchContainer && this.pict.AppData.Docuserve.KeywordIndexLoaded)
		{
			tmpSearchContainer.style.display = '';

			let tmpInput = document.getElementById('Docuserve-Sidebar-Search-Input');
			if (tmpInput)
			{
				tmpInput.addEventListener('input', () =>
				{
					if (this._SidebarSearchDebounceTimer)
					{
						clearTimeout(this._SidebarSearchDebounceTimer);
					}

					this._SidebarSearchDebounceTimer = setTimeout(() =>
					{
						this.performSidebarSearch(tmpInput.value);
					}, 250);
				});
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Render the sidebar footer placard showing module name, version,
	 * build timestamp and git commit from _version.json.  Hides the
	 * footer entirely when no version data is loaded.
	 */
	renderSidebarFooter()
	{
		let tmpFooterEl = document.getElementById('Docuserve-Sidebar-Footer');
		if (!tmpFooterEl)
		{
			return;
		}
		let tmpDocuserve = this.pict.AppData.Docuserve;
		if (!tmpDocuserve.VersionLoaded || !tmpDocuserve.Version || !tmpDocuserve.Version.Version)
		{
			tmpFooterEl.innerHTML = '';
			return;
		}
		let tmpVersion = tmpDocuserve.Version;
		let tmpHTML = '<div class="docuserve-version-placard">';
		if (tmpVersion.Name)
		{
			tmpHTML += '<div class="docuserve-version-name">' + this.escapeHTML(tmpVersion.Name) + '</div>';
		}
		tmpHTML += '<div class="docuserve-version-number">v' + this.escapeHTML(tmpVersion.Version) + '</div>';
		let tmpMetaParts = [];
		if (tmpVersion.GeneratedAt)
		{
			let tmpDate = String(tmpVersion.GeneratedAt).match(/^(\d{4}-\d{2}-\d{2})/);
			if (tmpDate)
			{
				tmpMetaParts.push('built ' + tmpDate[1]);
			}
		}
		if (tmpVersion.GitCommit)
		{
			tmpMetaParts.push(tmpVersion.GitCommit);
		}
		if (tmpMetaParts.length > 0)
		{
			tmpHTML += '<div class="docuserve-version-meta">' + this.escapeHTML(tmpMetaParts.join(' · ')) + '</div>';
		}
		tmpHTML += '</div>';
		tmpFooterEl.innerHTML = tmpHTML;
	}

	/**
	 * Render the sidebar group navigation from catalog data.
	 */
	renderSidebarGroups()
	{
		let tmpGroups = this.pict.AppData.Docuserve.SidebarGroups;

		if (!tmpGroups || tmpGroups.length < 1)
		{
			// Empty sidebar -- don't show a permanent loading message
			this.pict.ContentAssignment.assignContent('#Docuserve-Sidebar-Groups', '');
			return;
		}

		let tmpHTML = '';

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];
			tmpHTML += '<div class="docuserve-sidebar-group">';

			// Determine the route for the group title: use the group's own route,
			// or fall back to the first module with docs.
			let tmpGroupRoute = tmpGroup.Route || '';
			if (!tmpGroupRoute)
			{
				for (let k = 0; k < tmpGroup.Modules.length; k++)
				{
					if (tmpGroup.Modules[k].HasDocs && tmpGroup.Modules[k].Route)
					{
						tmpGroupRoute = tmpGroup.Modules[k].Route;
						break;
					}
				}
			}

			if (tmpGroupRoute)
			{
				let tmpGroupActiveClass = '';
				let tmpCurrentHash = window.location.hash || '';
				if (this.pict.AppData.Docuserve.CurrentGroup === tmpGroup.Key
					|| tmpCurrentHash === tmpGroupRoute)
				{
					tmpGroupActiveClass = ' active';
				}
				tmpHTML += '<a class="docuserve-sidebar-group-title' + tmpGroupActiveClass + '" href="' + tmpGroupRoute + '">' + this.escapeHTML(tmpGroup.Name) + '</a>';
			}
			else
			{
				tmpHTML += '<div class="docuserve-sidebar-group-title">' + this.escapeHTML(tmpGroup.Name) + '</div>';
			}
			tmpHTML += '<ul class="docuserve-sidebar-modules">';

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.HasDocs)
				{
					let tmpActiveClass = '';
					if (this.pict.AppData.Docuserve.CurrentGroup === tmpModule.Group && this.pict.AppData.Docuserve.CurrentModule === tmpModule.Name)
					{
						tmpActiveClass = ' class="active"';
					}
					tmpHTML += '<li><a' + tmpActiveClass + ' href="' + tmpModule.Route + '">' + this.escapeHTML(tmpModule.Name) + '</a></li>';
				}
				else
				{
					tmpHTML += '<li><span class="no-docs">' + this.escapeHTML(tmpModule.Name) + '</span></li>';
				}
			}

			tmpHTML += '</ul>';
			tmpHTML += '</div>';
		}

		this.pict.ContentAssignment.assignContent('#Docuserve-Sidebar-Groups', tmpHTML);
	}

	/**
	 * Render module-specific sub-navigation when viewing a module.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 */
	renderModuleNav(pGroup, pModule)
	{
		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpDemosProvider = this.pict.providers['Docuserve-Demos'];

		let tmpSidebar = tmpDocProvider ? tmpDocProvider.getModuleSidebar(pGroup, pModule) : null;
		let tmpDemos = tmpDemosProvider ? tmpDemosProvider.listByModule(pGroup, pModule) : [];

		if ((!tmpSidebar || tmpSidebar.length < 1) && tmpDemos.length < 1)
		{
			this.pict.ContentAssignment.assignContent('#Docuserve-Sidebar-ModuleNav', '');
			return;
		}

		let tmpRoutePrefix = '#/doc/' + pGroup + '/' + pModule + '/';
		let tmpDemoPrefix  = '#/demo/' + pGroup + '/' + pModule + '/';
		let tmpCurrentDemo = this.pict.AppData.Docuserve.CurrentDemo || '';
		let tmpHTML = '<div class="docuserve-sidebar-module-nav">';

		if (tmpSidebar && tmpSidebar.length > 0)
		{
			for (let i = 0; i < tmpSidebar.length; i++)
			{
				let tmpEntry = tmpSidebar[i];

				if (tmpEntry.Children)
				{
					tmpHTML += '<div class="docuserve-sidebar-module-nav-section">' + this.escapeHTML(tmpEntry.Title) + '</div>';

					for (let j = 0; j < tmpEntry.Children.length; j++)
					{
						let tmpChild = tmpEntry.Children[j];
						if (tmpChild.Path)
						{
							tmpHTML += '<a href="' + tmpRoutePrefix + tmpChild.Path + '">' + this.escapeHTML(tmpChild.Title) + '</a>';
						}
					}
				}
				else if (tmpEntry.Path)
				{
					tmpHTML += '<a href="' + tmpRoutePrefix + tmpEntry.Path + '">' + this.escapeHTML(tmpEntry.Title) + '</a>';
				}
			}
		}

		// Demos sub-section appears at the bottom of the module nav when
		// the Docuserve-Demos provider has entries for this (group, module).
		// Active demo gets the same `active` styling as a regular page link.
		if (tmpDemos.length > 0)
		{
			tmpHTML += '<div class="docuserve-sidebar-module-nav-section">Demos</div>';
			for (let i = 0; i < tmpDemos.length; i++)
			{
				let tmpDemo = tmpDemos[i];
				let tmpActive = (tmpDemo.Hash === tmpCurrentDemo) ? ' class="active"' : '';
				tmpHTML += '<a' + tmpActive + ' href="' + tmpDemoPrefix + this.escapeHTML(tmpDemo.Hash) + '">'
					+ this.escapeHTML(tmpDemo.Name || tmpDemo.Hash) + '</a>';
			}
		}

		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Docuserve-Sidebar-ModuleNav', tmpHTML);
	}

	/**
	 * Perform a sidebar search and render inline results.
	 *
	 * Shows up to 8 results as compact links.  If there are results, also
	 * shows a "See all results" link to the dedicated search page.
	 *
	 * @param {string} pQuery - The search query
	 */
	performSidebarSearch(pQuery)
	{
		let tmpResultsEl = document.getElementById('Docuserve-Sidebar-Search-Results');
		if (!tmpResultsEl)
		{
			return;
		}

		if (!pQuery || !pQuery.trim())
		{
			tmpResultsEl.innerHTML = '';
			return;
		}

		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpResults = tmpDocProvider.search(pQuery);

		if (tmpResults.length === 0)
		{
			tmpResultsEl.innerHTML = '<div style="padding: 0.4em 0.5em; font-size: 0.82em; color: #8A7F72;">No results found.</div>';
			return;
		}

		let tmpMaxResults = 8;
		let tmpHTML = '';

		for (let i = 0; i < tmpResults.length && i < tmpMaxResults; i++)
		{
			let tmpResult = tmpResults[i];
			let tmpMeta = '';
			if (tmpResult.Group && tmpResult.Module)
			{
				tmpMeta = tmpResult.Group + ' / ' + tmpResult.Module;
			}

			tmpHTML += '<a href="' + tmpResult.Route + '">';
			tmpHTML += '<div class="docuserve-sidebar-search-result-title">' + this.escapeHTML(tmpResult.Title) + '</div>';
			if (tmpMeta)
			{
				tmpHTML += '<div class="docuserve-sidebar-search-result-meta">' + this.escapeHTML(tmpMeta) + '</div>';
			}
			tmpHTML += '</a>';
		}

		if (tmpResults.length > tmpMaxResults)
		{
			let tmpEncodedQuery = encodeURIComponent(pQuery);
			tmpHTML += '<a class="docuserve-sidebar-search-all" href="#/search/' + tmpEncodedQuery + '">See all ' + tmpResults.length + ' results</a>';
		}

		tmpResultsEl.innerHTML = tmpHTML;
	}

	/**
	 * Toggle the sidebar visibility via the layout's shell panel.
	 *
	 * The pict-section-modal shell owns the collapse / resize / persist
	 * chrome for the sidebar panel; we delegate to its toggle() so the
	 * persisted state stays in sync with the actual visual state.
	 *
	 * Falls back to the legacy display:none toggle when the shell isn't
	 * available (e.g. apps still on the pre-migration layout).
	 */
	toggleSidebar()
	{
		let tmpLayout = this.pict.views['Docuserve-Layout'];
		if (tmpLayout && typeof tmpLayout.toggleSidebar === 'function')
		{
			tmpLayout.toggleSidebar();
			return;
		}

		// Legacy fallback for hosts not yet on the shell-driven layout.
		this.pict.AppData.Docuserve.SidebarVisible = !this.pict.AppData.Docuserve.SidebarVisible;
		let tmpContainer = document.getElementById('Docuserve-Sidebar-Container');
		if (tmpContainer)
		{
			tmpContainer.style.display = this.pict.AppData.Docuserve.SidebarVisible ? '' : 'none';
		}
	}

	/**
	 * Clear the module-specific sub-navigation.
	 */
	clearModuleNav()
	{
		this.pict.ContentAssignment.assignContent('#Docuserve-Sidebar-ModuleNav', '');
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = DocusserveSidebarView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],78:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-Splash",

	DefaultRenderable: "Docuserve-Splash-Content",
	DefaultDestinationAddress: "#Docuserve-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-splash {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			min-height: calc(100vh - 56px);
			padding: 3em 2em;
			text-align: center;
			background: var(--docuserve-bg);
		}
		.docuserve-splash h1 {
			font-size: 3em;
			font-weight: 700;
			color: var(--docuserve-text-strong);
			margin: 0 0 0.25em 0;
		}
		.docuserve-splash h1 small {
			font-size: 0.4em;
			font-weight: 400;
			color: var(--docuserve-text-dim);
			vertical-align: middle;
			margin-left: 0.15em;
		}
		.docuserve-splash-tagline {
			font-size: 1.25em;
			color: var(--docuserve-text-muted);
			margin-bottom: 1.5em;
			font-style: italic;
		}
		.docuserve-splash-description {
			font-size: 1em;
			color: var(--docuserve-text-muted);
			max-width: 600px;
			line-height: 1.7;
			margin-bottom: 2em;
		}
		.docuserve-splash-highlights {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
			gap: 1.25em;
			max-width: 900px;
			width: 100%;
			margin-bottom: 2.5em;
		}
		.docuserve-splash-highlight-card {
			background: var(--docuserve-bg-elevated);
			border: 1px solid var(--docuserve-border);
			border-radius: 8px;
			padding: 1.25em;
			text-align: left;
			transition: box-shadow 0.2s, border-color 0.2s;
		}
		.docuserve-splash-highlight-card:hover {
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
			border-color: var(--docuserve-accent);
		}
		.docuserve-splash-highlight-card h3 {
			margin: 0 0 0.5em 0;
			color: var(--docuserve-text-strong);
			font-size: 1em;
		}
		.docuserve-splash-highlight-card p {
			margin: 0;
			color: var(--docuserve-text-muted);
			font-size: 0.85em;
			line-height: 1.5;
		}
		.docuserve-splash-actions {
			display: flex;
			gap: 1em;
			flex-wrap: wrap;
			justify-content: center;
		}
		.docuserve-splash-actions a {
			display: inline-block;
			padding: 0.7em 1.5em;
			border-radius: 6px;
			font-size: 0.95em;
			font-weight: 600;
			text-decoration: none;
			transition: background-color 0.15s, color 0.15s;
			cursor: pointer;
		}
		.docuserve-splash-actions .primary {
			background-color: var(--docuserve-accent);
			color: var(--theme-color-background-panel, #fff);
		}
		.docuserve-splash-actions .primary:hover {
			background-color: var(--docuserve-accent-hover);
		}
		.docuserve-splash-actions .secondary {
			background-color: var(--docuserve-bg-elevated);
			color: var(--docuserve-text-strong);
			border: 2px solid var(--docuserve-accent);
		}
		.docuserve-splash-actions .secondary:hover {
			border-color: var(--docuserve-accent-hover);
			color: var(--docuserve-accent);
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-Splash-Template",
			Template: /*html*/`
<div class="docuserve-splash">
	<h1 id="Docuserve-Splash-Title"></h1>
	<div class="docuserve-splash-tagline" id="Docuserve-Splash-Tagline"></div>
	<div class="docuserve-splash-description" id="Docuserve-Splash-Description"></div>
	<div class="docuserve-splash-highlights" id="Docuserve-Splash-Highlights"></div>
	<div class="docuserve-splash-actions" id="Docuserve-Splash-Actions"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-Splash-Content",
			TemplateHash: "Docuserve-Splash-Template",
			DestinationAddress: "#Docuserve-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class DocusserveSplashView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpDocuserve = this.pict.AppData.Docuserve;

		if (tmpDocuserve.CoverLoaded && tmpDocuserve.Cover)
		{
			this.renderFromCover(tmpDocuserve.Cover);
		}
		else
		{
			this.renderFromCatalog(tmpDocuserve);
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Render the splash screen from parsed _cover.md data.
	 *
	 * @param {Object} pCover - The parsed cover data { Title, Tagline, Description, Highlights, Actions }
	 */
	renderFromCover(pCover)
	{
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Title', this.sanitizeTitle(pCover.Title));
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Tagline', this.escapeHTML(pCover.Tagline));
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Description', this.escapeHTML(pCover.Description));

		// Render highlight cards
		let tmpHighlightsHTML = '';
		for (let i = 0; i < pCover.Highlights.length; i++)
		{
			let tmpHighlight = pCover.Highlights[i];
			tmpHighlightsHTML += '<div class="docuserve-splash-highlight-card">';
			if (tmpHighlight.Label)
			{
				tmpHighlightsHTML += '<h3>' + this.escapeHTML(tmpHighlight.Label) + '</h3>';
			}
			tmpHighlightsHTML += '<p>' + this.escapeHTML(tmpHighlight.Text) + '</p>';
			tmpHighlightsHTML += '</div>';
		}
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Highlights', tmpHighlightsHTML);

		// Render action buttons
		let tmpActionsHTML = '';
		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		for (let i = 0; i < pCover.Actions.length; i++)
		{
			let tmpAction = pCover.Actions[i];
			let tmpClass = (i === 0) ? 'primary' : 'secondary';
			let tmpHref = tmpAction.Href;

			// External links open in new tab
			if (tmpHref.match(/^https?:\/\//))
			{
				tmpActionsHTML += '<a class="' + tmpClass + '" href="' + this.escapeHTML(tmpHref) + '" target="_blank" rel="noopener">' + this.escapeHTML(tmpAction.Text) + '</a>';
			}
			else
			{
				// Internal links go through the app router
				let tmpRoute = tmpDocProvider.convertSidebarLink(tmpHref);
				tmpActionsHTML += '<a class="' + tmpClass + '" href="' + this.escapeHTML(tmpRoute) + '">' + this.escapeHTML(tmpAction.Text) + '</a>';
			}
		}
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Actions', tmpActionsHTML);
	}

	/**
	 * Render the splash screen from catalog data as a fallback when _cover.md
	 * is not available.
	 *
	 * @param {Object} pDocuserve - The AppData.Docuserve state
	 */
	renderFromCatalog(pDocuserve)
	{
		// Derive the title from whatever data is available, falling back to the page title or 'Documentation'
		let tmpTitle = 'Documentation';
		let tmpTagline = '';

		if (pDocuserve.CatalogLoaded && pDocuserve.Catalog && pDocuserve.Catalog.Name)
		{
			tmpTitle = pDocuserve.Catalog.Name;
		}
		else if (pDocuserve.TopBarLoaded && pDocuserve.TopBar && pDocuserve.TopBar.Brand)
		{
			tmpTitle = pDocuserve.TopBar.Brand;
		}
		else if (typeof document !== 'undefined' && document.title)
		{
			tmpTitle = document.title;
		}

		if (pDocuserve.CatalogLoaded && pDocuserve.Catalog && pDocuserve.Catalog.Description)
		{
			tmpTagline = pDocuserve.Catalog.Description;
		}

		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Title', this.escapeHTML(tmpTitle));
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Tagline', this.escapeHTML(tmpTagline));
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Description', '');

		// Build highlight cards from catalog groups
		let tmpHighlightsHTML = '';
		let tmpGroups = pDocuserve.SidebarGroups || [];
		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];
			// Skip groups with no modules (like "Home" or "Getting Started")
			if (!tmpGroup.Modules || tmpGroup.Modules.length < 1)
			{
				continue;
			}
			let tmpDescription = tmpGroup.Description || (tmpGroup.Modules.length + ' modules');
			tmpHighlightsHTML += '<div class="docuserve-splash-highlight-card">';
			tmpHighlightsHTML += '<h3>' + this.escapeHTML(tmpGroup.Name) + '</h3>';
			tmpHighlightsHTML += '<p>' + this.escapeHTML(tmpDescription) + '</p>';
			tmpHighlightsHTML += '</div>';
		}
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Highlights', tmpHighlightsHTML);

		// Default action buttons
		this.pict.ContentAssignment.assignContent('#Docuserve-Splash-Actions', '');
	}

	/**
	 * Sanitize a title string, preserving only <small> tags.
	 * All other HTML is escaped.
	 *
	 * @param {string} pText - The raw title text
	 * @returns {string} The sanitized title HTML
	 */
	sanitizeTitle(pText)
	{
		if (!pText)
		{
			return '';
		}
		// Escape everything first, then restore <small> and </small>
		return this.escapeHTML(pText)
			.replace(/&lt;small&gt;/gi, '<small>')
			.replace(/&lt;\/small&gt;/gi, '</small>');
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = DocusserveSplashView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],79:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * PictView-Docuserve-TopBar-Nav — slot view rendered into Theme-TopBar's
 * NavView slot. Hosts navigation links (Home + any links declared in
 * _topbar.md) and the version chip (sourced from _version.json).
 *
 * Re-renders on demand when AppData.Docuserve.TopBar / Version data
 * is loaded by the documentation provider.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-TopBar-Nav",

	DefaultRenderable: "Docuserve-TopBar-Nav-Display",
	DefaultDestinationAddress: "#Theme-TopBar-Nav",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-nav
		{
			display: flex;
			align-items: center;
			height: 100%;
			gap: 0.6em;
			padding: 0 0.75em;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #E8E0D4));
		}
		.docuserve-nav-links
		{
			display: flex;
			align-items: center;
			gap: 0.25em;
		}
		.docuserve-nav-links a
		{
			color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #B5AA9A));
			text-decoration: none;
			padding: 0.45em 0.7em;
			border-radius: 4px;
			font-size: 0.9em;
			transition: background-color 0.15s, color 0.15s;
			cursor: pointer;
		}
		.docuserve-nav-links a:hover
		{
			background-color: var(--theme-color-background-hover, rgba(255, 255, 255, 0.06));
			color: var(--theme-color-text-on-brand, var(--theme-color-background-panel, #fff));
		}
		.docuserve-nav-version
		{
			font-size: 0.72em;
			font-weight: 500;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-muted, #B5AA9A));
			background: var(--theme-color-background-hover, rgba(255, 255, 255, 0.06));
			border: 1px solid var(--theme-color-border-light, rgba(255, 255, 255, 0.08));
			padding: 0.12em 0.55em;
			border-radius: 10px;
			font-family: var(--theme-typography-family-mono, ui-monospace, SFMono-Regular, Menlo, Consolas, monospace);
			letter-spacing: 0.02em;
			white-space: nowrap;
		}
		.docuserve-nav-version:empty
		{
			display: none;
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-TopBar-Nav-Template",
			Template: /*html*/`
<div class="docuserve-nav">
	<div id="Docuserve-Nav-Links" class="docuserve-nav-links"></div>
	<span id="Docuserve-Nav-Version" class="docuserve-nav-version" title=""></span>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-TopBar-Nav-Display",
			TemplateHash: "Docuserve-TopBar-Nav-Template",
			DestinationAddress: "#Theme-TopBar-Nav",
			RenderMethod: "replace"
		}
	]
};

class DocuserveTopBarNavView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._renderNavLinks();
		this._renderVersionChip();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_renderNavLinks()
	{
		let tmpDocuserve = this.pict.AppData.Docuserve || {};
		let tmpLinksEl = document.getElementById('Docuserve-Nav-Links');
		if (!tmpLinksEl) { return; }

		let tmpHTML = '<a href="#/Home">Home</a>';
		if (tmpDocuserve.TopBarLoaded && tmpDocuserve.TopBar && Array.isArray(tmpDocuserve.TopBar.NavLinks))
		{
			for (let i = 0; i < tmpDocuserve.TopBar.NavLinks.length; i++)
			{
				let tmpLink = tmpDocuserve.TopBar.NavLinks[i];
				tmpHTML += '<a href="' + this._escapeHTML(tmpLink.Href || '#') + '">' + this._escapeHTML(tmpLink.Text || '') + '</a>';
			}
		}
		tmpLinksEl.innerHTML = tmpHTML;
	}

	_renderVersionChip()
	{
		let tmpDocuserve = this.pict.AppData.Docuserve || {};
		let tmpEl = document.getElementById('Docuserve-Nav-Version');
		if (!tmpEl) { return; }

		if (!tmpDocuserve.VersionLoaded || !tmpDocuserve.Version || !tmpDocuserve.Version.Version)
		{
			tmpEl.innerHTML = '';
			tmpEl.setAttribute('title', '');
			return;
		}

		let tmpVersion = tmpDocuserve.Version;
		tmpEl.innerHTML = 'v' + this._escapeHTML(tmpVersion.Version);

		let tmpTooltipParts = [];
		tmpTooltipParts.push((tmpVersion.Name ? tmpVersion.Name + ' ' : '') + 'v' + tmpVersion.Version);
		if (tmpVersion.GeneratedAt)
		{
			let tmpMatch = String(tmpVersion.GeneratedAt).match(/^(\d{4}-\d{2}-\d{2})/);
			tmpTooltipParts.push('built ' + (tmpMatch ? tmpMatch[1] : tmpVersion.GeneratedAt));
		}
		if (tmpVersion.GitCommit)
		{
			tmpTooltipParts.push(tmpVersion.GitCommit);
		}
		tmpEl.setAttribute('title', tmpTooltipParts.join(' · '));
	}

	_escapeHTML(pText)
	{
		if (pText == null) { return ''; }
		return String(pText)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = DocuserveTopBarNavView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}],80:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * PictView-Docuserve-TopBar-User — slot view rendered into Theme-TopBar's
 * UserView slot. Hosts the Search link (when a keyword index is loaded)
 * and any external links declared in _topbar.md.
 *
 * The theme button (Theme-Section's 'Button' view) renders into the
 * Theme-TopBar chrome alongside this view — it's the right-most cluster
 * that opens the picker / mode-toggle / scale-select popover.
 *
 * Re-renders on demand when AppData.Docuserve.TopBar /
 * KeywordIndexLoaded changes.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Docuserve-TopBar-User",

	DefaultRenderable: "Docuserve-TopBar-User-Display",
	DefaultDestinationAddress: "#Theme-TopBar-User",

	AutoRender: false,

	CSS: /*css*/`
		.docuserve-user
		{
			display: flex;
			align-items: center;
			height: 100%;
			gap: 0.25em;
			padding: 0 0.75em;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #B5AA9A));
		}
		.docuserve-user a
		{
			color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #B5AA9A));
			text-decoration: none;
			font-size: 0.85em;
			padding: 0.4em 0.6em;
			border-radius: 4px;
			transition: background-color 0.15s, color 0.15s;
		}
		.docuserve-user a:hover
		{
			background-color: var(--theme-color-background-hover, rgba(255, 255, 255, 0.06));
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #E8E0D4));
		}
	`,

	Templates:
	[
		{
			Hash: "Docuserve-TopBar-User-Template",
			Template: /*html*/`<div class="docuserve-user" id="Docuserve-User-Links"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Docuserve-TopBar-User-Display",
			TemplateHash: "Docuserve-TopBar-User-Template",
			DestinationAddress: "#Theme-TopBar-User",
			RenderMethod: "replace"
		}
	]
};

class DocuserveTopBarUserView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._renderLinks();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_renderLinks()
	{
		let tmpDocuserve = this.pict.AppData.Docuserve || {};
		let tmpEl = document.getElementById('Docuserve-User-Links');
		if (!tmpEl) { return; }

		let tmpHTML = '';
		// Search link comes first when a keyword index is available.
		if (tmpDocuserve.KeywordIndexLoaded)
		{
			tmpHTML += '<a href="#/search/">Search</a>';
		}
		// External links from _topbar.md.
		if (tmpDocuserve.TopBarLoaded && tmpDocuserve.TopBar && Array.isArray(tmpDocuserve.TopBar.ExternalLinks))
		{
			for (let i = 0; i < tmpDocuserve.TopBar.ExternalLinks.length; i++)
			{
				let tmpLink = tmpDocuserve.TopBar.ExternalLinks[i];
				let tmpHref = this._escapeHTML(tmpLink.Href || '#');
				let tmpText = this._escapeHTML(tmpLink.Text || '');
				let tmpIsExternal = /^https?:/i.test(tmpLink.Href || '');
				tmpHTML += '<a href="' + tmpHref + '"' + (tmpIsExternal ? ' target="_blank" rel="noopener"' : '') + '>' + tmpText + '</a>';
			}
		}
		tmpEl.innerHTML = tmpHTML;
	}

	_escapeHTML(pText)
	{
		if (pText == null) { return ''; }
		return String(pText)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = DocuserveTopBarUserView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":68}]},{},[70])(70)
});

